"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconList = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["height", "onClick", "size", "style", "width", "className"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /* eslint-disable */ // Generated by gulp svg-icon - do not modify manually
var iconList = exports.iconList = ['AED', 'angle-double-left', 'angle-double-right', 'angle-down', 'angle-down-alt', 'angle-left', 'angle-left-alt', 'angle-right', 'angle-right-alt', 'angle-up', 'angle-up-alt', 'arrow-down', 'arrow-from-left', 'arrow-from-right', 'arrow-left', 'arrow-left-alt', 'arrow-right', 'arrow-right-alt', 'arrow-right-arrow-left', 'arrow-rotate-left', 'arrow-up', 'atm', 'attach', 'AUD', 'avatar', 'AZN', 'bag', 'bank', 'bell', 'bell-alt', 'BGN', 'BHD', 'binoculars', 'birthday-cake', 'book', 'briefcase', 'browser', 'CAD', 'calculator', 'calendar', 'calendar-alt', 'camera', 'camera-alt', 'card', 'caret-left', 'caret-right', 'chain', 'chart', 'chat', 'check', 'check-alt', 'check-circle', 'CHF', 'clipboard', 'clock', 'clock-alt', 'clock-rotate-left', 'clone', 'close', 'close-alt', 'close-circle', 'CNH', 'CNY', 'code', 'code-alt', 'comment-sms', 'compass', 'compress', 'csv', 'cup', 'customer', 'CZK', 'dashboard', 'dashboard-alt', 'desktop', 'dev-avatar', 'divide', 'DKK', 'document-plus', 'documents', 'documents-alt', 'download', 'DZD', 'edit', 'edit-alt', 'ellipsis', 'ellipsis-h', 'ellipsis-v-alt', 'envelope-open', 'error', 'EUR', 'excel', 'exclamation', 'exit', 'expand', 'expand-left', 'expand-right', 'external-link', 'eye', 'eye-alt', 'eye-slash', 'factory', 'file-lines', 'filter', 'filter-close', 'flag', 'flag-solid', 'flexible-alt', 'folder', 'frown', 'GBP', 'gift', 'globe', 'graduation-cap', 'grip-vertical', 'headphones', 'heart', 'heart-f', 'help', 'HKD', 'home', 'home-alt', 'home-f', 'HUF', 'IEP', 'IQD', 'identity', 'inbox', 'info', 'info-circle', 'JOD', 'JPY', 'kiosk', 'KWD', 'KZT', 'lightbulb', 'list', 'lock', 'lock-alt', 'lock-open', 'lock-open-alt', 'lock-open-check', 'loveseat', 'LYD', 'MAD', 'mail', 'mail-alt', 'map-marker-alt', 'mars', 'megaphone-alt', 'meh', 'menu', 'menu-arrow', 'menu-favorites', 'menu-related-actions', 'menu-sik-kullanilanlar', 'menu-tum-islemler', 'menu-yardimci-uygulamalar', 'microphone', 'microphone-slash', 'minus', 'minus-alt', 'mobil', 'money', 'money-bill', 'monitor-share', 'mouse-pointer', 'MYR', 'newspaper-alt', 'NGN', 'NLG', 'no-data', 'NOK', 'office', 'paper', 'paperclip', 'pause', 'pdf', 'phone', 'phone-alt', 'phone-arrow-down-left', 'phone-arrow-up-right', 'phone-emergency-alt', 'phone-hangup', 'phone-pause', 'phone-xmark', 'picture', 'pill-alt', 'pin', 'play', 'play-circle', 'PLN', 'plus', 'plus-alt', 'power-off', 'print', 'profile', 'ptt', 'QAR', 'qrcode', 'question', 'question-comment-alt', 'random-alt', 'rank-alt', 'rates', 'refresh', 'rings-wedding-alt', 'RON', 'roof-alt', 'round', 'round-plus', 'RUB', 'SAR', 'screen', 'search', 'search-alt', 'SEK', 'settings', 'SGD', 'share', 'share-nodes', 'shield', 'shop', 'signature', 'slider-h', 'sliders-h', 'smiley', 'sort', 'sort-alt', 'sort-down', 'sort-up', 'spin', 'star', 'success', 'sun', 'swap-right', 'tachometer-average', 'tachometer-fast', 'tachometer-fastest', 'tachometer-slow', 'thumb-tack', 'thumb-tack-f', 'thumbs-down', 'thumbs-up', 'ticket', 'TR', 'trash', 'trash-alt', 'turn-left', 'upload', 'USD', 'usd-circle', 'user', 'user-alt', 'user-arrow-down', 'user-arrow-up', 'user-f', 'user-friends', 'user-friends-f', 'user-plus', 'users-f', 'venus', 'video', 'video-slash', 'wallet', 'warning', 'warning-circle', 'wheelchair', 'XAU', 'XPT', 'YER', 'ykb-alt', 'ZAR'];
var Icon = exports.default = /*#__PURE__*/function (_Component) {
  function Icon() {
    (0, _classCallCheck2.default)(this, Icon);
    return _callSuper(this, Icon, arguments);
  }
  (0, _inherits2.default)(Icon, _Component);
  return (0, _createClass2.default)(Icon, [{
    key: "render",
    value: function render() {
      return this.getIcon(this.props.kind);
    }
  }, {
    key: "getIcon",
    value: function getIcon(kind) {
      var _this$props = this.props,
        height = _this$props.height,
        onClick = _this$props.onClick,
        size = _this$props.size,
        style = _this$props.style,
        width = _this$props.width,
        className = _this$props.className,
        rest = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      switch (kind) {
        default:
          return null;
        case 'AED':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_4901_807)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M22.588 4H1.412C.632 4 0 4.716 0 5.6v12.8c0 .884.632 1.6 1.412 1.6h21.176c.78 0 1.412-.716 1.412-1.6V5.6c0-.884-.632-1.6-1.412-1.6z",
            fill: "#000"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 15H0v5h24v-5z",
            fill: "#000"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 4H0v5h24V4z",
            fill: "#00732F"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 9H0v6h24V9z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M6 4H0v16h6V4z",
            fill: "#F00"
          })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_4901_807"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "24",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'angle-double-left':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "angle-double-left"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4569",
            d: "M6.4 12l5.3-5.3c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-6 6c-.4.4-.4 1 0 1.4l6 6c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4L6.4 12z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4570",
            d: "M14.4 12l5.3-5.3c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-6 6c-.4.4-.4 1 0 1.4l6 6c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4L14.4 12z"
          }));
        case 'angle-double-right':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "angle-double-right"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4264",
            d: "M19.7 11.3l-6-6c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l5.3 5.3-5.3 5.3c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l6-6c.4-.4.4-1 0-1.4z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4265",
            d: "M11.7 11.3l-6-6c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4L9.6 12l-5.3 5.3c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l6-6c.4-.4.4-1 0-1.4z"
          }));
        case 'angle-down':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "angel-down"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4264",
            d: "M12 16c-.3 0-.5-.1-.7-.3l-6-6c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l5.3 5.3 5.3-5.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-6 6c-.2.2-.4.3-.7.3z"
          }));
        case 'angle-down-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "angle-down-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "angle-down-alt-2",
            d: "M12 16.5L4.5 8.9l1.4-1.4 6.1 6.2 6.1-6.2 1.4 1.4-7.5 7.6z"
          }));
        case 'angle-left':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "angle-left"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10837",
            transform: "translate(-946.5 -609.806)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4564",
            d: "M961.5 628.8c-.3 0-.5-.1-.7-.3l-6-6c-.4-.4-.4-1 0-1.4l6-6c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-5.3 5.3 5.3 5.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3z"
          })));
        case 'angle-left-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "angle-left-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "angle-left-alt-2",
            d: "M7.5 12L15 4.5l1.4 1.4-6.1 6.1 6.2 6.1-1.4 1.4L7.5 12z"
          }));
        case 'angle-right':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "angle-right"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4266",
            d: "M9 19c-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l5.3-5.3-5.3-5.3c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l6 6c.4.4.4 1 0 1.4l-6 6c-.2.2-.4.3-.7.3z"
          }));
        case 'angle-right-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "angle-right-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "angle-right-alt-2",
            d: "M17.5 12L10 19.5l-1.4-1.4 6.2-6.1-6.3-6.1 1.4-1.4 7.6 7.5z"
          }));
        case 'angle-up':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "angle-up"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4264",
            d: "M12 8c.3 0 .5.1.7.3l6 6c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0L12 10.4l-5.3 5.3c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l6-6c.2-.2.4-.3.7-.3z"
          }));
        case 'angle-up-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "angle-up-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "angle-up-alt-2",
            d: "M12 7.5l7.5 7.5-1.4 1.4-6.1-6.1-6.1 6.2-1.4-1.4L12 7.5z"
          }));
        case 'arrow-down':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "arrow-down"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4658",
            d: "M11.6 20.9c.4.2.8.1 1.1-.2l7-7c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0L13 17.6V4c0-.6-.4-1-1-1s-1 .4-1 1v13.6l-5.3-5.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l7 7c.1.1.2.2.3.2z"
          }));
        case 'arrow-from-left':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "arrow-from-left"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15797",
            transform: "translate(-684 -1595)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8465",
            d: "M704.9 1607.4c.2-.4.1-.8-.2-1.1l-6-6c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l4.3 4.3H692c-.6 0-1 .4-1 1s.4 1 1 1h9.6l-4.3 4.3c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l6-6c.1-.1.2-.2.2-.3"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8466",
            d: "M688 1600c-.5 0-1 .4-1 .9v12.3c0 .5.5.9 1 .9s1-.4 1-.9v-12.3c0-.5-.5-.9-1-.9"
          })));
        case 'arrow-from-right':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "arrow-from-right"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15796",
            transform: "translate(-684.001 -1569)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8463",
            d: "M700 1580h-9.6l4.3-4.3c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-6 6c-.4.4-.4 1 0 1.4l6 6c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4l-4.3-4.3h9.6c.6 0 1-.4 1-1s-.4-1-1-1"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8464",
            d: "M704 1574c-.5 0-1 .4-1 .9v12.3c.1.6.6.9 1.1.9.5-.1.8-.4.9-.9v-12.3c0-.5-.5-.9-1-.9"
          })));
        case 'arrow-left':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "arrow-left"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4659",
            d: "M4.1 11.6c-.2.4-.1.8.2 1.1l6 6c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4L7.4 13H19c.6 0 1-.4 1-1s-.4-1-1-1H7.4l4.3-4.3c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-6 6c-.1.1-.2.2-.2.3z"
          }));
        case 'arrow-left-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "arrow-left-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "arrow-left-alt-2",
            d: "M19.7 11H8.1l5.3-5.3L12 4.3 4.3 12l7.7 7.7 1.4-1.4L8.1 13h11.6v-2z"
          }));
        case 'arrow-right':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "arrow-right"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4658",
            d: "M19.9 12.4c.2-.4.1-.8-.2-1.1l-6-6c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l4.3 4.3H5c-.6 0-1 .4-1 1s.4 1 1 1h11.6l-4.3 4.3c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l6-6c.1-.1.2-.2.2-.3z"
          }));
        case 'arrow-right-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "arrow-right-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "arrow-right-alt-2",
            d: "M4 13h12.4l-5.6 5.5 1.5 1.5 8.2-8-8.2-8-1.5 1.5 5.6 5.5H4v2z"
          }));
        case 'arrow-right-arrow-left':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "Layer_1"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M4 10h16c.4 0 .8-.2.9-.6.2-.4.1-.8-.2-1.1l-6-6c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4L17.6 8H4c-.5 0-1 .4-1 1s.5 1 1 1zM20 14H4c-.4 0-.8.2-.9.6-.2.4-.1.8.2 1.1l6 6c.2.2.4.3.7.3.3 0 .5-.1.7-.3.4-.4.4-1 0-1.4L6.4 16H20c.6 0 1-.5 1-1s-.5-1-1-1z"
          }));
        case 'arrow-rotate-left':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M12.842 1.25c-2.171 0-4.253.653-6.036 1.89a1.01 1.01 0 0 0-.259 1.397.998.998 0 0 0 1.385.261 8.537 8.537 0 0 1 4.9-1.538c4.771 0 8.656 3.92 8.656 8.735 0 4.815-3.885 8.735-8.656 8.735-3.476 0-6.603-2.131-7.948-5.297l1.255.582a.999.999 0 0 0 1.325-.492c.229-.502.01-1.106-.488-1.337l-3.477-1.608a.999.999 0 0 0-1.324.492L.59 16.578c-.23.503-.01 1.106.488 1.337a1.005 1.005 0 0 0 1.325-.493l.607-1.326c1.624 3.97 5.508 6.654 9.841 6.654 5.867 0 10.648-4.815 10.648-10.745 0-5.93-4.781-10.755-10.658-10.755z",
            fill: "#000"
          }));
        case 'arrow-up':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "arrow-up"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4659",
            d: "M12.4 3.1c-.4-.2-.8-.1-1.1.2l-7 7c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0L11 6.4V20c0 .6.4 1 1 1s1-.4 1-1V6.4l5.3 5.3c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4l-7-7c-.1-.1-.2-.2-.3-.2z"
          }));
        case 'atm':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "atm"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15702",
            transform: "translate(-1301.5 -378.807)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8368",
            d: "M1323.5 386.8h-20c-.6 0-1 .4-1 1s.4 1 1 1h2v12c0 .6.4 1 1 1h14c.6 0 1-.4 1-1v-12h2c.6 0 1-.4 1-1s-.4-1-1-1zm-16 2h8v11h-8v-11zm12 11h-2v-11h2v11z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8369",
            d: "M1310.5 393.8c-.6 0-1 .4-1 1v2.2c0 .6.4 1 1 1s1-.4 1-1v-2.2c0-.5-.4-1-1-1z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8370",
            d: "M1307.2 383.9h1.6l.2.9h1.4l-1.6-5h-1.7l-1.6 5h1.4l.3-.9zm.6-2.7c.1-.3.1-.5.1-.6 0 .1.1.3.1.6.1.3.1.5.2.7l.2.8h-1c.3-.7.4-1.2.4-1.5z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8371",
            d: "M1311.8 384.8h1.3v-3.9h1.2v-1.1h-3.7v1.1h1.2v3.9z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8372",
            d: "M1316.1 382.6c0-.3 0-.8-.1-1.4l1 3.6h1.2l1-3.6v3.6h1.2v-5h-1.7l-1 3.5-1-3.5h-1.7v5h1.2l-.1-2.2z"
          })));
        case 'attach':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M20.3 10.9l-6.5-6.7c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l6.5 6.6c1.5 1.5 1.5 4 0 5.6-.7.7-1.7 1.1-2.7 1.1s-2-.4-2.7-1.1L4.7 8.9c-.9-.9-.9-2.3 0-3.2.8-.9 2.3-.9 3.1 0l8.4 8.5c.3.3.3.7 0 .9-.2.2-.6.2-.9 0L7 6.6c-.4-.4-1-.4-1.4 0-.5.4-.5 1-.1 1.4l8.4 8.5c.5.5 1.2.8 1.9.8s1.4-.3 1.9-.8c1-1 1-2.7 0-3.7L9.2 4.3C8.4 3.4 7.4 3 6.2 3c-1.1 0-2.2.4-3 1.3-1.6 1.7-1.6 4.4 0 6.1l8.7 8.9C13 20.4 14.5 21 16 21s3-.6 4.1-1.7c2.4-2.3 2.5-6.1.2-8.4z"
          }));
        case 'AUD':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_4901_825)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M0 4h24v16H0V4z",
            fill: "#00008B"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M6 12.181l.346 1.099 1.059-.413-.629.966.982.588-1.13.098.156 1.148-.784-.84-.784.84.156-1.148-1.13-.098.982-.588-.629-.966 1.06.413L6 12.181zM18 14.162l.162.518.509-.189-.297.455.459.28-.536.049.077.546-.374-.399-.374.399.077-.546-.536-.049.459-.28-.297-.455.509.189.162-.518zM15 9.318l.162.525.509-.196-.297.455.459.28-.537.049.078.546-.374-.399-.374.399.078-.546-.537-.049.459-.28-.297-.455.509.196.162-.525zM18 6l.162.525.509-.196-.297.462.459.28-.536.049.077.546L18 7.267l-.374.399.077-.546-.536-.049.459-.28-.297-.462.509.196L18 6zM20.668 8.499l.163.525.508-.196-.304.462.466.28-.536.049.07.546-.367-.399-.374.399.078-.546-.544-.049.466-.28-.296-.462.5.196.17-.525zM19.2 10.956l.134.322.339.028-.261.231.085.343-.297-.189-.296.189.084-.343-.26-.231.338-.028.134-.322zM4.998 4h1.997v2.037h4.998v2.037H6.995v2.037H4.998V8.074H0V6.037h4.998V4z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M0 4h1.341L12 9.432v.686h-1.341L0 4.686V4z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M12 4h-1.341L0 9.432v.686h1.341L12 4.686V4z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M5.4 4h1.2v2.45H12v1.225H6.6v2.45H5.4v-2.45H0V6.45h5.4V4z",
            fill: "#F00"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M0 4l4.002 2.037h-.896L0 4.455V4zm12 0h-.896L7.1 6.037h.897L12 4zM12 10.118L7.998 8.081h.896L12 9.663v.455zm-12 0h.896L4.9 8.081h-.897L0 10.118z",
            fill: "#F00"
          })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_4901_825"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "24",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'avatar':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M12 16.2c-3.42 0-6.3 2.22-7.38 5.28C6.66 23.04 9.18 24 12 24c2.76 0 5.34-.96 7.38-2.52-1.08-3.06-3.96-5.28-7.38-5.28zM12 4.8c-2.64 0-4.8 2.16-4.8 4.8s2.16 4.8 4.8 4.8 4.8-2.16 4.8-4.8-2.16-4.8-4.8-4.8z"
          }));
        case 'AZN':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_27784_1303)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 4H0v16h24V4z",
            fill: "#509E2F"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 4H0v11h24V4z",
            fill: "#EF3340"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 4H0v5h24V4z",
            fill: "#00B5E2"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M11.2 14.4a2.4 2.4 0 1 0 0-4.8 2.4 2.4 0 0 0 0 4.8z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M11.733 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
            fill: "#EF3340"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M13.867 10.667l.255.717.688-.327-.327.688.717.255-.717.255.326.688-.687-.327-.255.717-.256-.717-.687.327.327-.688-.718-.255.718-.255-.327-.688.688.327.255-.717z",
            fill: "#fff"
          })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_27784_1303"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "24",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'bag':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "bag"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_22097",
            transform: "translate(-1276 -1610)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_9401",
            d: "M1280 1618h17c.5 0 1 .4 1 .9l1 14c0 .6-.4 1-.9 1.1H1279c-.6 0-1-.4-1-1v-.1l1-14c0-.5.5-.9 1-.9zm16.1 2H1281l-.9 12h16.9l-.9-12z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Subtraction_1",
            d: "M1285 1618.5h-2v-3c0-3 2.5-5.5 5.5-5.5s5.5 2.5 5.5 5.5v3h-2v-3c0-1.9-1.6-3.5-3.5-3.5s-3.5 1.6-3.5 3.5v3z"
          })));
        case 'bank':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "Layer_1"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 25.1 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "bank",
            transform: "translate(.57)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Union_29",
            d: "M1 23c-.6 0-1-.4-1-1s.4-1 1-1h22c.6 0 1 .4 1 1s-.4 1-1 1H1zm1-3c-.6 0-1-.4-1-1s.4-1 1-1h1v-7c-.6 0-1-.4-1-1V8.6l-.5.3C1 9.1.4 8.9.1 8.5-.1 8 0 7.4.5 7.1l11-6c.3-.2.7-.2 1 0l11 6c.5.3.6.9.4 1.4-.3.5-.9.6-1.4.4l-.5-.3V10c0 .6-.4 1-1 1v7h1c.6 0 1 .4 1 1s-.4 1-1 1H2zm16-2h1v-7h-1v7zm-3.5 0H16v-7h-1.5v7zm-3 0h1v-7h-1v7zM8 18h1.5v-7H8v7zm-3 0h1v-7H5v7zM4 7.5V9h16V7.5l-8-4.4-8 4.4z"
          })));
        case 'bell':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "bell"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "bell-2",
            d: "M10 21h4c0 1.1-.9 2-2 2s-2-.9-2-2zm-7-1c-.6 0-1-.4-1-1v-3c0-.4.2-.7.6-.9l1.4-.7V9c0-4.4 3.6-8 8-8s8 3.6 8 8v5.4l1.4.7c.3.2.6.5.6.9v3c0 .6-.4 1-1 1H3zM6 9v6c0 .4-.2.7-.6.9l-1.4.7V18h16v-1.4l-1.4-.7c-.4-.2-.6-.5-.6-.9V9c0-3.3-2.7-6-6-6S6 5.7 6 9z"
          }));
        case 'bell-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "bell-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "bell-alt-2",
            d: "M10 21h4c0 1.1-.9 2-2 2s-2-.9-2-2zm-8-1v-2h1c.5 0 1-.4 1-.9V9c0-2.1.9-4.2 2.4-5.7S10 .9 12.2 1c4.4.2 7.8 3.9 7.8 8.3V17c0 .5.4 1 .9 1H22v2H2zM7.8 4.7C6.7 5.9 6 7.4 6 9v8c0 .3-.1.7-.2 1h12.4c-.1-.3-.2-.7-.2-1V9.3c.1-3.3-2.5-6.1-5.8-6.3H12c-1.6 0-3.1.6-4.2 1.7z"
          }));
        case 'BGN':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_27784_1174)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 4H0v16h24V4z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 9.333H0V20h24V9.333z",
            fill: "#00966E"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 14.667H0V20h24v-5.333z",
            fill: "#D62612"
          })), /*#__PURE__*/_react.default.createElement("rect", {
            x: ".5",
            y: "4.5",
            width: "23",
            height: "15",
            rx: ".5",
            stroke: "#F0F0F0"
          }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_27784_1174"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "24",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'BHD':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_27784_1188)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M0 4h24v16H0V4z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M6 4h18v16H6l3.6-1.6L6 16.8l3.6-1.6L6 13.6 9.6 12 6 10.4l3.6-1.6L6 7.2l3.6-1.6L6 4z",
            fill: "#DA291C"
          })), /*#__PURE__*/_react.default.createElement("rect", {
            x: ".5",
            y: "4.5",
            width: "23",
            height: "15",
            rx: ".5",
            stroke: "#F0F0F0"
          }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_27784_1188"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "24",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'binoculars':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M22.97 20.175c0-.06.03-.131.03-.192 0-.03-.01-.05-.01-.08v-.05l-1-7.541s-.02-.04-.02-.07c-.1-.855-.82-1.54-1.97-1.931V2.89c0-.061-.03-.121-.04-.182-.18-1.035-1.49-1.699-3.46-1.699-2.13 0-3.5.764-3.5 1.95v2.957h-2V2.95C11 1.764 9.63 1 7.5 1c-1.97 0-3.28.664-3.46 1.7-.01.06-.04.12-.04.18v7.42c-1.15.393-1.87 1.087-1.98 1.941 0 .02-.02.04-.02.07l-1 7.532v.05c0 .03-.01.05-.01.08 0 .07.02.131.03.202 0 .03 0 .06.01.09C1.26 21.834 3.3 23 5.99 23c2.85 0 5-1.297 5-3.017V11.94h2v8.043c0 1.72 2.15 3.017 5 3.017 2.69 0 4.73-1.156 4.96-2.735 0-.03 0-.06.01-.09h.01zM15 3.252c.25-.11.76-.241 1.5-.241s1.26.14 1.5.251v2.645h-3V3.252zm-6 0v2.645H6V3.252c.24-.11.75-.251 1.5-.251s1.25.14 1.5.241v.01zM6 7.908h12v2.01h-.48-3.5-3.98H6.5c-.17 0-.33.02-.49.02v-2.04l-.01.01zm0 13.071c-1.9 0-2.96-.724-2.99-.985v-.04c.07-.272 1.12-.976 2.99-.976s3 .754 3 1.005c0 .252-1.06 1.006-3 1.006v-.01zm3-3.439c-.83-.362-1.85-.583-3-.583-.99 0-1.89.16-2.65.442l.64-4.826v-.01-.01c.19-.191 1.02-.613 2.51-.613h2.51v5.6H9zm8.52-5.61c1.47 0 2.29.422 2.48.613v.02l.64 4.836c-.76-.281-1.66-.442-2.65-.442-1.15 0-2.17.221-3 .583v-5.61h2.53zm.48 9.049c-1.94 0-3-.754-3-1.005 0-.252 1.06-1.006 3-1.006s2.92.704 2.99.975v.05c-.03.262-1.08.986-2.99.986z",
            fill: "#000"
          }));
        case 'birthday-cake':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "Layer_1"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M4 20v-3.3c.5.2 1.2.3 2 .3 1.4 0 2.4-.4 3-.8.6.4 1.6.8 3 .8s2.4-.4 3-.8c.6.4 1.6.8 3 .8.8 0 1.5-.1 2-.3V20H4zm16-8v2.5c-.4.2-1 .5-2 .5-1.5 0-2.3-.7-2.3-.7-.4-.4-.9-.4-1.3-.1h-.1s-.8.7-2.3.7c-1.5 0-2.3-.7-2.3-.7-.4-.4-.9-.4-1.3-.1h-.1s-.8.7-2.3.7c-1 0-1.6-.3-2-.5V12h16zm1-2h-2V6c0-.6-.4-1-1-1s-1 .4-1 1v4h-4V6c0-.6-.4-1-1-1s-1 .4-1 1v4H7V6c0-.6-.4-1-1-1s-1 .4-1 1v4H3c-.6 0-1 .4-1 1v10c0 .6.4 1 1 1h18c.6 0 1-.4 1-1V11c0-.6-.4-1-1-1zM6 4h.2c.1 0 .1 0 .2-.1.1 0 .1-.1.2-.1l.1-.1c.2-.2.3-.4.3-.7 0-.3-.1-.5-.3-.7l-.1-.1c-.1 0-.1-.1-.2-.1-.1-.1-.1-.1-.2-.1-.3-.1-.7 0-.9.3-.2.2-.3.4-.3.7 0 .3.1.5.3.7.2.2.4.3.7.3zM12 4c.1 0 .3 0 .4-.1.1-.1.2-.1.3-.2.2-.2.3-.4.3-.7 0-.1 0-.3-.1-.4-.1-.1-.1-.2-.2-.3l-.1-.1c-.1 0-.1-.1-.2-.1-.4-.2-.8-.1-1.1.2-.1.1-.2.2-.2.3-.1.1-.1.3-.1.4 0 .3.1.5.3.7.2.2.4.3.7.3zM18 4c.3 0 .5-.1.7-.3.2-.2.3-.4.3-.7 0-.3-.1-.5-.3-.7-.3-.3-.7-.4-1.1-.2-.1.1-.2.1-.3.2-.2.2-.3.4-.3.7 0 .3.1.5.3.7.2.2.4.3.7.3z"
          }));
        case 'book':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "book"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4672",
            d: "M20.5 3.2c-.3-.2-.7-.2-1-.1L12 6.7 4.4 3.1c-.5-.2-1.1 0-1.3.5-.1.1-.1.2-.1.4v12.3c0 .4.2.7.6.9l7.6 3.7c.2.1.5.2.8.2.3 0 .6-.1.9-.2l7.6-3.7c.3-.2.6-.5.6-.9V4c-.1-.3-.3-.7-.6-.8zM5 5.6l6 2.9v10.1l-6-2.9V5.6zm14 10l-6 2.9v-10l6-2.9v10z"
          }));
        case 'briefcase':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "briefcase"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4689",
            d: "M21 6h-4V4c0-1.7-1.3-3-3-3h-4C8.3 1 7 2.3 7 4v2H3c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM9 4c0-.6.4-1 1-1h4c.6 0 1 .4 1 1v2H9V4zm12 4v3H3V8h18zm-10 5h2v1h-2v-1zm-8 8v-8h6v2c0 .6.4 1 1 1h4c.6 0 1-.4 1-1v-2h6v8H3z"
          }));
        case 'browser':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "browser"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15703",
            transform: "translate(-1291.5 -384.807)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8359",
            d: "M1313.5 386.8h-20c-.6 0-1 .4-1 1v18c0 .6.4 1 1 1h20c.6 0 1-.4 1-1v-18c0-.5-.4-1-1-1zm-1 2v2h-18v-2h18zm-18 16v-12h18v12h-18z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8360",
            d: "M1301.2 398.3c-.1.6-.2 1.1-.2 1.3 0-.2-.1-.5-.1-.9s-.1-.7-.2-1l-.4-1.9h-1.1l-.4 1.9c-.1.3-.1.6-.2 1s-.1.7-.1.9c0-.3-.1-.8-.2-1.3l-.5-2.5h-1.2l1.1 5h1.5c.3-1.3.4-2.1.5-2.2 0-.2.1-.4.1-.6s.1-.4.1-.6c0 .2.1.4.1.7 0 .3.1.5.1.5l.4 2.2h1.5l1.1-5h-1.2l-.7 2.5z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8361",
            d: "M1303.5 400.8h2.7v-1.1h-1.5v-.9h1.4v-1.1h-1.4v-.8h1.5v-1.1h-2.7v5z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8362",
            d: "M1309.7 398.2c.2-.1.4-.2.5-.4.1-.2.2-.5.2-.7 0-.4-.1-.7-.4-.9-.4-.2-.9-.3-1.4-.3h-1.6v5h1.8c.5 0 .9-.1 1.3-.4.5-.5.6-1.2.3-1.8-.2-.3-.5-.5-.7-.5zm-1.5-1.4h.3c.4 0 .6.1.6.4 0 .1 0 .3-.1.4-.1.1-.3.1-.4.1h-.4v-.9zm.5 3h-.4v-1h.4c.2 0 .3 0 .4.1.1.1.2.2.2.4-.1.3-.3.5-.6.5z"
          })));
        case 'CAD':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_4901_826)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M0 4v16h24V4H0z",
            fill: "#F00"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M19 4H5v16h14V4z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M11.95 6l-.903 1.785c-.106.196-.29.175-.473.07l-.656-.357.487 2.744c.106.504-.226.504-.388.287L8.873 9.171l-.184.686a.218.218 0 0 1-.254.161l-1.447-.322.381 1.463c.085.322.142.462-.084.546l-.516.259 2.485 2.142a.354.354 0 0 1 .113.357l-.219.756c.854-.105 1.624-.196 2.478-.301.078 0 .205.07.205.161l-.113 2.772h.416l-.063-2.772c0-.091.113-.168.19-.168.854.105 1.624.196 2.478.301l-.219-.756a.35.35 0 0 1 .113-.357l2.485-2.142-.516-.259c-.226-.084-.162-.224-.084-.546l.38-1.463-1.446.322a.218.218 0 0 1-.254-.161l-.184-.686-1.143 1.358c-.163.217-.495.217-.389-.287l.487-2.744-.656.357c-.184.112-.367.126-.473-.07",
            fill: "#F00"
          })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_4901_826"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "24",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'calculator':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "Layer_1"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 25"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "calculator",
            transform: "translate(0 .5)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Union_32",
            d: "M6 24c-1.7 0-3-1.3-3-3V3c0-1.7 1.3-3 3-3h12c1.7 0 3 1.3 3 3v18c0 1.7-1.3 3-3 3H6zm-1-3c0 .6.4 1 1 1h12c.6 0 1-.4 1-1V8H5v13zM5 3v3h14V3c0-.6-.4-1-1-1H6c-.6 0-1 .4-1 1zm10 16v-4c0-.6.4-1 1-1s1 .4 1 1v4c0 .6-.4 1-1 1s-1-.4-1-1zm-4 0c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1-1-.4-1-1zm-4 0c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1-1-.4-1-1zm4-4c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1-1-.4-1-1zm-4 0c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1-1-.4-1-1zm8-4c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1-1-.4-1-1zm-4 0c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1-1-.4-1-1zm-4 0c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1-1-.4-1-1z"
          })));
        case 'calendar':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "calendar"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4656",
            d: "M21 4h-3V3c0-.6-.4-1-1-1s-1 .4-1 1v1H8V3c0-.6-.4-1-1-1s-1 .4-1 1v1H3c-.6 0-1 .4-1 1v16c0 .6.4 1 1 1h18c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1zm-1 16H4v-9h16v9zm0-11H4V6h2v.5c0 .6.4 1 1 1s1-.4 1-1V6h8v.5c0 .6.4 1 1 1s1-.4 1-1V6h2v3z"
          }));
        case 'calendar-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "calendar-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "calendar-alt-2",
            d: "M2 22V4h5V2h2v2h6V2h2v2h5v18H2zm2-2h16V10H4v10zM4 8h16V6H4v2zm7 10v-2h2v2h-2zm-4 0v-2h2v2H7zm8-4v-2h2v2h-2zm-4 0v-2h2v2h-2zm-4 0v-2h2v2H7z"
          }));
        case 'camera':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "camera"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Union_19",
            d: "M3 21c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2h4.4l.7-1.4c.2-.4.5-.6.9-.6h6c.4 0 .7.2.9.6l.7 1.4H21c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H3zm0-2h18V7h-5c-.4 0-.7-.2-.9-.6L14.4 5H9.6l-.7 1.4c-.2.4-.5.6-.9.6H3v12zm5-6c0-2.2 1.8-4 4-4s4 1.8 4 4-1.8 4-4 4-4-1.8-4-4zm2 0c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2z"
          }));
        case 'camera-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "camera-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4356",
            d: "M23 20H1V5h5.6l2-2h6.8l2 2H23v15zM3 18h18V7h-4.4l-2-2H9.4l-2 2H3v11z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4357",
            d: "M12 16c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
          }));
        case 'card':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "card"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10844",
            transform: "translate(-972.5 -583.806)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4542",
            d: "M978.5 599.8h12c.6 0 1-.4 1-1s-.4-1-1-1h-12c-.6 0-1 .4-1 1s.4 1 1 1z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4543",
            d: "M994.5 586.8h-20c-.6 0-1 .4-1 1v16c0 .6.4 1 1 1h20c.6 0 1-.4 1-1v-16c0-.5-.4-1-1-1zm-1 16h-18v-14h18v14z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Rectangle_9763",
            d: "M988.5 591.8h2c.6 0 1 .4 1 1v2c0 .6-.4 1-1 1h-2c-.6 0-1-.4-1-1v-2c0-.5.4-1 1-1z"
          })));
        case 'caret-left':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "caret-left"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10856",
            transform: "rotate(180 563.25 316.903)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4597",
            d: "M1108.5 611.8l12 10-12 10v-20z"
          })));
        case 'caret-right':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "caret-right"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10855",
            transform: "translate(-1102.5 -609.806)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4597",
            d: "M1108.5 611.8l12 10-12 10v-20z"
          })));
        case 'chain':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "chain"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Union_16",
            d: "M4.1 19.7c-.9-.9-1.3-2-1.3-3.3 0-1.2.5-2.4 1.3-3.3L7.3 10c1.8-1.8 4.7-1.8 6.5 0 .4.4.4 1 0 1.4-.4.4-1 .4-1.4 0-1-1-2.7-1-3.7 0l-3.2 3.2c-.5.5-.8 1.1-.8 1.8s.3 1.4.8 1.8c1 1 2.7 1 3.7 0l1.7-1.7c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-1.7 1.7c-.9.9-2 1.3-3.2 1.3-1.3.1-2.5-.3-3.3-1.2zm5.6-5.6c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0 1 1 2.6 1 3.7 0L18 9.5c1-1 1-2.7 0-3.7s-2.7-1-3.7 0l-2 2c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l2-2c1.8-1.8 4.7-1.8 6.5 0 1.8 1.8 1.8 4.7 0 6.5l-3.2 3.2c-.9.9-2 1.3-3.3 1.3-1.1 0-2.3-.5-3.2-1.3z"
          }));
        case 'chart':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "clone"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M5 10H1c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1h4c.6 0 1 .4 1 1v8c0 .6-.4 1-1 1zM2 8h2V2H2v6z",
            transform: "translate(1 13)",
            id: "Rectangle_12652"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M5 17H1c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1h4c.6 0 1 .4 1 1v15c0 .6-.4 1-1 1zm-3-2h2V2H2v13z",
            transform: "translate(9 6)",
            id: "Rectangle_12653"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M5 22H1c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1h4c.6 0 1 .4 1 1v20c0 .6-.4 1-1 1zm-3-2h2V2H2v18z",
            transform: "translate(17 1)",
            id: "Rectangle_12654"
          }));
        case 'chat':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "chat"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10694",
            transform: "translate(-1095.5 -407.806)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4478",
            d: "M1113.5 430.8c-.3 0-.5-.1-.7-.3l-3.7-3.7h-11.6c-.6 0-1-.4-1-1v-16c0-.6.4-1 1-1h20c.6 0 1 .4 1 1v16c0 .6-.4 1-1 1h-3v3c0 .6-.4 1-1 1zm-15-6h11c.3 0 .5.1.7.3l2.3 2.3v-1.6c0-.6.4-1 1-1h3v-14h-18v14z"
          })));
        case 'check':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "check"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "check-2",
            d: "M20.9 5.9c-.2-.2-.6-.4-.9-.4-.3 0-.7.1-.9.4l-9.1 9-5.1-5c-.3-.2-.6-.3-.9-.4-.3 0-.7.1-.9.4-.5.5-.5 1.3 0 1.8l6 5.9c.2.2.6.4.9.4.3 0 .7-.1.9-.4l10-9.9c.5-.5.5-1.3 0-1.8z"
          }));
        case 'check-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "check-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "check-alt-2",
            d: "M10.4 18l-6.9-7.2L5 9.2l5.5 5.7L19 6l1.5 1.5L10.4 18z"
          }));
        case 'check-circle':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "check-circle"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4666",
            d: "M11.9 1c-6 0-11 4.9-11 10.9C.9 18 5.7 23 11.8 23s11-4.9 11.1-10.9V12c0-6.1-4.9-11-11-11zm5.2 8.7l-6 6c-.4.4-1 .4-1.4 0l-3-3c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l2.3 2.3 5.3-5.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4z"
          }));
        case 'CHF':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_4901_827)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 4H0v16h24V4z",
            fill: "#F00"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M16.398 10.684H7.624v2.625h8.774v-2.625z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M13.327 7.625h-2.633v8.75h2.633v-8.75z",
            fill: "#fff"
          })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_4901_827"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "24",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'clipboard':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "clipboard",
            xmlnsXlink: "http://www.w3.org/1999/xlink"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            transform: "translate(3 1)",
            id: "Group_15779"
          }, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("path", {
            id: "SVGID_1_",
            d: "M0 0h18v22H0z"
          })), /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "SVGID_00000021100720531449766120000006038859978854041250_"
          }, /*#__PURE__*/_react.default.createElement("use", {
            xlinkHref: "#SVGID_1_",
            overflow: "visible"
          })), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15778",
            clipPath: "url(#SVGID_00000021100720531449766120000006038859978854041250_)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8445",
            d: "M17 2h-4V1c0-.6-.4-1-1-1H6c-.6 0-1 .4-1 1v1H1c-.6 0-1 .4-1 1v18c0 .6.4 1 1 1h16c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1M7 2h4v2H7V2zm9 18H2V4h3v1c0 .6.4 1 1 1h6c.6 0 1-.4 1-1V4h3v16z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8446",
            d: "M13 9H5c-.6 0-1 .4-1 1s.4 1 1 1h8c.6 0 1-.4 1-1s-.4-1-1-1"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8447",
            d: "M9 13H5c-.6 0-1 .4-1 1s.4 1 1 1h4c.6 0 1-.4 1-1s-.4-1-1-1"
          }))));
        case 'clock':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "clock"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4629",
            d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4630",
            d: "M13 11.6V7c0-.6-.4-1-1-1s-1 .4-1 1v5c0 .3.1.5.3.7l3 3c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4L13 11.6z"
          }));
        case 'clock-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "clock-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4365",
            d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4366",
            d: "M13 6h-2v7h5v-2h-3V6z"
          }));
        case 'clock-rotate-left':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M4.29 4.161L4.248 3a1 1 0 0 0-1-.964h-.035a1 1 0 0 0-.963 1.035l.142 3.953a1 1 0 0 0 1.036.967l3.931-.144a1 1 0 1 0-.075-2l-1.893.069A8.992 8.992 0 1 1 12 21a9 9 0 0 1-9-9 1 1 0 1 0-2 0A11 11 0 1 0 12 1a11.049 11.049 0 0 0-7.71 3.161z",
            fill: "#000"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M11.29 12.699l2.992 2.996h.003a.996.996 0 0 0 1.634-1.088 1.001 1.001 0 0 0-.224-.324l-2.7-2.704V7a1 1 0 0 0-1.703-.706 1 1 0 0 0-.292.706v4.994a1 1 0 0 0 .29.706z",
            fill: "#000"
          }));
        case 'clone':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "clone"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Subtraction_2",
            d: "M1 20v-9c0-1.7 1.3-3 3-3h3v2H4c-.6 0-1 .4-1 1v9c0 .6.4 1 1 1h9c.6 0 1-.4 1-1v-3h2v3c0 1.7-1.3 3-3 3H4c-1.7 0-3-1.3-3-3z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Rectangle_12652_-_Outline",
            d: "M10 3c-.6 0-1 .4-1 1v10c0 .6.4 1 1 1h10c.6 0 1-.4 1-1V4c0-.6-.4-1-1-1H10m0-2h10c1.7 0 3 1.3 3 3v10c0 1.7-1.3 3-3 3H10c-1.7 0-3-1.3-3-3V4c0-1.7 1.3-3 3-3z"
          }));
        case 'close':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "close"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "close-2",
            d: "M13.4 12l6.3-6.3c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0L12 10.6 5.7 4.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l6.3 6.3-6.3 6.3c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l6.3-6.3 6.3 6.3c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4L13.4 12z"
          }));
        case 'close-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "close-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "close-alt-2",
            d: "M20 5.5L18.5 4 12 10.5 5.5 4 4 5.5l6.5 6.5L4 18.5 5.5 20l6.5-6.5 6.5 6.5 1.5-1.5-6.5-6.5L20 5.5z"
          }));
        case 'close-circle':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "close-circle"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4670",
            d: "M19.8 4.2C15.5-.1 8.5-.1 4.2 4.2c-4.3 4.3-4.3 11.3 0 15.6 4.3 4.3 11.3 4.3 15.6 0 4.3-4.3 4.3-11.3 0-15.6zm-3.1 11.1c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0L12 13.4l-3.3 3.3c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l3.3-3.3-3.3-3.3c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l3.3 3.3 3.3-3.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L13.4 12l3.3 3.3z"
          }));
        case 'CNH':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M23 4H1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1z",
            fill: "#EC1C24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M2.682 8.48l1.236.924-.46-1.456 1.2-.931h-1.51l-.466-1.428-.458 1.428H.713l1.2.931-.459 1.456 1.228-.924zM7.73 9.362l.402.308-.148-.483.395-.308h-.501l-.149-.469-.155.469H7.08l.395.308-.155.483.41-.308zM6.17 10.783l.268.427.035-.497.48-.14-.459-.182.028-.497-.31.385-.466-.182.254.434-.318.385.487-.133zM7.878 7.199l.5.084-.36-.357.213-.448-.445.224-.353-.343.085.483-.438.231.494.084.085.497.219-.455zM6.501 5.722l.501-.105-.466-.203.029-.497-.325.371-.459-.196.254.427-.324.364.494-.091.26.434.036-.504z",
            fill: "#FFD900"
          }));
        case 'CNY':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_4901_828)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 4H0v16h24V4z",
            fill: "#EC1C24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M2.682 8.48l1.236.924-.46-1.456 1.2-.931h-1.51l-.466-1.428-.458 1.428H.713l1.2.931-.459 1.456 1.228-.924zM7.73 9.362l.402.308-.148-.483.395-.308h-.501l-.149-.469-.155.469H7.08l.395.308-.155.483.41-.308zM6.17 10.783l.268.427.035-.497.48-.14-.459-.182.028-.497-.31.385-.466-.182.254.434-.318.385.487-.133zM7.878 7.199l.5.084-.36-.357.213-.448-.445.224-.353-.343.085.483-.438.231.494.084.085.497.219-.455zM6.501 5.722l.501-.105-.466-.203.029-.497-.325.371-.459-.196.254.427-.324.364.494-.091.26.434.036-.504z",
            fill: "#FFD900"
          })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_4901_828"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "24",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'code':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "code"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4369",
            d: "M18 18c-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l4.3-4.3-4.3-4.3c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l5 5c.4.4.4 1 0 1.4l-5 5c-.2.2-.4.3-.7.3z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4370",
            d: "M6 18c-.3 0-.5-.1-.7-.3l-5-5c-.4-.4-.4-1 0-1.4l5-5c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L2.4 12l4.3 4.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4371",
            d: "M9 20c-.1 0-.3 0-.4-.1-.5-.2-.7-.8-.5-1.3l6-14c.2-.5.8-.7 1.3-.5.5.2.7.8.5 1.3l-6 14c-.1.4-.5.6-.9.6z"
          }));
        case 'code-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "code-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4367",
            d: "M18 18c-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l4.3-4.3-4.3-4.3c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l5 5c.4.4.4 1 0 1.4l-5 5c-.2.2-.4.3-.7.3z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4368",
            d: "M6 18c-.3 0-.5-.1-.7-.3l-5-5c-.4-.4-.4-1 0-1.4l5-5c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L2.4 12l4.3 4.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3z"
          }));
        case 'comment-sms':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "comment-sms"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Union_30",
            d: "M5 23c-1.7 0-3-1.3-3-3V4c0-1.7 1.3-3 3-3h8c1.7 0 3 1.3 3 3v1h4c1.1 0 2 .9 2 2v8c0 1.1-.9 2-2 2h-4v3c0 1.7-1.3 3-3 3H5zM4 4v16c0 .6.4 1 1 1h8c.6 0 1-.4 1-1v-2l-2.4 1.8c-.4.3-1.1.2-1.4-.2-.1-.2-.2-.4-.2-.6v-2H8c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2h6V4c0-.6-.4-1-1-1H5c-.6 0-1 .4-1 1zm4 11h3c.6 0 1 .4 1 1v1l2.4-1.8.1-.1s.1 0 .1-.1c.1 0 .2-.1.4-.1h5V7H8v8zm8-4c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1-1-.4-1-1zm-3 0c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1-1-.4-1-1zm-3 0c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1-1-.4-1-1z"
          }));
        case 'compass':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "compass"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            transform: "translate(1 1)",
            id: "Group_15793"
          }, /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15792"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8461",
            d: "M18.8 3.2c-4.3-4.3-11.3-4.3-15.5 0s-4.3 11.3 0 15.5c4.3 4.3 11.2 4.3 15.5 0 4.3-4.2 4.3-11.2 0-15.5m-1.4 14.2c-3.5 3.5-9.2 3.5-12.7 0s-3.5-9.2 0-12.7 9.2-3.5 12.7 0c3.5 3.4 3.5 9.1 0 12.7"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8462",
            d: "M16.2 5.8c-.3-.3-.7-.4-1-.2l-5.7 2c-.9.3-1.6 1-1.9 1.9l-2 5.7c-.2.5.1 1.1.6 1.3.1 0 .2.1.3.1.1 0 .2 0 .3-.1l5.7-2c.9-.3 1.6-1 1.9-1.9l2-5.7c.2-.4.1-.8-.2-1.1m-3.8 6.6c-.8.8-2 .8-2.8 0s-.8-2 0-2.8 2-.8 2.8 0c.8.8.8 2 0 2.8"
          }))));
        case 'compress':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9 8a1 1 0 0 1-1 1H3a1 1 0 0 1 0-2h4V3a1 1 0 0 1 2 0v5zM15 16a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2h-4v4a1 1 0 1 1-2 0v-5zM7 17v4a1 1 0 1 0 2 0v-5a1 1 0 0 0-1-1H3a1 1 0 1 0 0 2h4zM17 7V3a1 1 0 1 0-2 0v5a1 1 0 0 0 1 1h5a1 1 0 1 0 0-2h-4z"
          }));
        case 'csv':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M20.5 9h1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-1v1.5A2.5 2.5 0 0 1 18 23H4a2.5 2.5 0 0 1-2.5-2.5v-17A2.5 2.5 0 0 1 4 1h10.879a2.5 2.5 0 0 1 1.767.732l3.122 3.122A2.5 2.5 0 0 1 20.5 6.62V9zM4 3a.5.5 0 0 0-.5.5v17a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5V19h-12a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h12V6.621a.5.5 0 0 0-.146-.353l-3.122-3.122A.5.5 0 0 0 14.88 3H4zm13.685 8.324l.962 3.775h.037l.962-3.775h1.438l-1.548 5.354h-1.74l-1.549-5.354h1.438zm-3.094 1.264c.102.098.16.234.172.408h1.218a1.817 1.817 0 0 0-.229-.917 1.537 1.537 0 0 0-.639-.612c-.276-.145-.604-.217-.982-.217-.371 0-.7.072-.987.214-.286.143-.51.343-.671.599-.16.254-.24.551-.239.891-.001.419.117.749.355.991.24.24.567.412.983.515l.467.115c.174.044.312.09.415.141a.552.552 0 0 1 .22.168c.045.06.069.132.07.214a.41.41 0 0 1-.073.233.463.463 0 0 1-.208.159.885.885 0 0 1-.341.057.944.944 0 0 1-.42-.086.625.625 0 0 1-.27-.253.904.904 0 0 1-.107-.413h-1.21c.002.448.086.815.252 1.103.168.286.403.497.706.635.303.138.66.206 1.067.206.397 0 .736-.063 1.019-.19.284-.127.502-.313.655-.557.153-.244.23-.542.231-.894a1.849 1.849 0 0 0-.087-.565 1.333 1.333 0 0 0-.258-.465 1.606 1.606 0 0 0-.454-.363 2.649 2.649 0 0 0-.667-.249l-.384-.094a1.942 1.942 0 0 1-.289-.089.856.856 0 0 1-.199-.11.407.407 0 0 1-.115-.138.385.385 0 0 1-.03-.175.389.389 0 0 1 .063-.21c.04-.06.1-.108.183-.143a.814.814 0 0 1 .323-.055c.206 0 .36.049.46.146zm-2.805.743h-1.292a1.113 1.113 0 0 0-.073-.332.757.757 0 0 0-.16-.256.658.658 0 0 0-.245-.168.845.845 0 0 0-.328-.06.841.841 0 0 0-.543.178 1.094 1.094 0 0 0-.334.51 2.502 2.502 0 0 0-.112.797c0 .328.038.602.114.823.078.22.19.386.337.497.146.11.323.165.529.165a.94.94 0 0 0 .316-.05.717.717 0 0 0 .41-.382c.044-.092.074-.196.09-.31l1.29.01a2.268 2.268 0 0 1-.577 1.341 1.972 1.972 0 0 1-.652.476c-.26.12-.561.18-.905.18-.43 0-.816-.105-1.158-.316-.34-.211-.61-.521-.809-.93-.197-.41-.295-.912-.295-1.504 0-.596.1-1.098.302-1.506.202-.41.473-.719.815-.928.342-.21.724-.316 1.145-.316.297 0 .57.046.818.139.249.092.467.227.655.405.188.176.339.393.454.65.114.259.184.554.208.887z"
          }));
        case 'cup':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "cup"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4680",
            d: "M19 5V3c0-.6-.4-1-1-1H6c-.6 0-1 .4-1 1v2C2.8 5 1 6.8 1 9s1.8 4 4 4h.3c.8 2.6 3 4.5 5.7 4.9V20H8c-.6 0-1 .4-1 1s.4 1 1 1h8c.6 0 1-.4 1-1s-.4-1-1-1h-3v-2-.1c2.7-.4 4.9-2.3 5.7-4.9h.3c2.2 0 4-1.8 4-4s-1.8-4-4-4zM5 11c-1.1 0-2-.9-2-2s.9-2 2-2v4zm7 5c-2.8 0-5-2.2-5-5V4h10v7c0 2.8-2.2 5-5 5zm7-5V7c1.1 0 2 .9 2 2s-.9 2-2 2z"
          }));
        case 'customer':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "customer"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4686",
            d: "M12 12c2.8 0 5-2.2 5-5s-2.2-5-5-5-5 2.2-5 5 2.2 5 5 5zm0-8c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4687",
            d: "M15 13c-.3 0-.5.1-.7.3L13 14.6V14c0-.6-.4-1-1-1s-1 .4-1 1v.6l-1.3-1.3c-.2-.2-.4-.3-.7-.3-2.8 0-5 2.2-5 5v3c0 .6.4 1 1 1h14c.6 0 1-.4 1-1v-3c0-2.8-2.2-5-5-5zm3 7H6v-2c0-1.5 1.1-2.8 2.6-3l2.7 2.7c.4.4 1 .4 1.4 0l2.7-2.7c1.5.2 2.6 1.5 2.6 3v2z"
          }));
        case 'CZK':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_27784_1201)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 4H0v16h24V4z",
            fill: "#D7141A"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 4H0v8h24V4z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M12 12L0 4v16l12-8z",
            fill: "#11457E"
          })), /*#__PURE__*/_react.default.createElement("rect", {
            x: ".5",
            y: "4.5",
            width: "23",
            height: "15",
            rx: ".5",
            stroke: "#F0F0F0"
          }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_27784_1201"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "24",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'dashboard':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "dashboard"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4599",
            d: "M10 11H4c-.6 0-1-.4-1-1V4c0-.6.4-1 1-1h6c.6 0 1 .4 1 1v6c0 .6-.4 1-1 1zM5 9h4V5H5v4z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4600",
            d: "M20 11h-6c-.6 0-1-.4-1-1V4c0-.6.4-1 1-1h6c.6 0 1 .4 1 1v6c0 .6-.4 1-1 1zm-5-2h4V5h-4v4z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4601",
            d: "M10 21H4c-.6 0-1-.4-1-1v-6c0-.6.4-1 1-1h6c.6 0 1 .4 1 1v6c0 .6-.4 1-1 1zm-5-2h4v-4H5v4z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4602",
            d: "M20 21h-6c-.6 0-1-.4-1-1v-6c0-.6.4-1 1-1h6c.6 0 1 .4 1 1v6c0 .6-.4 1-1 1zm-5-2h4v-4h-4v4z"
          }));
        case 'dashboard-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "dashboard-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Union_23",
            d: "M13 19v-7h6v7h-6zm-8 0v-5h6v5H5zm0-7V5h6v7H5zm8-2V5h6v5h-6z"
          }));
        case 'desktop':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "desktop"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4722",
            d: "M23 10h-5V4c0-1.7-1.3-3-3-3H9C7.3 1 6 2.3 6 4v6H1c-.6 0-1 .4-1 1s.4 1 1 1h1v10c0 .6.4 1 1 1s1-.4 1-1v-2h16v2c0 .6.4 1 1 1s1-.4 1-1V12h1c.6 0 1-.4 1-1s-.4-1-1-1zM8 4c0-.6.4-1 1-1h6c.6 0 1 .4 1 1v6H8V4zm12 14H4v-6h16v6z"
          }));
        case 'dev-avatar':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "dev-avatar"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10742",
            transform: "translate(-1133.547 -755.806)"
          }, /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10742-2"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4491",
            d: "M1152.5 777.8c-.6 0-1-.4-1-1 0-3.3-2.7-6-6-6s-6 2.7-6 6c0 .6-.4 1-1 1s-1-.4-1-1c0-4.4 3.6-8 8-8s8 3.6 8 8c0 .6-.4 1-1 1z"
          })), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10743"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4492",
            d: "M1145.5 767.8c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
          })), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10744"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4493",
            d: "M1145.5 767.8c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
          })), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10745"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4494",
            d: "M1143.8 777.3c-.3 0-.5-.1-.7-.3l-1.5-1.5c-.4-.4-.4-1 0-1.4l1.5-1.5c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-.8.8.8.8c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3z"
          })), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10746"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4495",
            d: "M1147.3 777.3c-.6 0-1-.4-1-1 0-.3.1-.5.3-.7l.8-.8-.8-.8c-.4-.4-.3-1.1.1-1.4.4-.3.9-.3 1.3 0l1.5 1.5c.4.4.4 1 0 1.4l-1.5 1.5c-.2.2-.4.3-.7.3z"
          }))));
        case 'divide':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "divide"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M15 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM15 19a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2 12a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1z"
          }));
        case 'DKK':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_4901_829)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M22.588 4H1.412C.632 4 0 4.716 0 5.6v12.8c0 .884.632 1.6 1.412 1.6h21.176c.78 0 1.412-.716 1.412-1.6V5.6c0-.884-.632-1.6-1.412-1.6z",
            fill: "#000"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 4H0v16h24V4z",
            fill: "#C60C30"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M9 4H7v16h2V4z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 10.999H0v2.002h24v-2.002z",
            fill: "#fff"
          })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_4901_829"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "24",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'document-plus':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "document-plus"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10887",
            transform: "translate(-1237.5 -306.806)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4719",
            d: "M1257.2 313.1l-4-4c-.2-.2-.4-.3-.7-.3h-10c-.6 0-1 .4-1 1v18c0 .6.4 1 1 1h14c.6 0 1-.4 1-1v-14c0-.3-.1-.5-.3-.7zm-1.7 13.7h-12v-16h8.6l3.4 3.4v12.6z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4720",
            d: "M1250.5 316.8c0-.6-.4-1-1-1s-1 .4-1 1v2h-2c-.6 0-1 .4-1 1s.4 1 1 1h2v2c0 .6.4 1 1 1s1-.4 1-1v-2h2c.6 0 1-.4 1-1s-.4-1-1-1h-2v-2z"
          })));
        case 'documents':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M18 19.9H6c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h4.4c.8 0 1.5.4 1.8 1.1l.9 1.9H18c1.1 0 2 .9 2 2v9c0 1-.9 1.9-2 1.9zM6 6.1V18h12V9h-5.5c-.4 0-.7-.2-.9-.5l-1.2-2.4H6z"
          }));
        case 'documents-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "documents-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4387",
            d: "M18 5V1H2v19h4v3h16V5h-4zM4 18V3h12v2H6v13H4zm16 3H8V7h12v14z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4388",
            d: "M10 9h8v2h-8V9z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4389",
            d: "M10 13h8v2h-8v-2z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4390",
            d: "M10 17h4v2h-4v-2z"
          }));
        case 'download':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "download"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10835",
            transform: "translate(-1024.5 -479.806)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4649",
            d: "M1035.8 496.5c.4.4 1 .4 1.4 0l6-6c.4-.4.4-1 0-1.4s-1-.4-1.4 0l-4.3 4.3v-11.6c0-.6-.4-1-1-1s-1 .4-1 1v11.6l-4.3-4.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l6 6z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4650",
            d: "M1046.5 493.8c-.6 0-1 .4-1 1v6h-18v-6c0-.6-.4-1-1-1s-1 .4-1 1v7c0 .6.4 1 1 1h20c.6 0 1-.4 1-1v-7c0-.5-.4-1-1-1z"
          })));
        case 'DZD':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_27784_1301)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M0 4h24v16H0V4z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M0 4h12v16H0V4z",
            fill: "#063"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M15.464 10a4 4 0 1 0 0 4 3.2 3.2 0 1 1 0-4zm.154 2L12 10.824l2.236 3.078v-3.804L12 13.176 15.618 12z",
            fill: "#D21034"
          })), /*#__PURE__*/_react.default.createElement("rect", {
            x: ".5",
            y: "4.5",
            width: "23",
            height: "15",
            rx: ".5",
            stroke: "#F0F0F0"
          }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_27784_1301"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "24",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'edit':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "edit"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Union_5",
            d: "M5 22c-1.7 0-3-1.3-3-3V7c0-1.7 1.3-3 3-3h4.6c.6 0 1 .4 1 1s-.4 1-1 1H5c-.6 0-1 .4-1 1v12c0 .6.4 1 1 1h12c.6 0 1-.4 1-1v-3.6c0-.6.4-1 1-1s1 .4 1 1V19c0 1.7-1.3 3-3 3H5zm3-5c-.6 0-1-.4-1-1v-3.7c0-.3.1-.5.3-.7l9.3-9.3c.4-.4 1-.4 1.4 0L21.7 6c.4.4.4 1 0 1.4l-9.3 9.3c-.1.2-.4.3-.7.3H8zm1-4.3V15h2.3l5.5-5.5-2.3-2.3L9 12.7zm6.9-6.9l2.3 2.3 1.4-1.4-2.3-2.3-1.4 1.4z"
          }));
        case 'edit-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "edit-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Union_21",
            d: "M3 21.4v-16h7v2H5v12h12v-5h2v7H3zm4-4V13L17 3l4.4 4.4-10 10H7zm2-3.6v1.6h1.6l8-8L17 5.8l-8 8z"
          }));
        case 'ellipsis':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "ellipsis"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4343",
            d: "M13.5 5.5c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5S11.2 4 12 4s1.5.7 1.5 1.5z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4344",
            d: "M13.5 12c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5.7-1.5 1.5-1.5 1.5.7 1.5 1.5z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4345",
            d: "M13.5 18.5c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5.7-1.5 1.5-1.5 1.5.7 1.5 1.5z"
          }));
        case 'ellipsis-h':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "ellipsis-h"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4343",
            d: "M5.5 10.5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5S4 12.8 4 12s.7-1.5 1.5-1.5z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4344",
            d: "M12 10.5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5-1.5-.7-1.5-1.5.7-1.5 1.5-1.5z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4345",
            d: "M18.5 10.5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5S17 12.8 17 12s.7-1.5 1.5-1.5z"
          }));
        case 'ellipsis-v-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M13.8 5.2a2 2 0 1 1-3.999.001A2 2 0 0 1 13.8 5.2zM13.8 12.2a2 2 0 1 1-3.999.001A2 2 0 0 1 13.8 12.2zM13.8 19.2a2 2 0 1 1-3.999.001A2 2 0 0 1 13.8 19.2z"
          }));
        case 'envelope-open':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "envelope-open"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8377",
            d: "M23 9.2v-.1V9c0-.1 0-.1-.1-.2v-.1l-.1-.1-.1-.1v-.1l-10-7.3c-.4-.3-.8-.3-1.2 0l-10 7.3v.1l-.1.1-.1.1c-.1.1 0 0 0 0v.1s0 .1-.1.2v13.3c0 .6.4 1 1 1h20c.6 0 1-.4 1-1L23 9.2zm-11-6l8.3 6-8.3 5.9-8.3-5.8L12 3.2zM3 21.3V11.2l8.4 5.9c.3.2.8.2 1.1 0l8.4-5.9v10.1H3z"
          }));
        case 'error':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "error"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip-path"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Rectangle_12624",
            fill: "none",
            d: "M0 0h24v24H0z"
          }))), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15798",
            dataName: "Group 15798"
          }, /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15798-2",
            dataName: "Group 15798",
            clipPath: "url(#clip-path)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8467",
            dataName: "Path 8467",
            d: "M12 0a12 12 0 1 0 12 12A12.013 12.013 0 0 0 12 0m0 22a10 10 0 1 1 9.99-10A10.006 10.006 0 0 1 12 22"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8468",
            dataName: "Path 8468",
            d: "M13.337 12l3.81-3.789a1 1 0 0 0 0-1.415 1.009 1.009 0 0 0-1.421 0l-3.81 3.789-3.81-3.791a1.009 1.009 0 0 0-1.421 0 1 1 0 0 0 0 1.414L10.494 12l-3.812 3.789A1 1 0 0 0 8.1 17.2l3.811-3.79 3.812 3.8a1 1 0 1 0 1.425-1.41z",
            transform: "translate(.031)"
          }))));
        case 'EUR':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_4901_830)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 4H0v16h24V4z",
            fill: "#039"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M7.856 8.92l.22.525.571.014-.438.364.163.546-.487-.301-.473.322.14-.553-.45-.35.57-.042.192-.539-.008.014zM14.287 15.297l.219.525.572.014-.438.364.162.546-.487-.301-.473.322.141-.553-.451-.35.572-.042.19-.539-.007.014zM9.579 7.212l.219.525.571.014-.437.364.162.546-.487-.301-.473.322.141-.553-.451-.35.571-.042.19-.539-.006.014zM9.579 15.297l.219.525.571.014-.437.364.162.546-.487-.301-.473.322.141-.553-.451-.35.571-.042.19-.539-.006.014zM14.287 7.212l.219.525.572.014-.438.364.162.546-.487-.301-.473.322.141-.553-.451-.35.572-.042.19-.539-.007.014zM7.856 13.589l.22.525.571.014-.438.364.163.546-.487-.301-.473.322.14-.553-.45-.35.57-.042.192-.539-.008.014zM16.01 8.92l.218.525.572.014-.438.364.163.546-.487-.301-.473.322.14-.553-.45-.35.57-.042.192-.539-.008.014zM16.638 11.258l.218.525.572.014-.437.364.162.546-.487-.301-.473.322.141-.553-.452-.35.572-.042.19-.539-.006.014zM7.228 11.258l.22.525.57.014-.437.364.163.546-.488-.301-.472.322.14-.553-.451-.35.572-.042.19-.539-.007.014zM11.93 15.92l.218.525.572.014-.438.364.163.546-.487-.301-.473.322.14-.553-.45-.35.57-.042.192-.539-.008.014zM11.93 6.589l.218.525.572.014-.438.364.163.546-.487-.301-.473.322.14-.553-.45-.35.57-.042.192-.539-.008.014zM16.01 13.589l.218.525.572.014-.438.364.163.546-.487-.301-.473.322.14-.553-.45-.35.57-.042.192-.539-.008.014z",
            fill: "#FC0"
          })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_4901_830"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "24",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'excel':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M11.5 11.5L13.104 9h2.83l-3.02 4.519L16.5 19h-2.736L11.5 15.54l-1.132 1.826H11.5L12.538 19H6.5l3.585-5.481L7.067 9h2.83l1.603 2.5z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.5 1A2.5 2.5 0 0 0 2 3.5v17A2.5 2.5 0 0 0 4.5 23h14a2.5 2.5 0 0 0 2.5-2.5V6.621a2.5 2.5 0 0 0-.732-1.767l-3.122-3.122A2.5 2.5 0 0 0 15.38 1H4.5zM4 3.5a.5.5 0 0 1 .5-.5h10.879a.5.5 0 0 1 .353.146l3.122 3.122A.5.5 0 0 1 19 6.62V20.5a.5.5 0 0 1-.5.5h-14a.5.5 0 0 1-.5-.5v-17z"
          }));
        case 'exclamation':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "exclamation"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "exclamation-2",
            transform: "translate(.05 .2)"
          }, /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10875",
            transform: "translate(10.7 3.8)"
          }, /*#__PURE__*/_react.default.createElement("ellipse", {
            id: "Ellipse_32",
            cx: "1.2",
            cy: "14.7",
            rx: "1.2",
            ry: "1.2"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4690",
            d: "M1.2 0C.6 0 0 .6 0 1.3v9.4c0 .7.5 1.3 1.2 1.3s1.3-.5 1.3-1.2V1.3C2.5.6 2 0 1.2 0c.1 0 .1 0 0 0z"
          }))));
        case 'exit':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "exit"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Union_18",
            d: "M2 23c-.6 0-1-.4-1-1V2c0-.6.4-1 1-1h7c.6 0 1 .4 1 1s-.4 1-1 1H3v18h6c.6 0 1 .4 1 1s-.4 1-1 1H2zm13.3-4.3c-.4-.4-.4-1 0-1.4l4.3-4.3H8c-.6 0-1-.4-1-1s.4-1 1-1h11.6l-4.3-4.3c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l6 6c.1.1.2.2.2.3.1.2.1.5 0 .8-.1.1-.1.2-.2.3l-6 6c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3z"
          }));
        case 'expand':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "expand"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M8 2H3c-.6 0-1 .4-1 1v5c0 .6.4 1 1 1s1-.4 1-1V4h4c.6 0 1-.4 1-1s-.4-1-1-1zM21 2h-5c-.6 0-1 .4-1 1s.4 1 1 1h4v4c0 .6.4 1 1 1s1-.4 1-1V3c0-.6-.4-1-1-1zM8 20H4v-4c0-.6-.4-1-1-1s-1 .4-1 1v5c0 .6.4 1 1 1h5c.6 0 1-.4 1-1s-.4-1-1-1zM21 15c-.6 0-1 .4-1 1v4h-4c-.6 0-1 .4-1 1s.4 1 1 1h5c.6 0 1-.4 1-1v-5c0-.6-.4-1-1-1z"
          }));
        case 'expand-left':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "arrow-from-right"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15796",
            transform: "translate(-684.001 -1569)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8463",
            d: "M700 1580h-9.6l4.3-4.3c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-6 6c-.4.4-.4 1 0 1.4l6 6c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4l-4.3-4.3h9.6c.6 0 1-.4 1-1s-.4-1-1-1"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8464",
            d: "M704 1574c-.5 0-1 .4-1 .9v12.3c.1.6.6.9 1.1.9.5-.1.8-.4.9-.9v-12.3c0-.5-.5-.9-1-.9"
          })));
        case 'expand-right':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "arrow-from-left"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15797",
            transform: "translate(-684 -1595)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8465",
            d: "M704.9 1607.4c.2-.4.1-.8-.2-1.1l-6-6c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l4.3 4.3H692c-.6 0-1 .4-1 1s.4 1 1 1h9.6l-4.3 4.3c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l6-6c.1-.1.2-.2.2-.3"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8466",
            d: "M688 1600c-.5 0-1 .4-1 .9v12.3c0 .5.5.9 1 .9s1-.4 1-.9v-12.3c0-.5-.5-.9-1-.9"
          })));
        case 'external-link':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "external-link"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4504",
            d: "M21.9 2.6c-.1-.4-.5-.6-.9-.6h-6c-.6 0-1 .4-1 1s.4 1 1 1h3.6l-8.3 8.3c-.4.4-.4 1 0 1.4s1 .4 1.4 0L20 5.4V9c0 .6.4 1 1 1s1-.4 1-1V3c0-.1 0-.3-.1-.4z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4505",
            d: "M19 14.4c-.6 0-1 .4-1 1V19c0 .6-.4 1-1 1H5c-.6 0-1-.4-1-1V7c0-.6.4-1 1-1h4.6c.6 0 1-.4 1-1s-.4-1-1-1H5C3.3 4 2 5.3 2 7v12c0 1.7 1.3 3 3 3h12c1.7 0 3-1.3 3-3v-3.6c0-.6-.4-1-1-1z"
          }));
        case 'eye':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "eye"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4682",
            d: "M22.8 11.5C22.6 11.2 18 4 12 4S1.4 11.2 1.2 11.5c-.2.3-.2.8 0 1.1C1.4 12.8 6 20 12 20s10.6-7.2 10.8-7.5c.3-.3.3-.7 0-1zM12 18c-4.1 0-7.6-4.4-8.8-6 1.1-1.6 4.7-6 8.8-6s7.6 4.4 8.8 6c-1.2 1.6-4.7 6-8.8 6z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4683",
            d: "M12 8c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2c.2 0 .4 0 .6.1-.5.2-.7.8-.5 1.3s.8.7 1.3.5c.2-.1.4-.3.5-.5.1.2.1.4.1.6 0 1.1-.9 2-2 2z"
          }));
        case 'eye-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "eye-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Union_22",
            d: "M1.3 12.5L1 12l.4-.5C1.6 11.2 6.2 4 12.2 4s10.6 7.2 10.8 7.5l.3.5-.3.5c-.2.3-4.8 7.5-10.8 7.5S1.6 12.8 1.3 12.5zm2.1-.5c1.2 1.6 4.7 6 8.8 6s7.6-4.4 8.8-6c-1.2-1.6-4.7-6-8.8-6s-7.7 4.4-8.8 6zm3.8 0c0-2.7 2.2-5 4.9-5h.1c2.7 0 5 2.2 5 4.9v.1c0 2.7-2.2 5-4.9 5h-.1c-2.7 0-5-2.2-5-5 0 .1 0 0 0 0zm2 0c0 1.6 1.3 3 2.9 3h.1c1.6 0 3-1.3 3-2.9V12c0-1.6-1.3-3-2.9-3h-.1c-1.6 0-3 1.3-3 2.9v.1zm3-1c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1-1-.4-1-1z"
          }));
        case 'eye-slash':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "eye-slash"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Union_33",
            d: "M19.2 21l-2.4-2.4-1.5-1.5-8.7-8.8-1.5-1.4-3-3c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l3.2 3.2C8.3 4.6 10.1 4 12 4c6 0 10.6 7.2 10.8 7.5.2.3.2.8 0 1.1-1.2 1.8-2.7 3.5-4.4 4.9l2.2 2.2c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3-.3-.2-.5-.3-.7-.4zM16 12c0 .8-.2 1.6-.7 2.3L17 16c1.4-1.1 2.7-2.5 3.8-4-1.1-1.6-4.7-6-8.8-6-1.4 0-2.7.5-3.8 1.2l1.5 1.5c.7-.5 1.5-.7 2.3-.7 2.2 0 4 1.8 4 4zm-4.8-1.8l2.6 2.6c.1-.2.2-.5.2-.8 0-1.1-.9-2-2-2-.3 0-.6 0-.8.2zm-10 2.3c-.2-.3-.2-.8 0-1.1.7-1.1 1.6-2.2 2.5-3.1l1.4 1.4c-.7.7-1.3 1.5-1.9 2.2 1.1 1.6 4.7 6 8.8 6 .4 0 .8-.1 1.2-.1l1.6 1.6c-.9.4-1.8.6-2.8.6-6 0-10.6-7.2-10.8-7.5z"
          }));
        case 'factory':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M21.3 19.62L20.4 6.6h-3.6l-.6 8.04-6.6-3.84v3.6l-7.2-3.6v8.4c.96 1.32 2.22 2.4 3.6 3.18V18h3.6v5.76c.78.18 1.56.24 2.4.24 3.72 0 7.08-1.74 9.3-4.38z"
          }));
        case 'file-lines':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M20.71 4.29l-3-3A.99.99 0 0 0 17 1H4c-.55 0-1 .45-1 1v20c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V5c0-.27-.11-.52-.29-.71zM19 21H5V3h11.59L19 5.41V21z",
            fill: "#000"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M15.26 11.85H8.74c-.55 0-1-.45-1-1s.45-1 1-1h6.52c.55 0 1 .45 1 1s-.45 1-1 1zM12 15.8H8.74c-.55 0-1-.45-1-1s.45-1 1-1H12c.55 0 1 .45 1 1s-.45 1-1 1z",
            fill: "#000"
          }));
        case 'filter':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "filter"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10857",
            transform: "translate(-998.628 -661.806)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4621",
            d: "M1020.6 665.8h-20l6.9 8.2v7.8h6v-7.4l7.1-8.6z"
          })));
        case 'filter-close':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "filter-close"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15711",
            transform: "translate(-1308.5 -384.806)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8378",
            d: "M1328.9 391.8l2.3-2.3c.4-.4.4-1 0-1.4-.2-.2-.4-.3-.7-.3h-20c-.6 0-1 .4-1 1 0 .2.1.5.2.7l6.8 7.7v7.6c0 .6.4 1 1 1h6c.6 0 1-.4 1-1v-2.1c3.3.6 6.4-1.6 6.9-4.9.4-2.3-.6-4.6-2.5-6zm-6.4 12h-4v-7c0-.2-.1-.5-.2-.7l-5.5-6.3h15.4l-1.2 1.2c-3.2-.8-6.5 1.2-7.2 4.4-.6 2.6.5 5.3 2.8 6.6l-.1 1.8zm3-3c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8379",
            d: "M1327.5 395.8h-4c-.6 0-1 .4-1 1s.4 1 1 1h4c.6 0 1-.4 1-1s-.4-1-1-1z"
          })));
        case 'flag':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M5.999 13v9c0 .28-.1.52-.29.71-.19.19-.43.29-.71.29-.28 0-.52-.1-.71-.29A.974.974 0 0 1 4 22V2c0-.28.1-.52.29-.71C4.48 1.1 4.72 1 5 1h7.175c.23 0 .44.08.63.23.19.15.3.34.35.58l.25 1.2H19c.28 0 .52.1.71.29.19.19.289.43.289.71v10c0 .28-.1.52-.29.71-.19.19-.43.29-.71.29h-6.175c-.23 0-.44-.08-.63-.23a.95.95 0 0 1-.35-.58l-.25-1.2H6zm7.645 0h4.347V5h-5.426c-.23 0-.44-.08-.63-.23a1 1 0 0 1-.35-.58l-.25-1.2H6v8h6.426c.23 0 .44.08.63.23.19.15.3.34.35.58l.25 1.2h-.01z",
            fill: "#000"
          }));
        case 'flag-solid':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M5.999 13v9c0 .28-.1.52-.29.71a.975.975 0 0 1-.71.29.97.97 0 0 1-.709-.29A.972.972 0 0 1 4 22V2c0-.28.1-.52.29-.71A.97.97 0 0 1 4.999 1h7.176c.101 0 .199.016.292.046a1.075 1.075 0 0 1 .5.347.986.986 0 0 1 .187.417l.25 1.2h5.597c.28 0 .52.1.709.29.19.19.29.43.29.71v10c0 .127-.02.245-.06.354a.952.952 0 0 1-.323.438.974.974 0 0 1-.616.208h-6.176c-.23 0-.44-.08-.63-.23a.948.948 0 0 1-.35-.58l-.25-1.2H6z",
            fill: "#000"
          }));
        case 'flexible-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "flexible-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "flexible-alt-2",
            d: "M11.5 15.9c-2.5-2.5-6.6-2.5-9.1 0L1 14.5c3.3-3.3 8.6-3.3 11.9 0 2.5 2.5 6.6 2.5 9.1 0l1.4 1.4a8.39 8.39 0 0 1-11.9 0zm0-6C9 7.4 4.9 7.4 2.4 9.9L1 8.5c3.3-3.3 8.6-3.3 11.9 0 2.4 2.5 6.4 2.5 8.9.1l.1-.1 1.4 1.4c-1.6 1.6-3.7 2.5-6 2.5-2.2-.1-4.3-1-5.8-2.5z"
          }));
        case 'folder':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "folder"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10838",
            transform: "translate(-920.5 -557.806)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4532",
            d: "M940.5 578.8h-16c-1.1 0-2-.9-2-2v-14c0-1.1.9-2 2-2h6.4c.8 0 1.5.4 1.8 1.1l.9 1.9h6.9c1.1 0 2 .9 2 2v11c0 1.1-.9 2-2 2zm-16-16v14h16v-11H933c-.4 0-.7-.2-.9-.6l-1.2-2.4h-6.4z"
          })));
        case 'frown':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "frown"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10899",
            transform: "translate(-1270.505 -280.81)"
          }, /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10894"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4724",
            d: "M1282.5 303.8c-6.1 0-11-4.9-11-11 0-2.9 1.2-5.7 3.2-7.8 4.3-4.3 11.3-4.3 15.6 0 4.3 4.3 4.3 11.3 0 15.6-2.1 2-4.9 3.2-7.8 3.2zm-6.4-17.4c-3.5 3.5-3.5 9.2 0 12.7s9.2 3.5 12.7 0 3.5-9.2 0-12.7-9.1-3.5-12.7 0z"
          })), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10895"
          }, /*#__PURE__*/_react.default.createElement("circle", {
            id: "Ellipse_41",
            cx: "1279",
            cy: "290.3",
            r: "1.5"
          })), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10896"
          }, /*#__PURE__*/_react.default.createElement("circle", {
            id: "Ellipse_42",
            cx: "1286",
            cy: "290.3",
            r: "1.5"
          })), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10897"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4726",
            d: "M1278.2 296.8c-.6 0-1-.4-1-1 0-.3.2-.6.4-.8 3.1-1.6 6.7-1.6 9.8 0 .4.3.5 1 .2 1.4-.3.4-.9.5-1.4.2-2.4-1.1-5.1-1.1-7.5 0-.1.1-.3.2-.5.2z"
          }))));
        case 'GBP':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip1_4901_831)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M22.588 4.008H1.412c-.78 0-1.412.716-1.412 1.6V18.4C0 19.284.632 20 1.412 20h21.176c.78 0 1.412-.716 1.412-1.6V5.608c0-.883-.632-1.599-1.412-1.599z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M13.44 10.405h-.092v-.08-6.261V4h-2.69v6.397H0v3.19H10.652v6.405h2.69v-.08-6.317H24v-3.19H13.44z",
            fill: "#D10D24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M23.435 4.008l-.063.048c-2.93 1.743-5.866 3.486-8.796 5.23a.152.152 0 0 0-.056.04v.007H16.412a.288.288 0 0 0 .134-.04c2.485-1.479 4.97-2.95 7.454-4.43v-.855h-.565zM7.588 14.675a.289.289 0 0 0-.134.04c-2.485 1.479-4.97 2.95-7.461 4.43V20h.565s.035-.032.056-.04c1.066-.632 2.125-1.263 3.19-1.895 1.871-1.112 3.742-2.223 5.605-3.334.022-.016.043-.024.064-.04a49.772 49.772 0 0 0-1.892-.008l.007-.008zM18.544 14.707a.241.241 0 0 0-.128-.04H16.518s.042.04.07.056c2.47 1.47 4.941 2.934 7.412 4.405v-1.183c-1.821-1.08-3.635-2.159-5.456-3.238zM7.426 9.285C4.948 7.815 2.478 6.343 0 4.872v1.183c1.814 1.08 3.635 2.159 5.456 3.238.036.024.078.04.113.04h1.927c-.028-.016-.049-.032-.07-.04v-.008z",
            fill: "#D10D24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M14.245 20v-.096-4.67-.104c.02.016.042.024.063.032 2.69 1.6 5.38 3.199 8.076 4.798l.049.032h-8.181l-.007.008zM1.574 20c.057-.032.113-.072.17-.104 2.64-1.575 5.287-3.142 7.927-4.718.028-.016.049-.032.084-.048V20h-8.18zM22.426 4.008c-.057.032-.113.072-.17.104-2.64 1.575-5.287 3.142-7.927 4.718-.028.016-.049.032-.084.048v-.104-4.67-.096h8.18zM9.755 4.008V8.87s-.042-.024-.063-.032L1.624 4.04c-.015-.008-.036-.024-.05-.032h8.181zM4.475 9.333s-.035-.04-.056-.048C2.944 8.405 1.475 7.535 0 6.655v2.678H4.475zM19.567 9.293s-.028.024-.056.04H24V6.655c-1.475.88-2.95 1.759-4.433 2.63v.008zM4.49 14.675H0v2.678c1.475-.88 2.95-1.759 4.433-2.63.014-.008.028-.024.056-.04v-.008zM19.595 14.675h-.07s.035.032.05.048c1.474.88 2.95 1.75 4.425 2.63v-2.678h-4.405z",
            fill: "#00207F"
          })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_4901_831"
          }, /*#__PURE__*/_react.default.createElement("path", {
            fill: "#fff",
            d: "M0 0h24v24H0z"
          })), /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip1_4901_831"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            x: "-.007",
            y: "4",
            width: "24.007",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'gift':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_2848_270)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M20.5 5.382h-.31c.26-.51.43-1.08.43-1.69C20.62 1.65 18.98 0 16.95 0c-1.16 0-2.26.56-2.9 1.44l-2.13 2.492L10 1.5A3.67 3.67 0 0 0 7.05 0C5.03 0 3.38 1.66 3.38 3.692c0 .61.16 1.18.43 1.69H3.5c-1.38 0-2.5 1.12-2.5 2.501V21.5C1 22.879 2.12 24 3.5 24h17c1.38 0 2.5-1.12 2.5-2.501V7.883c0-1.38-1.12-2.5-2.5-2.5zm.5 2.501v3.362h-5.14V7.383h4.64c.28 0 .5.22.5.5zm-5.38-5.202c.32-.43.81-.68 1.34-.68.92 0 1.67.76 1.67 1.69 0 .93-.75 1.691-1.67 1.691h-3.65l2.31-2.7zM5.38 3.691c0-.93.75-1.69 1.67-1.69.53 0 1.02.25 1.36.71l2.12 2.671H7.05c-.92 0-1.67-.76-1.67-1.69zM3.5 7.384h4.64v3.862H3V7.883c0-.28.22-.5.5-.5zM3 21.5v-8.263h5.14v8.763H3.5c-.28 0-.5-.22-.5-.5zm7.14.5V7.383h3.71V22h-3.71zm10.36 0h-4.64v-8.763H21v8.263c0 .28-.22.5-.5.5z",
            fill: "#000"
          })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_2848_270"
          }, /*#__PURE__*/_react.default.createElement("path", {
            fill: "#fff",
            d: "M0 0h24v24H0z"
          }))));
        case 'globe':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "globe"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_22090",
            transform: "translate(1 1.001)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_9391",
            d: "M22 11c0-6.1-4.9-11-11-11S0 4.9 0 11c0 6 4.9 11 11 11s11-4.9 11-11M2.1 12H5c-.1 1.5-.5 3-1.1 4.4-1-1.2-1.7-2.8-1.8-4.4m1.7-6.4C4.5 7 4.9 8.5 5 10H2.1c.1-1.6.8-3.2 1.7-4.4M19.9 10H17c.1-1.5.5-3 1.1-4.4 1 1.3 1.7 2.8 1.8 4.4M15 10h-3V2.1c1.7.2 3.3.9 4.7 2-1 1.8-1.6 3.8-1.7 5.9m-5 0H7c-.1-2.1-.7-4.1-1.7-6 1.3-1.1 3-1.8 4.7-2v8zm-3 2h3v7.9c-1.7-.2-3.3-.9-4.7-2 1-1.8 1.6-3.8 1.7-5.9m5 0h3c.1 2.1.7 4.1 1.7 6-1.3 1.1-3 1.8-4.7 2v-8zm5.1 0H20c-.2 1.6-.8 3.1-1.8 4.4-.7-1.4-1-2.9-1.1-4.4"
          })));
        case 'graduation-cap':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "graduation-cap"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4717",
            d: "M23.4 6.9l-11-4.8c-.3-.1-.5-.1-.8 0L.6 6.9c-.5.2-.7.8-.5 1.3.1.2.3.4.5.5l2.5 1.1v7.6c0 2.8 4.5 4.2 8.9 4.2s8.9-1.4 8.9-4.2V9.8l2.5-1.1c.5-.2.7-.8.5-1.3-.1-.2-.3-.4-.5-.5zM12 4.1l8.5 3.7-8.5 3.7-8.5-3.7L12 4.1zm6.9 13.3c0 .8-2.6 2.2-6.9 2.2s-6.9-1.4-6.9-2.2v-6.7l6.5 2.8c.3.1.5.1.8 0l6.5-2.8v6.7z"
          }));
        case 'grip-vertical':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "grip-vertical"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15038",
            transform: "translate(-1158 -3116)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4343",
            d: "M1168.5 3121.5c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5.7-1.5 1.5-1.5 1.5.7 1.5 1.5z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4343-2",
            d: "M1174.5 3121.5c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5.7-1.5 1.5-1.5 1.5.7 1.5 1.5z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4344",
            d: "M1168.5 3128c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5.7-1.5 1.5-1.5 1.5.7 1.5 1.5z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4344-2",
            d: "M1174.5 3128c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5.7-1.5 1.5-1.5 1.5.7 1.5 1.5z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4345",
            d: "M1168.5 3134.5c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5.7-1.5 1.5-1.5 1.5.7 1.5 1.5z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4345-2",
            d: "M1174.5 3134.5c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5.7-1.5 1.5-1.5 1.5.7 1.5 1.5z"
          })));
        case 'headphones':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "headphones"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4407",
            d: "M4 11.8z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4408",
            d: "M20 11.7z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4673",
            d: "M12 1C5.9 1 1 5.9 1 12v3c0 1.7 1.3 3 3 3h3c.6 0 1-.4 1-1v-5c0-.6-.4-1-1-1H3.1c.6-4.9 5-8.5 10-7.9 4.2.5 7.4 3.8 7.9 7.9h-4c-.6 0-1 .4-1 1v5c0 .6.4 1 1 1h1.4c-.5 1.8-2 3-3.9 3h-2.4c-.6 0-1 .4-1 1s.4 1 1 1h2.4c2.9 0 5.4-2.1 5.9-5 1.5-.2 2.6-1.5 2.6-3v-3c0-6.1-4.9-11-11-11zM6 16H4c-.6 0-1-.4-1-1v-2h3v3zm15-1c0 .6-.4 1-1 1h-2v-3h3v2z"
          }));
        case 'heart':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "heart"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10884",
            transform: "translate(-1212.265 -358.752)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4713",
            d: "M1224.3 380.8c-.2 0-.5-.1-.7-.3l-2.7-2.4c-4.6-4.2-7.6-6.9-7.6-10.8 0-3.6 2.8-6.5 6.4-6.5h.1c2.6 2.2 6.4 2.2 9 0 3.6 0 6.5 2.8 6.5 6.4v.1c0 3.9-3.1 6.7-7.7 10.9l-2.7 2.4c-.1.1-.4.2-.6.2zm-4.5-18c-2.5 0-4.5 2-4.5 4.4v.1c0 3 2.6 5.4 7 9.4l2 1.8 2-1.8c4.4-4 7-6.3 7-9.4 0-2.5-1.9-4.5-4.4-4.5h-.1c-1.4 0-2.8.6-3.7 1.7-.4.4-1 .5-1.5.1l-.1-.1c-.9-1.1-2.3-1.7-3.7-1.7z"
          })));
        case 'heart-f':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "heart-f"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4714",
            d: "M16.5 2c-2.6 2.2-6.4 2.2-9 0C3.9 1.9 1 4.8 1 8.3v.1c0 3.9 3 6.7 7.6 10.8l2.7 2.4c.4.3 1 .3 1.3 0l2.7-2.4C19.9 15 23 12.3 23 8.3 23 4.9 20.2 2 16.6 2h-.1z"
          }));
        case 'help':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "help"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4674",
            d: "M12 1C5.9 1 1 5.9 1 12s4.9 11 11 11 11-4.9 11-11S18.1 1 12 1zm4.2 13.8c1.1-1.7 1.1-3.8 0-5.5L19 6.4c2.6 3.3 2.6 7.9 0 11.2l-2.8-2.8zM9.9 9.9c1.2-1.2 3.1-1.1 4.2 0 1.1 1.2 1.1 3 0 4.2-1.2 1.1-3.1 1.1-4.2 0-1.2-1.2-1.2-3.1 0-4.2zM17.6 5l-2.9 2.9c-1.7-1.1-3.8-1.1-5.5 0L6.4 5c3.3-2.7 7.9-2.7 11.2 0zM5 6.4l2.9 2.9c-1.1 1.7-1.1 3.8 0 5.5L5 17.6C2.3 14.3 2.3 9.7 5 6.4zM6.4 19l2.9-2.9c1.7 1.1 3.8 1.1 5.5 0l2.9 2.9c-3.4 2.7-8 2.7-11.3 0z"
          }));
        case 'HKD':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_27784_1302)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M0 4h24v16H0V4z",
            fill: "#EE1C25"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M13.145 7.339a.744.744 0 0 0-.397 1.114 1.205 1.205 0 0 1-.541 1.766 1.03 1.03 0 0 0-.289 1.715 1.823 1.823 0 0 1-.455-2.505.42.42 0 0 1-.03-.028 1.863 1.863 0 0 0 .447 2.555 2.409 2.409 0 0 1 1.265-4.617z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M12.053 8.83l-.735.32.783.173-.532-.6.077.798",
            fill: "#EE1C25"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M16.787 11.649a.745.745 0 0 0-1.183-.034 1.205 1.205 0 0 1-1.846.03 1.031 1.031 0 0 0-1.72.257 1.823 1.823 0 0 1 2.241-1.207.412.412 0 0 1 .018-.037 1.863 1.863 0 0 0-2.292 1.214 2.409 2.409 0 0 1 4.782-.223z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M15.032 11.07l-.532-.6.078.798.406-.69-.735.32",
            fill: "#EE1C25"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M8.334 15.098a.746.746 0 0 0 .976-.668 1.204 1.204 0 0 1 1.476-1.11 1.03 1.03 0 0 0 1.241-1.218 1.823 1.823 0 0 1-1.104 2.294.447.447 0 0 1 .008.04 1.864 1.864 0 0 0 1.14-2.33 2.41 2.41 0 0 1-3.737 2.992z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M10.094 14.534l.783.173-.532-.6.077.798.407-.691",
            fill: "#EE1C25"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M13.814 16.444a.744.744 0 0 0-.334-1.135 1.204 1.204 0 0 1-.6-1.746 1.03 1.03 0 0 0-.775-1.557 1.823 1.823 0 0 1 1.84 1.758.46.46 0 0 1 .041.005 1.864 1.864 0 0 0-1.863-1.804 2.41 2.41 0 0 1 1.69 4.48z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M13.821 14.596l.406-.691-.735.32.783.173-.532-.6",
            fill: "#EE1C25"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M7.92 9.47a.745.745 0 0 0 .938.723 1.204 1.204 0 0 1 1.511 1.06 1.03 1.03 0 0 0 1.542.804 1.823 1.823 0 0 1-2.522-.34.407.407 0 0 1-.036.019 1.863 1.863 0 0 0 2.568.364 2.41 2.41 0 0 1-4-2.63z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M9 10.97l.079.798.406-.691-.735.32.783.173",
            fill: "#EE1C25"
          })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_27784_1302"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "24",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'home':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "home"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4648",
            d: "M22 23h-7c-.6 0-1-.4-1-1v-6h-4v6c0 .6-.4 1-1 1H2c-.6 0-1-.4-1-1V8.4c0-.4.2-.7.5-.9l10-6.4c.3-.2.7-.2 1.1 0l10 6.4c.2.2.4.5.4.9V22c0 .6-.4 1-1 1zm-6-2h5V8.9l-9-5.7-9 5.7V21h5v-6c0-.6.4-1 1-1h6c.6 0 1 .4 1 1v6z"
          }));
        case 'home-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "home-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "home-alt-2",
            d: "M23 23h-9v-6.9h-4V23H1V8.3L12 1l11 7.3V23zm-7-2h5V9.4l-9-5.9-9 5.9V21h5v-6.9h8V21z"
          }));
        case 'home-f':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "home-f"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8476",
            d: "M22.5 7.5l-10-6.4c-.3-.2-.7-.2-1.1 0l-10 6.4c-.2.2-.4.5-.4.9V22c0 .6.4 1 1 1h6c.6 0 1-.4 1-1v-5c0-.6.4-1 1-1h4c.6 0 1 .4 1 1v5c0 .6.4 1 1 1h6c.6 0 1-.4 1-1V8.4c0-.4-.2-.7-.5-.9"
          }));
        case 'HUF':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_27784_1300)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M0 4h24v16H0",
            fill: "#477050"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M0 4h24v10.667H0",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M0 4h24v5.333H0",
            fill: "#CE2939"
          })), /*#__PURE__*/_react.default.createElement("rect", {
            x: ".5",
            y: "4.5",
            width: "23",
            height: "15",
            rx: ".5",
            stroke: "#F0F0F0"
          }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_27784_1300"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "24",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'IEP':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_27784_1621)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 4H0v16h24V4z",
            fill: "#169B62"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 4H8v16h16V4z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 4h-8v16h8V4z",
            fill: "#FF883E"
          })), /*#__PURE__*/_react.default.createElement("rect", {
            x: ".5",
            y: "4.5",
            width: "23",
            height: "15",
            rx: ".5",
            stroke: "#F0F0F0"
          }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_27784_1621"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "24",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'IQD':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_27784_1622)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M0 4h24v16H0V4z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M0 4h24v5.333H0V4z",
            fill: "#CD1125"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M0 14.667h24V20H0v-5.333z",
            fill: "#000"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M11.847 13.121h-3.91a.454.454 0 0 1-.078.207.54.54 0 0 1-.172.159.675.675 0 0 1-.487.069c.547-.27.513-.542.168-1.148.192-.069.222-.087.416-.218-.138.416.355.366.719.366 0-.146.014-.312-.095-.334.141-.05.154-.066.378-.256v.56h2.697v-.385a.08.08 0 1 0-.162 0v.223a.06.06 0 0 1-.06.06H9.2v-.363l1.548-1.495c-.01.076.149.282.216.317-.05.008-.107-.002-.144.034l-1.266 1.224h1.404c0-.325.303-.325.444-.44.141.115.445.115.445.44v.98zm.292 0v-2.555c.144.078.255.17.433.214-.008.1-.1.133-.1.204v1.572c.199.044.243-.071.338-.13.024.25.184.497.178.695h-.849zm2.671-1.707l.313-.262v1.373h.223v-1.561c.108-.091.25-.19.313-.305v2.462h-1.97c-.028-.509-.028-1.032.566-.919v-.208c0-.049-.073-.01-.073-.055l.406-.339v.925h.222v-1.11zm-.103-.703c-.038.002-.097-.208-.083-.248.014-.047.067-.047.09-.025.035.035.031.271-.007.273zm-.366.285c-.11-.065-.092-.09.005-.063.167.05.252.008.373-.115l.091.047c.12.06.192.034.234-.111.013-.045.049-.033.059.018.038.202-.115.264-.27.208-.085-.029-.1-.029-.142.004a.305.305 0 0 1-.35.012zm1.61 2.125v-2.555c.144.078.255.17.433.214-.008.1-.1.133-.1.204v1.572c.199.044.243-.071.338-.13.024.25.184.497.178.695h-.849zm-7.658.283a.119.119 0 1 1 .238 0 .119.119 0 1 1-.238 0zm5.78-.93c0 .019.01.036.026.05.017.012.04.02.065.02a.107.107 0 0 0 .064-.02.061.061 0 0 0 .027-.05.061.061 0 0 0-.027-.048.107.107 0 0 0-.064-.02.107.107 0 0 0-.065.02.061.061 0 0 0-.026.049z",
            fill: "#017B3D"
          })), /*#__PURE__*/_react.default.createElement("rect", {
            x: ".5",
            y: "4.5",
            width: "23",
            height: "15",
            rx: ".5",
            stroke: "#F0F0F0"
          }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_27784_1622"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "24",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'identity':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "identity"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10843",
            transform: "translate(-946.5 -583.806)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4537",
            d: "M952.5 594.8h3c.6 0 1-.4 1-1s-.4-1-1-1h-3c-.6 0-1 .4-1 1s.4 1 1 1z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4538",
            d: "M952.5 598.8h3c.6 0 1-.4 1-1s-.4-1-1-1h-3c-.6 0-1 .4-1 1s.4 1 1 1z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4539",
            d: "M968.5 586.8h-20c-.6 0-1 .4-1 1v16c0 .6.4 1 1 1h20c.6 0 1-.4 1-1v-16c0-.5-.4-1-1-1zm-1 16h-18v-14h18v14z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4540",
            d: "M962.5 595.8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2c.1 1.1 1 2 2 2z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4541",
            d: "M962.5 596.8c-1.7 0-3 1.3-3 3h6c0-1.7-1.3-3-3-3z"
          })));
        case 'inbox':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "inbox"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M23 11.8v-.2l-3-8c-.2-.3-.6-.6-1-.6H5c-.4 0-.8.3-.9.6l-3 8V19c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-7c-.1-.1-.1-.1-.1-.2zM5.7 5h12.6l2.2 6H16c-.6 0-1 .4-1 1 0 1.7-1.3 3-3 3s-3-1.3-3-3c0-.6-.4-1-1-1H3.4l2.3-6zM21 19H3v-6h4.1c.5 2.7 3.2 4.5 5.9 3.9 2-.4 3.5-1.9 3.9-3.9H21v6z"
          }));
        case 'info':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "info"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10841",
            transform: "rotate(180 472.25 264.903)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4663",
            d: "M932.5 506.8c-6.1 0-11 4.9-11 11s4.9 11 11 11 11-4.9 11-11-4.9-11-11-11zm0 20c-5 0-9-4-9-9s4-9 9-9 9 4 9 9-4 9-9 9z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4664",
            d: "M932.5 521.5c-.5 0-.9.4-.9.9s.4.9.9.9.9-.4.9-.9-.4-.9-.9-.9z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4665",
            d: "M932.5 511.8c-.6 0-1 .4-1 1v7c0 .6.4 1 1 1s1-.4 1-1v-7c0-.5-.4-1-1-1z"
          })));
        case 'info-circle':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "info-circle"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4667",
            d: "M12 1C5.9 1 1 5.9 1 12s4.9 11 11 11 11-4.9 11-11S18.1 1 12 1zm1 16c0 .6-.4 1-1 1s-1-.4-1-1v-7c0-.6.4-1 1-1s1 .4 1 1v7zm-1-9c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
          }));
        case 'JOD':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_27784_1623)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M0 4h24v16H0V4z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M0 4h24v5.333H0V4z",
            fill: "#000"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M0 14.667h24V20H0v-5.333z",
            fill: "#007A3D"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M16 12L0 20V4m4.943 6.857l-.248.629-.644-.197.336.584-.558.381.67.102-.051.673.495-.458.498.458-.05-.673.666-.102-.555-.381.336-.584-.644.197-.251-.629z",
            fill: "#CE1126"
          })), /*#__PURE__*/_react.default.createElement("rect", {
            x: ".5",
            y: "4.5",
            width: "23",
            height: "15",
            rx: ".5",
            stroke: "#F0F0F0"
          }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_27784_1623"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "24",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'JPY':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_4901_832)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M22.588 4H1.412C.632 4 0 4.716 0 5.6v12.8c0 .884.632 1.6 1.412 1.6h21.176c.78 0 1.412-.716 1.412-1.6V5.6c0-.884-.632-1.6-1.412-1.6z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M12 16.137c2.304 0 4.172-1.852 4.172-4.137 0-2.285-1.868-4.137-4.172-4.137-2.304 0-4.172 1.852-4.172 4.137 0 2.285 1.868 4.137 4.172 4.137z",
            fill: "#BC002D"
          })), /*#__PURE__*/_react.default.createElement("rect", {
            x: ".5",
            y: "4.5",
            width: "23",
            height: "15",
            rx: ".5",
            stroke: "#F0F0F0"
          }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_4901_832"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "24",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'kiosk':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "Layer_1"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M19.5 0h-14c-1.1 0-2 .9-2 2v15.5c0 1.1.9 2 2 2h1V22h-2c-.6 0-1 .4-1 1s.4 1 1 1h16c.6 0 1-.4 1-1s-.4-1-1-1h-2v-2.5h1c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm0 2v11h-14V2h14zm-3 20h-8v-2.5h8V22zm-11-4.5V15h14v2.5h-14z"
          }));
        case 'KWD':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_4901_833)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M22.588 4H1.412C.632 4 0 4.716 0 5.6v12.8c0 .884.632 1.6 1.412 1.6h21.176c.78 0 1.412-.716 1.412-1.6V5.6c0-.884-.632-1.6-1.412-1.6z",
            fill: "#000"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 4H0v5.336h24V4z",
            fill: "#007A3D"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 9.336H0v5.336h24V9.336z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 14.664H0V20h24v-5.336z",
            fill: "#CE1126"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M0 4l6.953 5.336v5.328L0 20V4z",
            fill: "#000"
          })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_4901_833"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "24",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'KZT':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_27784_1615)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M0 4h32v16H0V4z",
            fill: "#00ABC2"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M12.288 12.873a2.153 2.153 0 1 0 0-4.306 2.153 2.153 0 0 0 0 4.306zM12.288 8.274c.128-.002.176-.082.176-.178 0-.128-.176-.738-.176-.738s-.176.61-.176.738c0 .096.048.178.176.178zM14.734 10.72c.002.128.082.176.178.176.128 0 .737-.176.737-.176s-.61-.176-.737-.176c-.096 0-.178.048-.178.176zM12.288 13.166c-.128.002-.176.082-.176.178 0 .128.176.738.176.738s.176-.61.176-.738c0-.096-.048-.178-.176-.178zM9.841 10.72c-.001-.128-.081-.176-.177-.176-.128 0-.738.176-.738.176s.61.176.738.176c.096 0 .177-.048.177-.176zM13.224 8.46c.119.047.194-.008.23-.097.05-.118.12-.749.12-.749s-.396.496-.445.614c-.037.09-.024.183.095.232zM14.548 11.656c-.048.12.008.194.097.23.118.05.748.12.748.12s-.496-.396-.614-.444c-.088-.037-.182-.024-.231.094zM11.351 12.98c-.119-.047-.194.008-.23.097-.05.118-.12.749-.12.749s.396-.496.445-.614c.037-.09.024-.183-.095-.232zM10.027 9.784c.048-.12-.008-.194-.096-.23-.119-.05-.75-.12-.75-.12s.497.395.615.444c.089.037.182.024.231-.094zM14.017 8.99c.092.09.183.067.25-.001.091-.09.398-.646.398-.646s-.556.307-.646.397c-.068.068-.092.16-.002.25zM14.017 12.45c-.089.091-.066.182.002.25.09.09.646.397.646.397s-.307-.556-.397-.646c-.068-.068-.16-.092-.25-.001zM10.558 12.45c-.092-.09-.182-.067-.25.001-.09.09-.397.646-.397.646s.555-.307.646-.397c.067-.068.091-.16 0-.25zM10.558 8.99c.09-.092.066-.182-.001-.25-.09-.09-.646-.397-.646-.397s.306.555.397.646c.068.068.16.092.25.001zM14.548 9.784c.05.117.143.131.231.094.118-.049.614-.444.614-.444s-.63.07-.748.12c-.09.036-.146.112-.097.23zM13.224 12.98c-.118.05-.132.143-.095.232.05.118.445.614.445.614s-.07-.63-.12-.75c-.036-.088-.112-.145-.23-.096zM10.027 11.656c-.05-.117-.142-.131-.231-.095-.118.05-.614.445-.614.445s.63-.07.749-.12c.088-.036.145-.112.096-.23zM11.351 8.46c.118-.05.132-.143.095-.232-.049-.118-.445-.614-.445-.614s.07.63.12.75c.037.088.112.145.23.096zM12.765 8.32c.126.024.188-.045.207-.14.025-.125-.029-.757-.029-.757s-.291.564-.316.69c-.019.093.012.183.138.208zM14.687 11.197c-.023.126.046.189.14.208.125.025.758-.03.758-.03s-.564-.29-.69-.316c-.094-.018-.183.013-.208.138zM11.81 13.12c-.126-.024-.188.045-.207.14-.025.125.029.757.029.757s.291-.563.316-.69c.019-.093-.012-.183-.138-.208zM9.888 10.243c.024-.126-.046-.189-.14-.207-.125-.025-.757.028-.757.028s.563.292.689.317c.094.018.183-.013.208-.138zM13.647 8.686c.107.07.191.03.245-.05.07-.106.263-.711.263-.711s-.485.409-.556.515c-.053.08-.059.175.048.246z",
            fill: "#FFEC2D"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M14.322 12.08c-.07.107-.03.19.05.244.106.071.71.264.71.264s-.409-.485-.515-.556c-.08-.054-.174-.06-.245.047zM10.928 12.754c-.107-.07-.191-.03-.245.05-.07.106-.263.711-.263.711s.485-.409.556-.515c.053-.08.059-.175-.048-.246zM10.254 9.36c.07-.106.03-.19-.05-.244-.107-.071-.712-.264-.712-.264s.41.485.516.557c.08.053.174.058.246-.048zM14.322 9.36c.072.106.165.102.245.049.107-.072.516-.557.516-.557s-.605.193-.711.264c-.08.053-.121.138-.05.245zM13.647 12.754c-.106.072-.101.166-.048.246.071.106.556.515.556.515s-.192-.605-.263-.711c-.054-.08-.139-.121-.245-.05zM10.254 12.08c-.073-.106-.166-.102-.246-.049-.106.072-.516.557-.516.557s.605-.193.712-.264c.08-.053.12-.138.05-.245zM10.928 8.686c.106-.073.101-.166.048-.246-.071-.106-.556-.515-.556-.515s.192.605.263.711c.054.08.139.121.245.05zM14.687 10.243c.027.125.114.156.209.138.125-.025.689-.317.689-.317s-.633-.053-.758-.028c-.094.018-.165.081-.14.207zM12.765 13.12c-.125.026-.157.114-.138.208.025.126.316.689.316.689s.054-.632.03-.758c-.02-.094-.083-.165-.208-.14zM9.888 11.197c-.026-.125-.114-.156-.208-.138-.126.025-.69.317-.69.317s.633.054.758.029c.094-.02.165-.082.14-.208zM11.81 8.32c.125-.026.157-.114.138-.208-.025-.125-.316-.689-.316-.689s-.054.632-.029.758c.019.094.082.165.207.14zM11.903 15.383a.668.668 0 0 0-.168.029c-.075.01-.147.036-.222.048l-.03.005-.05.005a.185.185 0 0 1 .005.041.136.136 0 0 1-.005.04.098.098 0 0 1-.021.034.116.116 0 0 1-.036.028.112.112 0 0 1-.041.01.108.108 0 0 1-.083-.03.356.356 0 0 1-.045.009.185.185 0 0 1-.042 0 .262.262 0 0 1-.086-.037c-.055.032-.116.062-.149.118-.018.026-.022.055-.027.085a.233.233 0 0 0 .023.112c.006.01.011-.037.03-.043a.282.282 0 0 1 .106-.053c.032-.017.028 0 .015.026-.003.013-.021.064.003.038a1.04 1.04 0 0 1 .345-.066c.17-.018.34-.021.51-.024l.48.01c.076.003.153.02.228.007.018-.005.047-.006.057-.017-.034-.02-.074-.02-.112-.025h-.305c-.085-.008-.173-.01-.253-.041-.021-.009-.041-.03-.061-.007a.365.365 0 0 1-.095.02.367.367 0 0 1-.164-.028c.037-.052.082-.097.123-.145a1.267 1.267 0 0 1-.098-.02c.058-.04.112-.086.168-.129z",
            fill: "#FFEC2D"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M14.395 15.936c-.116.07-.204-.054-.301-.09-.07.037-.076.163-.14.222-.078.088-.173-.024-.165-.111-.093.078-.14.255-.29.23-.07-.057-.123-.178-.177-.04-.044.068-.162.164-.223.062-.019-.09-.064-.196-.113-.053-.033.1-.141.175-.246.131-.057-.047.046-.22-.027-.207-.109.072-.172.25-.324.236-.059-.066.036-.178-.029-.252-.076.098-.16.242-.293.252-.063-.052.003-.2-.038-.222-.135.081-.278.226-.449.18.067-.253.344-.342.578-.362.401-.05.823.041 1.21-.104.062-.038.213-.092.16-.18-.048-.07.123-.042.14-.123-.01-.103.079-.089.166-.098.39-.017.775.065 1.164.08.03.189-.181.322-.35.263-.081.013-.202-.185-.178-.04-.017.075-.005.175-.075.226m-3.318-.388c.09.083.153-.015.238-.051.283-.098.53-.268.773-.438.148-.122.276-.28.474-.32.386-.117.797-.102 1.185-.21.296-.405.797-.549 1.218-.781.094-.03.13-.107.16-.193.161-.254.38-.478.638-.631a.597.597 0 0 1 .407-.075c-.01.165-.105.311-.219.425.094-.002.174-.061.268-.058.033.17-.15.258-.247.364.054.012.261.028.148.082-.144.1-.308.169-.441.285.123.022.136.048.012.092-.068.046-.198.062-.21.151.092.057-.043.114-.095.132-.1.024-.205.067-.072.143-.05.076-.158.092-.246.084.027.086.065.182-.046.22-.25.19-.544.327-.858.358.393.03.797-.043 1.132-.256.045-.052.277-.109.147-.153-.061-.025-.192-.053-.201-.1.182-.112.41-.072.606-.139.005-.063-.149-.045-.206-.06-.137-.011-.129-.046.003-.059.167-.044.356-.053.496-.161-.114-.053-.258-.007-.38-.05.207-.09.45-.1.636-.235.084-.094-.108-.065-.164-.063-.115.02-.168-.034-.038-.082.222-.164.503-.27.66-.507.036-.053.086-.213-.032-.156-.155.052-.29.226-.467.172.347-.27.678-.576.916-.95.012-.107-.157-.118-.2-.034-.224.215-.426.47-.712.604.274-.264.5-.577.698-.902.042-.096.156-.212.094-.32-.1-.082-.224-.006-.276.092-.173.227-.305.492-.529.676.196-.373.398-.77.403-1.2 0-.089-.018-.22-.139-.203-.095.017-.072.16-.111.232-.087.294-.128.613-.305.87.04-.239.11-.488.056-.73-.025-.107-.2-.06-.177.046-.208 1.054-.915 1.976-1.84 2.509-.423.24-.896.394-1.377.464-.13.028-.27.011-.393.056-.3.23-.482.614-.861.735-.17.084-.392.101-.514.26a.137.137 0 0 0-.012.065z",
            fill: "#FFEC2D"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M12.213 14.48c-.056.1-.09.218-.161.309-.217-.197-.53-.19-.806-.204-.226-.012-.473-.033-.649-.195-.184-.151-.335-.347-.541-.47-.189-.051-.378-.115-.53-.244-.323-.264-.509-.655-.825-.927-.06-.06-.131-.106-.199-.156-.064.016-.035.154-.113.084-.043-.03-.15-.034-.16.009.097.127.194.272.207.435-.066.007-.183-.014-.215.01.087.132.2.248.327.341-.061.01-.182.005-.205.03.126.102.262.208.428.234.034.045-.05.131.02.17.041.016.175.044.083.09-.064.043-.04.143.041.14.051.027.167.033.176.079-.046.046-.187.101-.067.144a.832.832 0 0 0 .37.108c-.065.054-.144.085-.21.136.296.174.625.289.95.399.13.043.26.083.395.109a3.234 3.234 0 0 1-1.122-.296c-.184-.08-.37-.159-.558-.229.083-.043.178-.053.264-.09-.178-.036-.372-.048-.529-.146.024-.042.115-.044.165-.066.095-.023.154-.05.02-.059-.134-.036-.289-.02-.407-.1.008-.05.132-.032.182-.053.064-.011.134-.02.185-.063-.208-.087-.48-.025-.642-.209-.038-.07.116-.014.16-.025.112 0 .232.035.338-.01-.303-.133-.628-.257-.859-.503-.025-.04-.102-.148-.04-.161.18.023.31.22.502.19.026-.035-.112-.092-.146-.14-.28-.242-.552-.503-.749-.818-.014-.105.152-.121.196-.04.214.207.408.448.675.589.095.046-.055-.054-.074-.09a4.777 4.777 0 0 1-.655-.928c-.03-.06-.082-.17.01-.203.093-.046.185.017.231.096.182.229.315.5.542.692-.193-.374-.399-.768-.404-1.198.005-.083.01-.21.123-.206.095-.014.08.107.111.165.094.316.135.658.322.937-.041-.234-.102-.476-.062-.714.01-.078.098-.102.155-.054.047.113.056.254.099.376.24.824.782 1.549 1.487 2.035.58.399 1.27.636 1.973.678.063.005.127.007.19.011M11.32 15.572a.038.038 0 1 0 0-.076.038.038 0 0 0 0 .076z",
            fill: "#FFEC2D"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M11.317 15.544a.015.015 0 0 0 .015-.016.015.015 0 0 0-.03 0c0 .009.006.016.015.016z",
            fill: "#FFEC2D",
            stroke: "#FFEC2D",
            strokeWidth: ".191"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M1.92 5.167s-.154-.13-.206-.065c-.084.105.258.624.258.807 0 .3-.2.381-.447.424-.166.03-.436-.012-.436-.012.05-.068.084-.088.17-.094a.357.357 0 0 1-.193-.324c0-.258.106-.365.106-.656 0-.161-.133-.367-.133-.367.235.023.35.24.285.413a.114.114 0 0 0 .1-.03c.017.048-.01.103-.046.152.029.015.05.006.097-.004-.005.05-.034.102-.107.152.21-.055.34.092.34.245 0 .116-.081.2-.16.2a.162.162 0 0 1-.085-.027c-.015.032-.008.074.008.106-.058-.015-.095-.05-.07-.122a.148.148 0 0 1-.104-.048.125.125 0 0 1 .105-.048c-.033-.067.004-.104.056-.135 0 0-.033.135.053.135.038 0 .074-.012.074-.07 0-.049-.044-.117-.144-.113-.1.004-.181.07-.181.229 0 .147.119.22.275.226.142.004.248-.073.248-.218 0-.195-.28-.637-.28-.81 0-.13.117-.202.231-.202.148 0 .273.147.273.147l-.087.109z",
            fill: "#FFEC2D"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M1.952 8.674c0 .325-.29.491-.52.491-.308 0-.472-.184-.472-.425 0-.137.025-.223.088-.354l.707-1.466a.431.431 0 0 0 .032-.194c0-.132-.127-.24-.261-.243-.122-.003-.255.114-.255.247 0 .161.084.233.17.233.106 0 .148-.043.148-.117 0-.052-.025-.075-.06-.075-.092 0-.066.123-.066.123a.083.083 0 0 1-.061-.114.164.164 0 0 1-.088-.052.165.165 0 0 1 .088-.048c-.021-.07.007-.105.068-.12a.122.122 0 0 0-.008.076c.096-.027.245.016.245.183 0 .166-.115.306-.331.271.051.025.077.075.082.13-.039-.014-.082-.017-.082-.017.025.045.06.083.059.17-.04-.018-.078-.051-.129-.03.08.158-.018.376-.27.428a.523.523 0 0 0 .137-.34c0-.377-.104-.44-.104-.701 0-.11.056-.228.167-.308v.005a.223.223 0 0 1-.147-.106c.168-.047.412-.047.544.005.15.018.256.133.287.192a.581.581 0 0 1 0 .463l-.718 1.523a.5.5 0 0 0-.05.214c0 .192.176.26.276.26.12 0 .242-.092.242-.206 0-.072-.04-.115-.096-.115-.136 0-.127.115-.1.187-.085-.037-.133-.105-.12-.176a.216.216 0 0 1-.135-.077c.033-.041.073-.073.135-.074-.027-.11.047-.157.12-.183-.023.081-.038.174.1.174.1 0 .18.018.226.083l.011-.432c.006-.13-.173-.126-.287-.087.043-.15.13-.23.335-.21a.161.161 0 0 1-.102-.157c0-.121.098-.256.163-.296l.032 1.265z",
            fill: "#FFEC2D"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M1.952 9.647c0-.324-.29-.491-.52-.491-.308 0-.472.184-.472.426 0 .136.025.222.088.353l.707 1.466c.024.052.032.11.032.195 0 .131-.127.239-.261.242-.122.003-.255-.114-.255-.247 0-.161.084-.233.17-.233.106 0 .148.043.148.118 0 .051-.025.074-.06.074-.092 0-.066-.122-.066-.122a.083.083 0 0 0-.061.113.164.164 0 0 0-.088.053.165.165 0 0 0 .088.048c-.021.07.007.104.068.119a.122.122 0 0 1-.008-.076c.096.028.245-.016.245-.183 0-.166-.115-.306-.331-.27.051-.025.077-.075.082-.132-.039.016-.082.018-.082.018.025-.045.06-.083.059-.17-.04.018-.078.051-.129.03.08-.158-.018-.376-.27-.428a.523.523 0 0 1 .137.34c0 .377-.104.44-.104.701 0 .11.056.228.167.308v-.004A.223.223 0 0 0 1.09 12c.168.048.412.047.544-.005a.404.404 0 0 0 .287-.192.581.581 0 0 0 0-.463l-.718-1.523a.5.5 0 0 1-.05-.214c0-.192.176-.26.276-.26.12 0 .242.092.242.206 0 .072-.04.116-.096.116-.136 0-.127-.116-.1-.188-.085.038-.133.105-.12.177a.216.216 0 0 0-.135.076c.033.042.073.073.135.074-.027.11.047.158.12.183-.023-.08-.038-.174.1-.174.1 0 .18-.018.226-.083l.011.432c.006.13-.173.126-.287.087.043.15.13.23.335.21a.161.161 0 0 0-.102.157c0 .122.098.256.163.296l.032-1.265zM1.92 5.167s.154-.13.206-.065c.084.105-.258.624-.258.807 0 .3.2.381.447.424.166.03.436-.012.436-.012-.05-.068-.084-.088-.17-.094a.357.357 0 0 0 .193-.324c0-.258-.106-.365-.106-.656 0-.161.133-.367.133-.367-.235.023-.35.24-.285.413a.114.114 0 0 1-.1-.03c-.017.048.01.103.046.152-.029.015-.05.006-.097-.004.005.05.034.102.107.152-.21-.055-.34.092-.34.245 0 .116.081.2.16.2.026 0 .064-.011.085-.027.015.032.008.074-.008.106.058-.015.095-.05.07-.122a.148.148 0 0 0 .104-.048.125.125 0 0 0-.105-.048c.033-.067-.004-.104-.056-.135 0 0 .033.135-.053.135-.038 0-.074-.012-.074-.07 0-.049.044-.117.144-.113.1.004.181.07.181.229 0 .147-.119.22-.275.226-.142.004-.248-.073-.248-.218 0-.195.28-.637.28-.81 0-.13-.117-.202-.231-.202-.148 0-.273.147-.273.147l.087.109z",
            fill: "#FFEC2D"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M1.888 8.674c0 .325.29.491.52.491.308 0 .472-.184.472-.425a.718.718 0 0 0-.088-.354L2.085 6.92a.431.431 0 0 1-.032-.194c0-.132.127-.24.261-.243.122-.003.255.114.255.247 0 .161-.084.233-.17.233-.106 0-.148-.043-.148-.117 0-.052.025-.075.06-.075.092 0 .066.123.066.123a.083.083 0 0 0 .061-.114.164.164 0 0 0 .088-.052.165.165 0 0 0-.088-.048c.021-.07-.007-.105-.068-.12a.122.122 0 0 1 .008.076c-.096-.027-.245.016-.245.183 0 .166.115.306.331.271-.051.025-.077.075-.082.13.039-.014.082-.017.082-.017-.025.045-.06.083-.059.17.04-.018.078-.051.129-.03-.08.158.018.376.27.428a.523.523 0 0 1-.137-.34c0-.377.104-.44.104-.701a.386.386 0 0 0-.167-.308v.005a.223.223 0 0 0 .148-.106c-.169-.047-.413-.047-.545.005a.403.403 0 0 0-.287.192.581.581 0 0 0 0 .463l.718 1.523a.5.5 0 0 1 .05.214c0 .192-.176.26-.276.26-.12 0-.242-.092-.242-.206 0-.072.04-.115.096-.115.136 0 .127.115.1.187.085-.037.133-.105.12-.176a.216.216 0 0 0 .135-.077c-.033-.041-.073-.073-.135-.074.027-.11-.047-.157-.12-.183.023.081.038.174-.1.174-.1 0-.18.018-.226.083l-.011-.432c-.006-.13.173-.126.287-.087-.043-.15-.13-.23-.335-.21a.161.161 0 0 0 .102-.157.411.411 0 0 0-.163-.296l-.032 1.265z",
            fill: "#FFEC2D"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M1.888 9.647c0-.324.29-.491.52-.491.308 0 .472.184.472.426a.718.718 0 0 1-.088.353l-.707 1.466a.431.431 0 0 0-.032.195c0 .131.127.239.261.242.122.003.255-.114.255-.247 0-.161-.084-.233-.17-.233-.106 0-.148.043-.148.118 0 .051.025.074.06.074.092 0 .066-.122.066-.122.045.01.082.056.061.113a.163.163 0 0 1 .088.053.165.165 0 0 1-.088.048c.021.07-.007.104-.068.119a.122.122 0 0 0 .008-.076c-.096.028-.245-.016-.245-.183 0-.166.115-.306.331-.27-.051-.025-.077-.075-.082-.132.039.016.082.018.082.018-.025-.045-.06-.083-.059-.17.04.018.078.051.129.03-.08-.158.018-.376.27-.428a.523.523 0 0 0-.137.34c0 .377.104.44.104.701 0 .11-.056.228-.167.308v-.004c.073.02.12.056.148.105-.169.048-.413.047-.545-.005a.404.404 0 0 1-.287-.192.581.581 0 0 1 0-.463l.718-1.523a.5.5 0 0 0 .05-.214c0-.192-.176-.26-.276-.26-.12 0-.242.092-.242.206 0 .072.04.116.096.116.136 0 .127-.116.1-.188.085.038.133.105.12.177.048.006.093.029.135.076-.033.042-.073.073-.135.074.027.11-.047.158-.12.183.023-.08.038-.174-.1-.174-.1 0-.18-.018-.226-.083l-.011.432c-.006.13.173.126.287.087-.043.15-.13.23-.335.21.05.02.102.067.102.157a.411.411 0 0 1-.163.296l-.032-1.265zM1.92 18.833s-.154.13-.206.065c-.084-.105.258-.624.258-.807 0-.3-.2-.382-.447-.424a1.757 1.757 0 0 0-.436.012c.05.068.084.088.17.094a.357.357 0 0 0-.193.324c0 .258.106.365.106.656 0 .161-.133.367-.133.367.235-.023.35-.24.285-.413a.114.114 0 0 1 .1.03c.017-.048-.01-.103-.046-.151.029-.016.05-.007.097.003-.005-.05-.034-.102-.107-.152.21.055.34-.092.34-.245 0-.116-.081-.2-.16-.2a.162.162 0 0 0-.085.027c-.015-.032-.008-.074.008-.106-.058.015-.095.05-.07.122a.148.148 0 0 0-.104.048c.025.031.062.049.105.048-.033.067.004.104.056.135 0 0-.033-.135.053-.135.038 0 .074.012.074.07 0 .049-.044.117-.144.113-.1-.005-.181-.07-.181-.229 0-.148.119-.22.275-.226.142-.004.248.073.248.218 0 .194-.28.637-.28.81 0 .13.117.202.231.202.148 0 .273-.147.273-.147l-.087-.109z",
            fill: "#FFEC2D"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M1.952 15.326c0-.325-.29-.491-.52-.491-.308 0-.472.184-.472.425 0 .137.025.223.088.354l.707 1.466c.024.051.032.11.032.194 0 .132-.127.24-.261.243-.122.003-.255-.114-.255-.247 0-.161.084-.233.17-.233.106 0 .148.043.148.117 0 .052-.025.075-.06.075-.092 0-.066-.123-.066-.123a.083.083 0 0 0-.061.114.164.164 0 0 0-.088.052.165.165 0 0 0 .088.048c-.021.07.007.105.068.12a.122.122 0 0 1-.008-.076c.096.027.245-.016.245-.183 0-.166-.115-.306-.331-.271.051-.024.077-.075.082-.13a.3.3 0 0 1-.082.017c.025-.045.06-.083.059-.17-.04.018-.078.051-.129.03.08-.159-.018-.376-.27-.428a.523.523 0 0 1 .137.34c0 .377-.104.44-.104.701 0 .11.056.227.167.308v-.005a.223.223 0 0 0-.147.106c.168.047.412.047.544-.005a.403.403 0 0 0 .287-.192.581.581 0 0 0 0-.463l-.718-1.523a.5.5 0 0 1-.05-.214c0-.192.176-.26.276-.26.12 0 .242.092.242.206 0 .072-.04.115-.096.115-.136 0-.127-.115-.1-.187-.085.037-.133.105-.12.176a.216.216 0 0 0-.135.077c.033.041.073.073.135.074-.027.11.047.157.12.183-.023-.081-.038-.174.1-.174.1 0 .18-.018.226-.083l.011.432c.006.13-.173.126-.287.087.043.15.13.23.335.21a.16.16 0 0 0-.102.157c0 .121.098.256.163.296l.032-1.265z",
            fill: "#FFEC2D"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M1.952 14.353c0 .324-.29.491-.52.491-.308 0-.472-.184-.472-.426 0-.136.025-.222.088-.353l.707-1.466a.431.431 0 0 0 .032-.195c0-.131-.127-.239-.261-.242-.122-.003-.255.114-.255.247 0 .161.084.233.17.233.106 0 .148-.043.148-.118 0-.051-.025-.074-.06-.074-.092 0-.066.122-.066.122a.083.083 0 0 1-.061-.113.163.163 0 0 1-.088-.053.165.165 0 0 1 .088-.048c-.021-.07.007-.104.068-.119a.122.122 0 0 0-.008.076c.096-.028.245.016.245.183 0 .166-.115.306-.331.27.051.025.077.075.082.132-.039-.016-.082-.018-.082-.018.025.045.06.083.059.17-.04-.018-.078-.051-.129-.03.08.158-.018.376-.27.428a.523.523 0 0 0 .137-.34c0-.377-.104-.44-.104-.701 0-.11.056-.228.167-.308v.004A.223.223 0 0 1 1.09 12c.168-.048.412-.047.544.005.15.017.256.133.287.192a.581.581 0 0 1 0 .463l-.718 1.523a.5.5 0 0 0-.05.214c0 .192.176.26.276.26.12 0 .242-.092.242-.206 0-.072-.04-.116-.096-.116-.136 0-.127.116-.1.188-.085-.038-.133-.105-.12-.177a.216.216 0 0 1-.135-.076c.033-.042.073-.073.135-.074-.027-.11.047-.158.12-.184-.023.082-.038.175.1.175.1 0 .18.018.226.083l.011-.432c.006-.13-.173-.126-.287-.087.043-.15.13-.23.335-.21a.16.16 0 0 1-.102-.157.41.41 0 0 1 .163-.296l.032 1.265zM1.92 18.833s.154.13.206.065c.084-.105-.258-.624-.258-.807 0-.3.2-.382.447-.424.166-.03.436.012.436.012-.05.068-.084.088-.17.094.096.05.193.157.193.324 0 .258-.106.365-.106.656 0 .161.133.367.133.367-.235-.023-.35-.24-.285-.413a.114.114 0 0 0-.1.03c-.017-.048.01-.103.046-.151-.029-.016-.05-.007-.097.003.005-.05.034-.102.107-.152-.21.055-.34-.092-.34-.245 0-.116.081-.2.16-.2.026 0 .064.011.085.027.015-.032.008-.074-.008-.106.058.015.095.05.07.122.044.004.08.019.104.048a.125.125 0 0 1-.105.048c.033.067-.004.104-.056.135 0 0 .033-.135-.053-.135-.038 0-.074.012-.074.07 0 .049.044.117.144.113.1-.005.181-.07.181-.229 0-.148-.119-.22-.275-.226-.142-.004-.248.073-.248.218 0 .194.28.637.28.81 0 .13-.117.202-.231.202-.148 0-.273-.147-.273-.147l.087-.109z",
            fill: "#FFEC2D"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M1.888 15.326c0-.325.29-.491.52-.491.308 0 .472.184.472.425a.718.718 0 0 1-.088.354l-.707 1.466a.431.431 0 0 0-.032.194c0 .132.127.24.261.243.122.003.255-.114.255-.247 0-.161-.084-.233-.17-.233-.106 0-.148.043-.148.117 0 .052.025.075.06.075.092 0 .066-.123.066-.123.045.01.082.056.061.114a.164.164 0 0 1 .088.052.165.165 0 0 1-.088.048c.021.07-.007.105-.068.12a.122.122 0 0 0 .008-.076c-.096.027-.245-.016-.245-.183 0-.166.115-.306.331-.271-.051-.024-.077-.075-.082-.13.039.014.082.017.082.017-.025-.045-.06-.083-.059-.17.04.018.078.051.129.03-.08-.159.018-.376.27-.428a.523.523 0 0 0-.137.34c0 .377.104.44.104.701 0 .11-.056.227-.167.308v-.005c.073.02.12.056.148.106-.169.047-.413.047-.545-.005a.403.403 0 0 1-.287-.192.581.581 0 0 1 0-.463l.718-1.523a.499.499 0 0 0 .05-.214c0-.192-.176-.26-.276-.26-.12 0-.242.092-.242.206 0 .072.04.115.096.115.136 0 .127-.115.1-.187.085.037.133.105.12.176.048.007.093.03.135.077-.033.041-.073.073-.135.074.027.11-.047.157-.12.183.023-.081.038-.174-.1-.174-.1 0-.18-.018-.226-.083l-.011.432c-.006.13.173.126.287.087-.043.15-.13.23-.335.21a.16.16 0 0 1 .102.157.411.411 0 0 1-.163.296l-.032-1.265z",
            fill: "#FFEC2D"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M1.888 14.353c0 .324.29.491.52.491.308 0 .472-.184.472-.426a.718.718 0 0 0-.088-.353l-.707-1.466a.431.431 0 0 1-.032-.195c0-.131.127-.239.261-.242.122-.003.255.114.255.247 0 .161-.084.233-.17.233-.106 0-.148-.043-.148-.118 0-.051.025-.074.06-.074.092 0 .066.122.066.122a.083.083 0 0 0 .061-.113.163.163 0 0 0 .088-.053.165.165 0 0 0-.088-.048c.021-.07-.007-.104-.068-.119a.122.122 0 0 1 .008.076c-.096-.028-.245.016-.245.183 0 .166.115.306.331.27-.051.025-.077.075-.082.132.039-.016.082-.018.082-.018-.025.045-.06.083-.059.17.04-.018.078-.051.129-.03-.08.158.018.376.27.428a.523.523 0 0 1-.137-.34c0-.377.104-.44.104-.701a.386.386 0 0 0-.167-.308v.004A.223.223 0 0 0 2.752 12c-.169-.048-.413-.047-.545.005a.404.404 0 0 0-.287.192.581.581 0 0 0 0 .463l.718 1.523a.5.5 0 0 1 .05.214c0 .192-.176.26-.276.26-.12 0-.242-.092-.242-.206 0-.072.04-.116.096-.116.136 0 .127.116.1.188.085-.038.133-.105.12-.177a.216.216 0 0 0 .135-.076c-.033-.042-.073-.073-.135-.074.027-.11-.047-.158-.12-.184.023.082.038.175-.1.175-.1 0-.18.018-.226.083l-.011-.432c-.006-.13.173-.126.287-.087-.043-.15-.13-.23-.335-.21a.16.16 0 0 0 .102-.157.411.411 0 0 0-.163-.296l-.032 1.265z",
            fill: "#FFEC2D"
          })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_27784_1615"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "24",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'lightbulb':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "lightbulb"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_22109",
            transform: "translate(32)"
          }, /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_22107"
          }, /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_22106"
          }, /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_22101"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_9399",
            d: "M-20 6c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1s-1 .4-1 1v2c0 .6.4 1 1 1z"
          })), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_22102"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_9400",
            d: "M-10 12h-2c-.6 0-1 .4-1 1s.4 1 1 1h2c.6 0 1-.4 1-1s-.4-1-1-1z"
          })), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_22103"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_9401",
            d: "M-28 12h-2c-.6 0-1 .4-1 1s.4 1 1 1h2c.6 0 1-.4 1-1s-.4-1-1-1z"
          })), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_22104"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_9402",
            d: "M-25.3 6.4L-26.8 5c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l1.4 1.4c.2.2.5.3.7.3.3 0 .5-.1.7-.3.5-.4.5-1 .1-1.4z"
          })), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_22105"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_9403",
            d: "M-11.8 5.1c-.4-.4-1-.4-1.4 0l-1.4 1.4c-.4.4-.4 1 0 1.4.2.2.4.3.7.3.3 0 .5-.1.7-.3l1.4-1.4c.4-.4.4-1.1 0-1.4z"
          })))), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_22108"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_9404",
            d: "M-19 22h-2c-1.1 0-2-.9-2-2v-1.8c-2.2-1.3-3.3-3.8-2.9-6.2.4-2.4 2.2-4.3 4.6-4.8 1.8-.4 3.6.1 5.1 1.2 1.4 1.1 2.2 2.8 2.2 4.7 0 2.1-1.1 4.1-3 5.2V20c0 1.1-.9 2-2 2zm-1-13c-.3 0-.6 0-.9.1-1.6.4-2.8 1.6-3.1 3.2-.3 1.8.6 3.6 2.3 4.4.4.2.6.5.6.9V20h2v-2.4c0-.4.2-.8.6-.9 1.6-.7 2.5-2.1 2.5-3.7 0-1.2-.5-2.3-1.5-3.1-.7-.6-1.6-.9-2.5-.9z"
          }))));
        case 'list':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "list",
            xmlnsXlink: "http://www.w3.org/1999/xlink"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            transform: "translate(2 3)",
            id: "Group_15788"
          }, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("path", {
            id: "SVGID_1_",
            d: "M0 0h20v18H0z"
          })), /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "SVGID_00000044857568974627517190000006335057270740221886_"
          }, /*#__PURE__*/_react.default.createElement("use", {
            xlinkHref: "#SVGID_1_",
            overflow: "visible"
          })), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15787",
            clipPath: "url(#SVGID_00000044857568974627517190000006335057270740221886_)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8453",
            d: "M19 3H7c-.6 0-1-.4-1-1s.4-1 1-1h12c.6 0 1 .4 1 1s-.4 1-1 1"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8454",
            d: "M19 10.1H7c-.6 0-1-.4-1-1s.4-1 1-1h12c.6 0 1 .4 1 1s-.4 1-1 1"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8455",
            d: "M19 17H7c-.6 0-1-.4-1-1s.4-1 1-1h12c.6 0 1 .4 1 1s-.4 1-1 1"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8456",
            d: "M0 2C0 .9.9 0 2 0s2 .9 2 2-.9 2-2 2-2-.9-2-2"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8457",
            d: "M0 9c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8458",
            d: "M0 16c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2"
          }))));
        case 'lock':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "lock"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10850",
            transform: "translate(-1024.5 -661.806)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4622",
            d: "M1043.5 669.8h-3v-2.1c0-2.2-1.8-4-4-4s-4 1.8-4 4v2.1h-3c-.6 0-1 .4-1 1v12c0 .6.4 1 1 1h14c.6 0 1-.4 1-1v-12c0-.5-.4-1-1-1zm-9-2.1c.1-1.1 1.1-1.9 2.2-1.8 1 .1 1.8.9 1.8 1.8v2.1h-4v-2.1zm8 14.1h-12v-10h12v10z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4623",
            d: "M1036.5 673.8c-1.1 0-2 .9-2 2 0 .7.4 1.4 1 1.7v1.3c0 .6.4 1 1 1s1-.4 1-1v-1.3c1-.5 1.3-1.8.7-2.7-.3-.6-1-1-1.7-1z"
          })));
        case 'lock-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "lock-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "lock-alt-2",
            d: "M5 21V8.1h3.1V6.7C8.2 4.5 10 2.9 12.2 3c2 .1 3.6 1.7 3.7 3.7v1.4H19V21H5zm1.6-1.5h10.9V9.7H6.6v9.8zm7.7-11.4V6.7c-.1-1.2-1.1-2.2-2.3-2.2-1.2 0-2.3.9-2.3 2.2v1.4h4.6zm-3.1 9v-1.5c-.9-.4-1.3-1.5-.9-2.4.4-.9 1.5-1.3 2.4-.9.9.4 1.3 1.5.9 2.4-.2.4-.5.7-.9.9v1.5h-1.5z"
          }));
        case 'lock-open':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "lock-open"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Union_20",
            d: "M5 22c-.6 0-1-.4-1-1V9c0-.6.4-1 1-1h3V5.9C8 3.7 9.8 2 12 2s4 1.7 4 3.9c0 .6-.4 1-1 1s-1-.4-1-1c0-1.1-.9-1.9-2-1.9s-2 .8-2 1.9V8h9c.6 0 1 .4 1 1v12c0 .6-.4 1-1 1H5zm1-2h12V10H6v10zm5-3v-1.3c-.6-.4-1-1-1-1.7 0-1.1.9-2 2-2s2 .9 2 2c0 .7-.4 1.4-1 1.7V17c0 .6-.4 1-1 1s-1-.4-1-1z"
          }));
        case 'lock-open-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "lock-open-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "lock-open-alt-2",
            d: "M5 21V8.2h3.1V5.7C8.2 3.5 10 1.9 12.2 2c2 .1 3.6 1.7 3.7 3.7 0 .4-.3.7-.7.7h-.1c-.4 0-.7-.3-.7-.7-.1-1.2-1.1-2.2-2.3-2.2-1.2 0-2.3.9-2.3 2.2v2.5H19V21H5zm1.6-1.5h10.9V9.7H6.6v9.8zm4.6-2.4v-1.5c-.9-.4-1.3-1.5-.9-2.4s1.5-1.3 2.4-.9c.9.4 1.3 1.5.9 2.4-.2.4-.5.7-.9.9v1.5h-1.5z"
          }));
        case 'lock-open-check':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M18.494 8.563H9.297V4.936a2.694 2.694 0 0 1 2.698-2.688 2.7 2.7 0 0 1 2.698 2.688v.998h2.006v-.998c0-2.588-2.106-4.686-4.704-4.686S7.291 2.358 7.291 4.936v3.627H5.506c-1.103 0-2.006.9-2.006 1.998v11.19c0 1.1.903 1.999 2.006 1.999h12.988c1.103 0 2.006-.9 2.006-1.998v-11.19a2.008 2.008 0 0 0-2.006-2zM5.506 21.752v-11.19h12.988v11.19H5.506z",
            fill: "#000"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M14.68 13.591l-3.516 3.501-1.6-1.592a1.001 1.001 0 0 0-1.414 0 .992.992 0 0 0 0 1.409l2.312 2.301c.19.19.441.29.712.29.271 0 .522-.11.712-.29L16.114 15a.992.992 0 0 0 0-1.409 1.001 1.001 0 0 0-1.414 0h-.02z",
            fill: "#000"
          }));
        case 'loveseat':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "loveseat"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4718",
            d: "M21 11h-2V5c0-1.7-1.3-3-3-3H8C6.3 2 5 3.3 5 5v6H3c-1.1 0-2 .9-2 2v7c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-7c0-1.1-.9-2-2-2zM7 5c0-.6.4-1 1-1h8c.6 0 1 .4 1 1v9H7V5zm-4 8h2v7H3v-7zm4 3h10v4H7v-4zm12 4v-7h2v7h-2z"
          }));
        case 'LYD':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_27784_1624)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 4H0v16h24V4z",
            fill: "#239E46"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 4H0v12h24V4z",
            fill: "#000"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 4H0v4h24V4z",
            fill: "#E70013"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M11 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M11.404 13.738a1.738 1.738 0 1 0 0-3.476 1.738 1.738 0 0 0 0 3.476z",
            fill: "#000"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M11.973 12l2.69-.874L13 13.414v-2.828l1.662 2.288-2.69-.874z",
            fill: "#fff"
          })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_27784_1624"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "24",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'MAD':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_27784_1793)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M0 4h24v16H0V4z",
            fill: "#C1272D"
          }), /*#__PURE__*/_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 7.806l.941 2.898h3.047l-2.465 1.791.942 2.898L12 13.602l-2.465 1.79.942-2.897-2.465-1.79h3.046L12 7.805zm-1.104 3.398H9.55l1.09.791.256-.79zm.168 1.1l.358-1.1h1.156l.358 1.1-.936.68-.936-.68zm-.162.5l-.416 1.28 1.089-.791-.673-.489zm1.523.489l1.089.79-.416-1.279-.673.489zm.936-1.298l1.088-.79h-1.345l.257.79zm-.945-1.29h-.832L12 9.424l.416 1.28z",
            fill: "#006233"
          })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_27784_1793"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "24",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'mail':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "mail"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4654",
            d: "M23 3.9v-.2c0-.1-.1-.1-.1-.2 0 0 0-.1-.1-.1-.1-.1-.1-.1-.2-.1l-.1-.1H2C1.9 3 1.8 3 1.8 3h-.2l-.1.1c-.1 0-.1.1-.2.1l-.1.1c0 .1-.1.1-.1.2v16.3c0 .6.4 1 1 1h20c.6 0 1-.4 1-1V4l-.1-.1zM19.4 5L12 11.7 4.6 5h14.8zM3 19V6.2l8.3 7.5c.4.3 1 .3 1.3 0L21 6.2V19H3z"
          }));
        case 'mail-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "mail-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "mail-alt-2",
            d: "M1 3.5v17h22v-17H1zm18.1 2L12 11.2 4.9 5.5h14.2zM3 18.5V6.6l9 7.2 9-7.2v11.9H3z"
          }));
        case 'map-marker-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "map-marker-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "map-marker-alt-2",
            d: "M11.3 22.2c-.2-.2-4.7-5-6.2-6.7C2 11.9 2.4 6.4 6 3.2c.1 0 .1-.1.2-.1C10-.1 15.6.4 18.9 4.1 20.2 5.7 21 7.8 21 9.9c0 2-.7 4-2 5.6-1.5 1.8-6.1 6.6-6.2 6.8l-.8.7-.7-.8zM5 9.9c0 1.6.6 3.2 1.6 4.4 1.1 1.3 4 4.4 5.4 5.9 1.4-1.5 4.3-4.6 5.4-6 2.4-2.9 2-7.1-.8-9.6-.1-.1-.1-.1-.2-.1-3-2.4-7.4-2-9.9 1C5.6 6.7 5 8.3 5 9.9zm5 .1c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2c-1.1-.1-2-.9-2-2z"
          }));
        case 'mars':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "mars"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4729",
            d: "M21 2h-5.7c-.6 0-1 .4-1 1s.4 1 1 1h3.3l-5.4 5.4c-3.1-2.3-7.5-1.7-9.8 1.4s-1.7 7.5 1.4 9.8c3.1 2.3 7.5 1.7 9.8-1.4 1.9-2.5 1.9-5.9 0-8.4L20 5.4v3.3c0 .6.4 1 1 1s1-.4 1-1V3c0-.6-.4-1-1-1zm-8.5 16.5c-2 2-5.1 2-7.1 0s-2-5.1 0-7.1 5.1-2 7.1 0c.9.9 1.5 2.2 1.5 3.5 0 1.4-.5 2.7-1.5 3.6z"
          }));
        case 'megaphone-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "megaphone-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4419",
            d: "M0 17.8l1.5-1.5 6.2 6.2L6.2 24 0 17.8z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4420",
            d: "M17.2 15.5L24 11 12.9 0 2.5 16.2l5.2 5.3 3.2-2.1.3.4c.7 1 1.8 1.6 3 1.5.7 0 1.4-.2 2-.6.8-.5 1.4-1.4 1.6-2.4.2-1 0-2-.6-2.8zM15.9 18c-.1.4-.3.8-.7 1-.7.5-1.7.3-2.3-.4l-.2-.3 2.8-1.8.1.2c.3.4.4.9.3 1.3zm-7.8.9l-2.9-3 8.1-12.7 7.4 7.4-12.6 8.3z"
          }));
        case 'meh':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M11.995 22.99A10.994 10.994 0 0 1 4.217 4.217a11 11 0 1 1 7.778 18.773zM5.631 5.631a9 9 0 1 0 12.728 0 9.012 9.012 0 0 0-12.728 0z",
            fill: "#000"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M8.495 10.996a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM15.495 10.996a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM7 15a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1z",
            fill: "#000"
          }));
        case 'menu':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "menu"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10691",
            transform: "translate(-1100.5 -406.806)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4475",
            d: "M1122.5 411.8h-20c-.6 0-1-.4-1-1s.4-1 1-1h20c.6 0 1 .4 1 1s-.4 1-1 1z"
          })), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10692",
            transform: "translate(-1100.5 -406.806)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4476",
            d: "M1122.5 419.8h-20c-.6 0-1-.4-1-1s.4-1 1-1h20c.6 0 1 .4 1 1s-.4 1-1 1z"
          })), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10693",
            transform: "translate(-1100.5 -406.806)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4477",
            d: "M1122.5 427.8h-20c-.6 0-1-.4-1-1s.4-1 1-1h20c.6 0 1 .4 1 1s-.4 1-1 1z"
          })));
        case 'menu-arrow':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "menu-arrow"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4421",
            d: "M2 4h20c.5 0 1-.4 1-.9V3c0-.5-.4-1-.9-1H2c-.5 0-1 .4-1 .9V3c0 .5.4 1 .9 1H2z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4422",
            d: "M22 10H2c-.5 0-1 .4-1 .9v.1c0 .5.4 1 .9 1H22c.5 0 1-.4 1-.9V11c0-.5-.4-1-.9-1H22z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4423",
            d: "M10 18H2c-.6 0-1 .4-1 1s.4 1 1 1h8c.6 0 1-.4 1-1s-.4-1-1-1z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4424",
            d: "M22.7 18.3l-3-3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l1.3 1.3H14c-.6 0-1 .4-1 1s.4 1 1 1h5.6l-1.3 1.3c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l3-3c.3-.3.4-.7.2-1.1 0-.1-.1-.2-.2-.3z"
          }));
        case 'menu-favorites':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_5678_59)",
            fill: "#000"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M.733 3.499h20.532c.406 0 .734-.448.734-1 0-.551-.328-.999-.734-.999H.733C.328 1.5 0 1.948 0 2.5c0 .551.328.999.733.999zM21.266 8.098H.734c-.405 0-.733.447-.733.999s.328 1 .733 1h20.532c.406 0 .734-.448.734-1s-.328-1-.734-1zM11 14.697H1a1 1 0 0 0-.707 1.706 1 1 0 0 0 .707.293h10a1 1 0 1 0 0-1.999zM11 20.501H1a1 1 0 0 0-.707 1.706A1 1 0 0 0 1 22.5h10a1 1 0 1 0 0-1.999zM20.13 13.918l.845 1.784a.71.71 0 0 0 .53.4l1.889.285a.745.745 0 0 1 .39 1.255l-1.366 1.389a.758.758 0 0 0-.2.65l.323 1.961a.711.711 0 0 1-1.023.776l-1.69-.926a.68.68 0 0 0-.655 0l-1.69.926a.712.712 0 0 1-1.023-.776l.323-1.96a.757.757 0 0 0-.2-.651l-1.367-1.39a.743.743 0 0 1 .39-1.254l1.889-.285a.708.708 0 0 0 .53-.4l.845-1.784a.694.694 0 0 1 1.268 0h-.007z"
          })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_5678_59"
          }, /*#__PURE__*/_react.default.createElement("path", {
            fill: "#fff",
            d: "M0 0h24v24H0z"
          }))));
        case 'menu-related-actions':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_5678_29)",
            fill: "#000"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M5.451 0H1a1 1 0 0 0-1 1v4.452a1 1 0 0 0 1 1h4.451a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM5.451 14.839H1a1 1 0 0 0-1 1v4.452a1 1 0 0 0 1 1h4.451a1 1 0 0 0 1-1v-4.452a1 1 0 0 0-1-1zM12.871 6.451H8.42a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h4.452a1 1 0 0 1 1 1v4.451a1 1 0 0 1-1 1zm-3.452-2h2.452V2H9.42v2.451zM20.29 0h-4.451a1 1 0 0 0-1 1v4.452a1 1 0 0 0 1 1h4.451a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM5.45 13.871H1a1 1 0 0 1-1-1V8.419a1 1 0 0 1 1-1h4.45a1 1 0 0 1 1 1v4.452a1 1 0 0 1-1 1zm-3.45-2h2.45V9.419H2v2.452zM12.871 13.871H8.42a1 1 0 0 1-1-1V8.419a1 1 0 0 1 1-1h4.452a1 1 0 0 1 1 1v4.452a1 1 0 0 1-1 1zm-3.452-2h2.452V9.419H9.42v2.452zM12.871 21.294H8.42a1 1 0 0 1-1-1v-4.452a1 1 0 0 1 1-1h4.452a1 1 0 0 1 1 1v4.452a1 1 0 0 1-1 1zm-3.452-2h2.452v-2.452H9.42v2.452zM20.29 13.871h-4.45a1 1 0 0 1-1-1V8.419a1 1 0 0 1 1-1h4.45a1 1 0 0 1 1 1v4.452a1 1 0 0 1-1 1zm-3.45-2h2.45V9.419h-2.45v2.452z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M23.999 17.693a6.306 6.306 0 1 1-12.612 0 6.306 6.306 0 0 1 12.612 0zm-9.737 1.633a1.797 1.797 0 0 0 1.802 1.797c.478 0 .936-.189 1.275-.525l.429-.428a.411.411 0 0 0-.295-.691.413.413 0 0 0-.288.107l-.43.428a1.006 1.006 0 0 1-1.382 0 .98.98 0 0 1 0-1.383l1.259-1.258a.98.98 0 0 1 1.382 0 .417.417 0 0 0 .584 0 .414.414 0 0 0 .09-.45.407.407 0 0 0-.09-.134 1.8 1.8 0 0 0-2.546 0l-1.263 1.264a1.802 1.802 0 0 0-.527 1.273zm2.405-1.017c0 .109.044.212.122.289a1.798 1.798 0 0 0 2.544 0l1.264-1.264a1.8 1.8 0 0 0-.002-2.549 1.801 1.801 0 0 0-2.547.002l-.393.395a.412.412 0 0 0 .297.685.411.411 0 0 0 .286-.107l.394-.389a.979.979 0 0 1 1.382 1.383l-1.263 1.26a.984.984 0 0 1-1.384 0 .41.41 0 0 0-.7.295z"
          })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_5678_29"
          }, /*#__PURE__*/_react.default.createElement("path", {
            fill: "#fff",
            d: "M0 0h24v24H0z"
          }))));
        case 'menu-sik-kullanilanlar':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 20 20",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_5678_80)",
            fill: "#000"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M19.375 2.5h-9.69L7.997.25a.627.627 0 0 0-.5-.25H.622a.625.625 0 0 0-.625.625v18.75A.625.625 0 0 0 .622 20h18.75a.625.625 0 0 0 .625-.625V3.125a.625.625 0 0 0-.622-.625zM7.185 1.25L8.873 3.5a.624.624 0 0 0 .5.25h9.375v12.5h-17.5v-15h5.937zm-5.938 17.5V17.5h17.5v1.25h-17.5z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M16.787 12.093l-1.68-1.344a.61.61 0 0 0-.762 0l-1.68 1.344a.61.61 0 0 1-.992-.477V2.501h6.106v9.114a.61.61 0 0 1-.991.477l-.001.001z"
          })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_5678_80"
          }, /*#__PURE__*/_react.default.createElement("path", {
            fill: "#fff",
            d: "M0 0h20v20H0z"
          }))));
        case 'menu-tum-islemler':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M23 0H1a1 1 0 0 0-1 1v4.4a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1z",
            fill: "#000"
          }), /*#__PURE__*/_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.667 12.266H1a1 1 0 0 1-1-1V8.333a1 1 0 0 1 1-1h3.667a1 1 0 0 1 1 1v2.933a1 1 0 0 1-1 1zm-2.667-2h1.667v-.933H2v.933zM1 18.133h3.667a1 1 0 0 0 1-1V14.2a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v2.933a1 1 0 0 0 1 1zm2.667-2H2V15.2h1.667v.933zM23 12.266H7.6a1 1 0 0 1-1-1V8.333a1 1 0 0 1 1-1H23a1 1 0 0 1 1 1v2.933a1 1 0 0 1-1 1zm-14.4-2H22v-.933H8.6v.933zM7.6 18.133H23a1 1 0 0 0 1-1V14.2a1 1 0 0 0-1-1H7.6a1 1 0 0 0-1 1v2.933a1 1 0 0 0 1 1zm14.4-2H8.6V15.2H22v.933zM4.667 24H1a1 1 0 0 1-1-1v-2.934a1 1 0 0 1 1-1h3.667a1 1 0 0 1 1 1V23a1 1 0 0 1-1 1zM2 22h1.667v-.934H2V22zM7.6 24H23a1 1 0 0 0 1-1v-2.934a1 1 0 0 0-1-1H7.6a1 1 0 0 0-1 1V23a1 1 0 0 0 1 1zM22 22H8.6v-.934H22V22z",
            fill: "#000"
          }));
        case 'menu-yardimci-uygulamalar':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_5678_41)",
            fill: "#000"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M10.777 14.222a1 1 0 0 1-.707-1.707L22.293.293a1 1 0 0 1 1.414 1.414L11.484 13.929a1 1 0 0 1-.707.293z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M23 9.333a1 1 0 0 1-1-1V2h-6.334a1 1 0 0 1 0-2H23a1 1 0 0 1 1 1v7.333a1 1 0 0 1-1 1zM18.11 24H3.449a3.447 3.447 0 0 1-3.444-3.445V5.888a3.447 3.447 0 0 1 3.444-3.444h5.607a1 1 0 0 1 0 2H3.448a1.445 1.445 0 0 0-1.444 1.444v14.667A1.445 1.445 0 0 0 3.448 22h14.667a1.445 1.445 0 0 0 1.444-1.445v-4.461a1 1 0 0 1 2 0v4.457A3.447 3.447 0 0 1 18.11 24z"
          })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_5678_41"
          }, /*#__PURE__*/_react.default.createElement("path", {
            fill: "#fff",
            d: "M0 0h24v24H0z"
          }))));
        case 'microphone':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "microphone",
            xmlnsXlink: "http://www.w3.org/1999/xlink"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            transform: "translate(4)",
            id: "Group_15746"
          }, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("path", {
            id: "SVGID_1_",
            d: "M0 0h16v24H0z"
          })), /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "SVGID_00000098191823593896869250000001378907871505764277_"
          }, /*#__PURE__*/_react.default.createElement("use", {
            xlinkHref: "#SVGID_1_",
            overflow: "visible"
          })), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15745",
            clipPath: "url(#SVGID_00000098191823593896869250000001378907871505764277_)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8415",
            d: "M8 17c2.8 0 5-2.2 5-5V5c0-2.8-2.2-5-5-5S3 2.2 3 5v7c0 2.8 2.2 5 5 5M5 5c0-1.7 1.3-3 3-3s3 1.3 3 3v7c0 1.7-1.3 3-3 3s-3-1.3-3-3V5z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8416",
            d: "M16 12c0-.6-.4-1-1-1s-1 .4-1 1c0 3.3-2.7 6-6 6s-6-2.7-6-6c0-.6-.4-1-1-1s-1 .4-1 1c0 4 3 7.4 7 7.9V22H5c-.6 0-1 .4-1 1s.4 1 1 1h6c.6 0 1-.4 1-1s-.4-1-1-1H9v-2-.1c4-.5 7-3.9 7-7.9"
          }))));
        case 'microphone-slash':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "microphone-slash"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            transform: "translate(1)",
            id: "Group_15752"
          }, /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15751"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8420",
            d: "M21.7 21.3l-4.4-4.4c1.1-1.4 1.7-3.1 1.7-4.9 0-.6-.4-1-1-1s-1 .4-1 1c0 1.2-.4 2.5-1.1 3.5l-.7-.7c.5-.9.8-1.8.8-2.8V5c0-2.8-2.2-5-5-5S6 2.2 6 5v.6L1.7 1.3C1.3.9.7.9.3 1.3s-.4 1 0 1.4l6 6 6.8 6.8 7.2 7.2c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4M8 5c0-1.7 1.3-3 3-3s3 1.3 3 3v7c0 .4-.1.9-.3 1.3L8 7.6V5z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8421",
            d: "M11 17c.6 0 1-.4 1-1s-.4-1-1-1c-1.7 0-3-1.3-3-3 0-.6-.4-1-1-1s-1 .4-1 1c0 2.8 2.2 5 5 5"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8422",
            d: "M14 22h-2v-2-.1c.4-.1.9-.1 1.3-.3.5-.2.8-.7.7-1.2-.2-.5-.7-.8-1.2-.7-3.2.9-6.5-.9-7.5-4-.2-.5-.3-1.1-.3-1.7 0-.6-.4-1-1-1s-1 .4-1 1c0 4 3 7.4 7 7.9V22H8c-.6 0-1 .4-1 1s.4 1 1 1h6c.6 0 1-.4 1-1s-.4-1-1-1"
          }))));
        case 'minus':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "minus"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "minus-2",
            d: "M19 13c.6 0 1-.4 1-1s-.4-1-1-1H5c-.6 0-1 .4-1 1s.4 1 1 1h14z"
          }));
        case 'minus-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "minus-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "minus-alt-2",
            d: "M3 11h18v2H3v-2z"
          }));
        case 'mobil':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "mobil"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Union_26",
            d: "M8 23c-1.7 0-3-1.3-3-3V4c0-1.7 1.3-3 3-3h8c1.7 0 3 1.3 3 3v16c0 1.7-1.3 3-3 3H8zM7 4v16c0 .6.4 1 1 1h8c.6 0 1-.4 1-1V4c0-.6-.4-1-1-1H8c-.6 0-1 .4-1 1zm4 16c-.6 0-1-.4-1-1s.4-1 1-1h2c.6 0 1 .4 1 1s-.4 1-1 1h-2z"
          }));
        case 'money':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "money"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_22098",
            transform: "translate(-1345 -1716)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Rectangle_12646",
            d: "M1347 1721.5v13h20v-13h-20m-1-2h22c.6 0 1 .4 1 1v15c0 .6-.4 1-1 1h-22c-.6 0-1-.4-1-1v-15c0-.6.4-1 1-1z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Ellipse_54",
            d: "M1357 1726.5c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5-.7-1.5-1.5-1.5m0-2c1.9 0 3.5 1.6 3.5 3.5s-1.6 3.5-3.5 3.5-3.5-1.6-3.5-3.5 1.6-3.5 3.5-3.5z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Ellipse_55",
            d: "M1363.5 1726.5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5-1.5-.7-1.5-1.5.7-1.5 1.5-1.5z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Ellipse_56",
            d: "M1350.5 1726.5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5-1.5-.7-1.5-1.5.7-1.5 1.5-1.5z"
          })));
        case 'money-bill':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "money-bill"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15932",
            transform: "translate(-264.117 -199.21)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_29833",
            d: "M286.1 200.2h-20c-.6 0-1 .4-1 1v12c0 .6.4 1 1 1h20c.6 0 1-.4 1-1v-12c0-.5-.4-1-1-1zm-17 12c0-1.1-.9-2-2-2v-6c1.1 0 2-.9 2-2h14c0 1.1.9 2 2 2v6c-1.1 0-2 .9-2 2h-14z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_29834",
            d: "M286.1 216.2h-20c-.6 0-1 .4-1 1s.4 1 1 1h20c.6 0 1-.4 1-1s-.4-1-1-1z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_29835",
            d: "M286.1 220.2h-20c-.6 0-1 .4-1 1s.4 1 1 1h20c.6 0 1-.4 1-1s-.4-1-1-1z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_29836",
            d: "M276.1 204.2c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm0 4c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
          })));
        case 'monitor-share':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "monitor-share"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            transform: "translate(1 2)",
            id: "Group_15754"
          }, /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15753"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8423",
            d: "M19 0H3C1.3 0 0 1.3 0 3v11c0 1.7 1.3 3 3 3h3c.6 0 1-.4 1-1s-.4-1-1-1H3c-.6 0-1-.4-1-1V3c0-.6.4-1 1-1h16c.6 0 1 .4 1 1v11c0 .6-.4 1-1 1h-3c-.6 0-1 .4-1 1s.4 1 1 1h3c1.7 0 3-1.3 3-3V3c0-1.7-1.3-3-3-3"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8424",
            d: "M15 11.5c.4.4 1 .4 1.4.1s.4-1 .1-1.4l-.1-.1-4.8-4.8c-.1-.1-.2-.2-.3-.2-.4-.2-.8-.1-1.1.2l-4.8 4.8c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l3.1-3.1v10.1c0 .6.4 1 1 1s1-.4 1-1V8.4l3.1 3.1z"
          }))));
        case 'mouse-pointer':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "mouse-pointer"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4715",
            d: "M16.5 22c-.3 0-.5-.1-.7-.3L12 17.9l-3 3c-.4.4-1 .4-1.4 0-.1-.1-.2-.3-.2-.4L2 3.3c-.1-.5.2-1.1.7-1.3h.6l17.3 5.3c.5.2.8.7.7 1.2 0 .2-.1.3-.2.4l-3 3 3.8 3.8c.4.4.4 1 0 1.4l-4.5 4.5c-.4.3-.6.4-.9.4zM12 15.5c.3 0 .5.1.7.3l3.8 3.8 3.1-3.1-3.8-3.8c-.4-.4-.4-1 0-1.4l2.6-2.6L4.5 4.5l4.2 13.9 2.6-2.6c.2-.2.4-.3.7-.3z"
          }));
        case 'MYR':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_27784_1794)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M0 4h24v16H0V4z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M.857 4.571H24m0 2.286H.857m0 2.286H24m0 2.286H.857",
            stroke: "#C00",
            strokeWidth: "42.857"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M0 4h12v9.714H0V4z",
            fill: "#006"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M0 13.714h24M24 16H0m0 2.286h24",
            stroke: "#C00",
            strokeWidth: "42.857"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M10 6.714l.255 1.743.986-1.46-.53 1.682 1.522-.889-1.204 1.286 1.757-.14-1.643.635 1.643.636-1.757-.14 1.204 1.285-1.521-.888.529 1.681-.986-1.46L10 12.43l-.255-1.743-.985 1.46.528-1.682-1.521.888 1.204-1.285-1.757.14 1.643-.636-1.643-.635 1.757.14L7.767 7.79l1.521.889-.528-1.681.985 1.46L10 6.713zm-1.429.072a3.048 3.048 0 1 0 0 5.571 3.429 3.429 0 1 1 0-5.571z",
            fill: "#FC0"
          })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_27784_1794"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "24",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'newspaper-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "newspaper-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4428",
            d: "M19 5V3H0v18h24V5h-5zM6 19H2V5h15v14H6zm16 0h-3V7h3v12z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4429",
            d: "M12 7h3v2h-3V7z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4430",
            d: "M12 11h3v2h-3v-2z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4431",
            d: "M4 15h11v2H4v-2z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4432",
            d: "M10 7H4v6h6V7zm-2 4H6V9h2v2z"
          }));
        case 'NGN':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_27784_1795)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M0 4h24v16H0V4z",
            fill: "#008751"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M8 4h8v16H8V4z",
            fill: "#fff"
          })), /*#__PURE__*/_react.default.createElement("rect", {
            x: ".5",
            y: "4.5",
            width: "23",
            height: "15",
            rx: ".5",
            stroke: "#F0F0F0"
          }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_27784_1795"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "24",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'NLG':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_27784_1796)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 4H0v16h24V4z",
            fill: "#21468B"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 4H0v10.667h24V4z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 4H0v5.333h24V4z",
            fill: "#AE1C28"
          })), /*#__PURE__*/_react.default.createElement("rect", {
            x: ".5",
            y: "4.5",
            width: "23",
            height: "15",
            rx: ".5",
            stroke: "#F0F0F0"
          }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_27784_1796"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "24",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'no-data':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "no-data"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M14.401 7.025L15.777 8.4H14.4V7.025z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.801 17.4V6.6h6v2.1a.3.3 0 0 0 .3.3h2.1v8.4h-8.4zm2.1-7.2h4.2a.3.3 0 1 1 0 .6h-4.2a.3.3 0 1 1 0-.6zm4.2 2.1h-4.2a.3.3 0 1 0 0 .6h4.2a.3.3 0 1 0 0-.6zm-4.2 2.1h2.4a.3.3 0 1 1 0 .6h-2.4a.3.3 0 1 1 0-.6z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm4.778-15.415a.297.297 0 0 0-.065-.097l-2.4-2.4A.305.305 0 0 0 14.1 6H7.5a.3.3 0 0 0-.3.3v11.4a.3.3 0 0 0 .3.3h9a.3.3 0 0 0 .3-.3v-9a.296.296 0 0 0-.022-.115z"
          }));
        case 'NOK':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_4901_834)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M22.588 4H1.412C.632 4 0 4.716 0 5.6v12.8c0 .884.632 1.6 1.412 1.6h21.176c.78 0 1.412-.716 1.412-1.6V5.6c0-.884-.632-1.6-1.412-1.6z",
            fill: "#000"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 4H0v16h24V4z",
            fill: "#EF2B2D"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M10.412 4H6.247v16h4.165V4z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 9.536H0v4.784h24V9.536z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M9.374 4H7.292v16h2.082V4z",
            fill: "#002868"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 10.736H0v2.392h24v-2.392z",
            fill: "#002868"
          })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_4901_834"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "24",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'office':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "office"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4721",
            d: "M1258.5 380.806h-2v-21a1 1 0 0 0-1-1h-16a1 1 0 0 0-1 1v21h-2a1 1 0 0 0 0 2h22a1 1 0 0 0 0-2zm-12 0v-4h2v4zm4 0v-5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v5h-4v-20h14v20z",
            transform: "translate(-1235.5 -358.806)"
          }), /*#__PURE__*/_react.default.createElement("rect", {
            id: "Rectangle_10003",
            dataName: "Rectangle 10003",
            width: "4",
            height: "4",
            rx: "1",
            transform: "translate(7 4)"
          }), /*#__PURE__*/_react.default.createElement("rect", {
            id: "Rectangle_10004",
            dataName: "Rectangle 10004",
            width: "4",
            height: "4",
            rx: "1",
            transform: "translate(13 4)"
          }), /*#__PURE__*/_react.default.createElement("rect", {
            id: "Rectangle_10005",
            dataName: "Rectangle 10005",
            width: "4",
            height: "4",
            rx: "1",
            transform: "translate(7 10)"
          }), /*#__PURE__*/_react.default.createElement("rect", {
            id: "Rectangle_10006",
            dataName: "Rectangle 10006",
            width: "4",
            height: "4",
            rx: "1",
            transform: "translate(13 10)"
          }));
        case 'paper':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "paper"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "paper-2",
            d: "M19.7 6.3l-4-4c-.2-.2-.4-.3-.7-.3H5c-.5 0-1 .4-1 .9V21c0 .5.4 1 .9 1H19c.5 0 1-.4 1-.9V7c0-.3-.1-.5-.3-.7zm-2.1.7H15V4.4L17.6 7zM6 20V4h7v4c0 .5.4 1 .9 1H18v11H6z"
          }));
        case 'paperclip':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "paperclip"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10834",
            transform: "translate(-1128.692 -479.556)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4644",
            d: "M1145 500.6c-1.5 0-2.9-.6-4-1.7l-9.1-9.3c-1.6-1.6-1.6-4.2 0-5.8 1.6-1.6 4.2-1.6 5.8 0l9.1 9.3c1 1 1 2.6 0 3.6-.5.5-1.1.8-1.8.8s-1.3-.3-1.8-.8l-9.1-9.3c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l9.1 9.3c.2.2.6.2.8 0 .2-.2.2-.6 0-.8l-9.1-9.3c-.8-.8-2.1-.8-3 0-.8.8-.8 2.2 0 3l9.1 9.3c1.4 1.4 3.7 1.4 5.2 0 1.4-1.5 1.4-3.8 0-5.3l-6.2-6.3c-.4-.4-.4-1-.1-1.4.4-.4 1-.4 1.4-.1l.1.1 6.2 6.3c2.2 2.2 2.2 5.8 0 8.1-1 1.1-2.5 1.7-4 1.7z"
          })));
        case 'pause':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "pause"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10894",
            transform: "translate(-832 -3034.236)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4724",
            d: "M840.7 3054.2h-1.3c-.7 0-1.3-.4-1.3-1v-14c0-.6.6-1 1.3-1h1.3c.7 0 1.3.4 1.3 1v14c0 .6-.6 1-1.3 1z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Rectangle_10008",
            d: "M847 3038.2h2c.6 0 1 .4 1 1v14c0 .6-.4 1-1 1h-2c-.6 0-1-.4-1-1v-14c0-.5.4-1 1-1z"
          })));
        case 'pdf':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M13.845 15.482h-.54v-2.964h.5c.271 0 .5.043.688.131a.871.871 0 0 1 .428.454c.099.215.148.514.148.897s-.048.682-.145.897a.867.867 0 0 1-.418.454 1.51 1.51 0 0 1-.66.131zM8.807 13.957h.5c.167 0 .308-.03.426-.091a.648.648 0 0 0 .273-.266.813.813 0 0 0 .097-.406.788.788 0 0 0-.097-.403.62.62 0 0 0-.273-.257.915.915 0 0 0-.426-.092h-.5v1.515z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M20.5 9h1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-1v1.5A2.5 2.5 0 0 1 18 23H4a2.5 2.5 0 0 1-2.5-2.5v-17A2.5 2.5 0 0 1 4 1h10.879a2.5 2.5 0 0 1 1.767.732l3.122 3.122A2.5 2.5 0 0 1 20.5 6.62V9zM4 3a.5.5 0 0 0-.5.5v17a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5V19h-12a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h12V6.621a.5.5 0 0 0-.146-.353l-3.122-3.122A.5.5 0 0 0 14.88 3H4zm14.357 13.75h-1.418v-5.5h3.672v1.203h-2.254v.945h2.03v1.204h-2.03v2.148zm-6.47 0h2.01c.53 0 .99-.11 1.379-.328.39-.22.69-.535.903-.945.212-.412.319-.904.319-1.477 0-.573-.108-1.064-.322-1.474a2.22 2.22 0 0 0-.908-.946c-.39-.22-.855-.33-1.392-.33h-1.99v5.5zm-4.498 0v-5.5h2.255c.387 0 .726.08 1.017.242.291.16.517.387.679.68.161.291.242.632.242 1.022 0 .394-.083.735-.25 1.023-.165.289-.397.51-.696.666a2.218 2.218 0 0 1-1.043.234h-.786v1.633H7.389z"
          }));
        case 'phone':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "phone"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4433",
            d: "M16.8 23c-3.2 0-7.2-1.9-10.5-5.2C1.6 13.1-.3 7.1 1.9 3.9L3 2.8l2.1-1.5c.3-.2.8-.4 1.2-.3.4.1.8.3 1 .7l3.2 4.6c.4.6.3 1.5-.2 2l-1.8 1.8c-.4.4 0 2.1 1.7 3.7 1.7 1.7 3.4 2 3.7 1.7l1.8-1.8c.5-.5 1.4-.6 2-.2l4.6 3.2c.3.2.6.6.7 1 .1.4 0 .9-.3 1.2L21.2 21c-.3.4-.7.8-1.1 1.1-1 .6-2.2.9-3.3.9zM6 3.1L4.1 4.4l-.6.6c-1.7 2.5.1 7.5 4.1 11.4 4 4 9 5.7 11.4 4.1.2-.1.5-.4.6-.6l1.3-1.8-4-2.8-1.6 1.6c-1.4 1.4-4.2.7-6.5-1.7-2.3-2.3-3-5.1-1.7-6.5l1.6-1.6-2.7-4z"
          }));
        case 'phone-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "phone-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "phone-alt-2",
            d: "M16.2 23c1.3 0 2.6-.5 3.5-1.5l3.2-3.3-6.4-6.5-1.9 1.9-4.3-4.3 1.9-1.9L5.9 1 2.3 4.6C1.4 5.5 1 6.7 1 7.9c0 1.2.5 2.4 1.3 3.2l10.3 10.5c1 .9 2.3 1.4 3.6 1.4zm4.1-4.7l-1.9 1.8c-1.2 1.2-3.1 1.2-4.3 0L3.7 9.7C3.2 9.2 3 8.5 3 7.9c0-.7.2-1.3.7-1.9L6 3.7l3.5 3.6-1.8 2 7.1 7.2 1.9-1.9 3.6 3.7z"
          }));
        case 'phone-arrow-down-left':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M21.22 16.3l-3.982-1.622a1.689 1.689 0 0 0-1.922.468l-1.675 2.007c-2.92-1.356-5.282-3.666-6.664-6.525l2.041-1.64c.568-.46.76-1.22.485-1.88L7.847 3.204a1.657 1.657 0 0 0-1.968-.944l-3.652.972A1.632 1.632 0 0 0 1 4.799C1 14.852 9.32 23 19.581 23c.75 0 1.4-.495 1.602-1.2l.998-3.575a1.611 1.611 0 0 0-.961-1.924z",
            fill: "#000"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M22.812 3.745l-2.617-2.566a.618.618 0 0 0-.87 0l-3.707 3.629-1.996-1.961c-.384-.385-1.052-.11-1.052.43v6.746c0 .669.549 1.21 1.236 1.21h6.828c.55 0 .824-.651.44-1.036l-1.978-1.952 3.726-3.648a.598.598 0 0 0 0-.852h-.01z",
            fill: "#000"
          }));
        case 'phone-arrow-up-right':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M21.258 16.3l-3.99-1.623a1.693 1.693 0 0 0-1.925.467l-1.679 2.008c-2.925-1.357-5.291-3.667-6.676-6.527l2.045-1.64a1.61 1.61 0 0 0 .486-1.88L7.86 3.2a1.66 1.66 0 0 0-1.971-.944l-3.66.972A1.632 1.632 0 0 0 1 4.795C1 14.851 9.336 23 19.616 23c.752 0 1.403-.495 1.605-1.2l1-3.576a1.611 1.611 0 0 0-.963-1.925z",
            fill: "#000"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M21.771 1H14.93c-.55 0-.835.65-.44 1.036l1.98 1.952-3.732 3.649a.597.597 0 0 0 0 .852l2.623 2.567a.62.62 0 0 0 .871 0l3.714-3.63 2 1.961c.384.386 1.054.11 1.054-.43V2.21C23.01 1.54 22.459 1 21.77 1z",
            fill: "#000"
          }));
        case 'phone-emergency-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "phone-emergency-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "phone-emergency-alt-2",
            d: "M12 22.6L1.4 12c-1.8-1.8-1.8-4.6-.1-6.4l.1-.1 3.8-3.8 6.6 6.5-1.9 1.9 4.5 4.4 1.9-1.9 6.6 6.5-3.3 3.4c-2.2 2-5.5 2-7.6.1zM2.8 6.9c-1 .9-1 2.5-.1 3.5l.1.1L13.4 21c1.2 1.2 3.2 1.2 4.5 0l1.9-1.8-3.7-3.7-1.9 1.9-7.3-7.2 1.9-1.9-3.7-3.7-2.3 2.3zm15.3 3.3V6.8l-2.8 1.6-1-1.7 2.8-1.6-2.8-1.6 1-1.7 2.8 1.6V0h2v3.4L23 1.7l1 1.7L21.2 5 24 6.7l-1 1.7-2.8-1.6v3.4h-2.1z"
          }));
        case 'phone-hangup':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M3.669 16.89a1.47 1.47 0 0 1-1.824-.613L.192 13.435a1.42 1.42 0 0 1 .235-1.727c6.391-6.277 16.755-6.277 23.146 0a1.42 1.42 0 0 1 .235 1.727l-1.653 2.841a1.47 1.47 0 0 1-1.824.614l-3.513-1.42A1.428 1.428 0 0 1 15.92 14l.23-2.275a12.56 12.56 0 0 0-8.302 0l.232 2.273c.065.632-.3 1.228-.897 1.47l-3.513 1.42-.002.002z",
            fill: "#000"
          }));
        case 'phone-pause':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M21.25 16.3l-3.988-1.623a1.692 1.692 0 0 0-1.925.467l-1.678 2.008c-2.924-1.357-5.289-3.667-6.673-6.527l2.044-1.64c.568-.46.76-1.22.486-1.88L7.856 3.2a1.66 1.66 0 0 0-1.97-.944l-3.658.972A1.632 1.632 0 0 0 1 4.795C1 14.851 9.332 23 19.608 23c.752 0 1.403-.495 1.604-1.2l1-3.576a1.611 1.611 0 0 0-.963-1.925z",
            fill: "#000"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M16.813 1h-1.834a.687.687 0 0 0-.687.688v7.791c0 .38.308.688.687.688h1.834c.38 0 .687-.308.687-.688V1.688A.687.687 0 0 0 16.812 1zM22.313 1h-1.834a.687.687 0 0 0-.687.688v7.791c0 .38.307.688.687.688h1.834c.38 0 .687-.308.687-.688V1.688A.687.687 0 0 0 22.312 1z",
            fill: "#000"
          }));
        case 'phone-xmark':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M21.251 16.296l-3.988-1.624a1.692 1.692 0 0 0-1.925.468l-1.677 2.009c-2.925-1.358-5.29-3.669-6.675-6.53l2.045-1.642c.568-.459.76-1.22.486-1.88L7.857 3.19a1.66 1.66 0 0 0-1.97-.945l-3.659.972A1.633 1.633 0 0 0 1 4.786C1 14.846 9.333 23 19.61 23c.752 0 1.403-.495 1.605-1.201l.999-3.577a1.612 1.612 0 0 0-.963-1.926zM20.564 5.382L22.8 3.144a.692.692 0 0 0 0-.972l-.972-.973a.691.691 0 0 0-.972 0L18.62 3.437 16.383 1.2a.692.692 0 0 0-.971 0l-.972.973a.692.692 0 0 0 0 .972l2.237 2.238-2.237 2.237a.692.692 0 0 0 0 .973l.972.972a.692.692 0 0 0 .971 0l2.237-2.238 2.237 2.238a.691.691 0 0 0 .972 0l.972-.972a.692.692 0 0 0 0-.973l-2.237-2.237z",
            fill: "#000"
          }));
        case 'picture':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "picture"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10836",
            transform: "translate(-1128.5 -504.806)"
          }, /*#__PURE__*/_react.default.createElement("circle", {
            id: "Ellipse_31",
            cx: "1135.5",
            cy: "513.8",
            r: "2"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4655",
            d: "M1150.5 507.8h-20c-.6 0-1 .4-1 1v16c0 .6.4 1 1 1h20c.6 0 1-.4 1-1v-16c0-.5-.4-1-1-1zm-1 2v9l-4.3-4.3c-.4-.4-1-.4-1.4 0l-5.8 5.8-2.3-2.3c-.4-.4-1-.4-1.4 0l-2.8 2.8v-11h18z"
          })));
        case 'pill-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "pill-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "pill-alt-2",
            d: "M18.1 5.9c-1.8-1.8-4.7-1.9-6.6-.1l-.1.1-5.5 5.5C4.1 13.2 4 16.1 5.8 18l.1.1c1.8 1.8 4.7 1.9 6.6.1l.1-.1 5.5-5.5c1.8-1.8 1.9-4.7.1-6.6 0 0-.1 0-.1-.1zm-6.9 10.8c-1.1 1-2.8 1-3.8 0l-.1-.1c-1-1.1-1-2.7 0-3.8l2.7-2.7 3.9 3.9-2.7 2.7z"
          }));
        case 'pin':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "pin"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10688",
            transform: "translate(-1057.5 -387.806)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4470",
            d: "M1069.5 388.8c-5 0-9 4-9 9 0 2.1.7 4.2 2.1 5.8 1.5 1.7 6 6.7 6.2 6.9.2.2.5.3.7.3.3 0 .5-.1.7-.3.2-.2 4.8-5.2 6.2-7 3.1-3.9 2.6-9.5-1.3-12.7-1.5-1.3-3.5-2-5.6-2zm5.4 13.4c-1.1 1.3-4 4.6-5.4 6.1-1.4-1.5-4.3-4.7-5.4-6a7 7 0 0 1 .9-9.9 7 7 0 0 1 9.9.9c2.1 2.6 2.1 6.3 0 8.9z"
          }), /*#__PURE__*/_react.default.createElement("circle", {
            id: "Ellipse_21",
            cx: "1069.5",
            cy: "397.8",
            r: "2"
          })));
        case 'play':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "play"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8376",
            d: "M5 3.1v17.8c0 .6.5 1.1 1.1 1.1.2 0 .4-.1.6-.2l13.4-8.9c.5-.3.6-1 .3-1.5l-.3-.3L6.7 2.2c-.5-.3-1.2-.2-1.5.3-.1.2-.2.4-.2.6z"
          }));
        case 'play-circle':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "play-circle"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15706",
            transform: "translate(-1284.505 -358.81)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8373",
            d: "M1296.5 381.8c-6.1 0-11-4.9-11-11 0-2.9 1.2-5.7 3.2-7.8 4.3-4.3 11.3-4.3 15.6 0 4.3 4.3 4.3 11.3 0 15.6-2.1 2-4.9 3.2-7.8 3.2zm-6.4-17.4c-3.5 3.5-3.5 9.2 0 12.7s9.2 3.5 12.7 0 3.5-9.2 0-12.7-9.1-3.5-12.7 0z"
          })), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15707",
            transform: "translate(-1284.505 -358.81)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8374",
            d: "M1293.8 367.7v6.3c0 .6.4 1 1 1 .2 0 .4-.1.6-.2l4.7-3.1c.5-.3.6-.9.3-1.4l-.3-.3-4.7-3.1c-.5-.3-1.1-.2-1.4.3-.2.1-.2.3-.2.5z"
          })));
        case 'PLN':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 26 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_27784_1797)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M25.6 4H0v16h25.6V4z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M25.6 12H0v8h25.6v-8z",
            fill: "#DC143C"
          })), /*#__PURE__*/_react.default.createElement("rect", {
            x: ".5",
            y: "4.5",
            width: "24.6",
            height: "15",
            rx: ".5",
            stroke: "#F0F0F0"
          }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_27784_1797"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "25.6",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'plus':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "plus"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "plus-2",
            d: "M19 11h-6V5c0-.6-.4-1-1-1s-1 .4-1 1v6H5c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1v-6h6c.6 0 1-.4 1-1s-.4-1-1-1z"
          }));
        case 'plus-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "plus-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "plus-alt-2",
            d: "M21 11h-8V3h-2v8H3v2h8v8h2v-8h8v-2z"
          }));
        case 'power-off':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "power-off"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10842",
            transform: "translate(2 1.079)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4640",
            d: "M15.7 3.5c-.5-.3-1.1-.2-1.4.2s-.2 1.1.2 1.4c2.2 1.5 3.4 4 3.4 6.7 0 4.4-3.6 8-8 8s-8-3.6-8-8c0-2.6 1.3-5.1 3.4-6.7.6-.3.7-.9.4-1.3s-1-.6-1.4-.3c-4.5 3.2-5.6 9.4-2.5 13.9 3.2 4.5 9.4 5.6 13.9 2.5s5.6-9.4 2.5-13.9c-.7-1-1.5-1.8-2.5-2.5z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4641",
            d: "M10 7c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1S9 .4 9 1v5c0 .6.4 1 1 1z"
          })));
        case 'print':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "print"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4516",
            d: "M20 6h-3V3c0-.6-.4-1-1-1H8c-.6 0-1 .4-1 1v3H4c-1.1 0-2 .9-2 2v9c0 1.1.9 2 2 2h3v2c0 .6.4 1 1 1h8c.6 0 1-.4 1-1v-2h3c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM9 4h6v2H9V4zm6 16H9v-5h6v5zm5-3h-3v-3c0-.6-.4-1-1-1H8c-.6 0-1 .4-1 1v3H4V8h16v9z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4517",
            d: "M17 12c.4 0 .8-.2.9-.6.1-.2.1-.5 0-.8-.2-.5-.8-.7-1.3-.5-.5.2-.7.8-.5 1.3.1.4.5.6.9.6z"
          }));
        case 'profile':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "profile"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10862",
            transform: "translate(-1151.5 -384.806)"
          }, /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10860"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4684",
            d: "M1163.5 396.8c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
          })), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10861"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4685",
            d: "M1170.5 406.8h-14c-.6 0-1-.4-1-1v-3c0-2.8 2.2-5 5-5h6c2.8 0 5 2.2 5 5v3c0 .6-.4 1-1 1zm-13-2h12v-2c0-1.7-1.3-3-3-3h-6c-1.7 0-3 1.3-3 3v2z"
          }))));
        case 'ptt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "ptt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Union_31",
            d: "M18.8 18.3c-1.1-.8-1.6-2.2-1.5-3.5V12h-.8V9.6h.8V6h2.8v3.7H22V12h-1.8v3.2c0 .5.1.9.4 1.3.2.3.6.5.9.5h.5v2.1c-.3 0-.5 0-.8.1-.9-.2-1.7-.4-2.4-.9zm-6.1 0c-1.1-.8-1.6-2.2-1.5-3.5V12h-.8V9.6h.8V6H14v3.7h1.9V12h-1.8v3.2c0 .5.1 1 .4 1.3.2.3.6.5.9.5h.5v2.1c-.3 0-.5 0-.8.1-.9-.2-1.7-.4-2.4-.9zM2 19V5h2.4c1.4-.1 2.8.3 3.9 1.2 1 .8 1.6 2 1.5 3.2.1 1.7-.7 3.3-2.1 4.3-.8.6-1.7 1-2.7 1.2V19H2zm3.1-6.7c.4-.1.8-.3 1-.6.5-.7.7-1.5.7-2.3 0-1.4-.5-2.1-1.6-2.1v5z"
          }));
        case 'QAR':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_27784_1798)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M0 4h24v16H0",
            fill: "#8A1538"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M7.04 20H0V4h7.04l1.92.889-1.92.889 1.92.889-1.92.889 1.92.888-1.92.89 1.92.888-1.92.89L8.96 12l-1.92.889 1.92.889-1.92.889 1.92.889-1.92.888 1.92.89-1.92.888 1.92.89L7.04 20z",
            fill: "#fff"
          })), /*#__PURE__*/_react.default.createElement("rect", {
            x: ".5",
            y: "4.5",
            width: "23",
            height: "15",
            rx: ".5",
            stroke: "#F0F0F0"
          }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_27784_1798"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "24",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'qrcode':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "qrcode"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15033",
            transform: "translate(-1286.5 -358.805)"
          }, /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15021"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_7557",
            d: "M1301.5 381.8h-2v-4h-4v-2h6v6z"
          })), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15022"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_7558",
            d: "M1300.5 373.8h-2v-6h8v3h-2v-1h-4v4z"
          })), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15023"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Rectangle_12556",
            d: "M1301.5 371.8h5v2h-5z"
          })), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15024"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_7559",
            d: "M1289.5 370.8h-2v-3h8v-8h2v10h-8v1z"
          })), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15025"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_7560",
            d: "M1309.5 376.8h-7v-2h5v-7h2v9z"
          })), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15026"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Rectangle_12557",
            d: "M1295.5 378.8h2v3h-2z"
          })), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15027"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Rectangle_12558",
            d: "M1287.5 371.8h10v2h-10z"
          })), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15028"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_7561",
            d: "M1294.5 366.8h-7v-7h7v7zm-5-2h3v-3h-3v3z"
          })), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15029"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_7562",
            d: "M1294.5 381.8h-7v-7h7v7zm-5-2h3v-3h-3v3z"
          })), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15030"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_7563",
            d: "M1309.5 366.8h-7v-7h7v7zm-5-2h3v-3h-3v3z"
          })), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15031"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_7564",
            d: "M1309.5 381.8h-2v-2h-3v2h-2v-4h7v4z"
          })), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15032"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_7565",
            d: "M1301.5 366.8h-3v-2h1v-3h-1v-2h3v7z"
          }))));
        case 'question':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "question"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Union_6",
            d: "M1 12C1 5.9 5.9 1 12 1s11 4.9 11 11-4.9 11-11 11S1 18.1 1 12zm2 0c0 5 4 9 9 9s9-4 9-9-4-9-9-9-9 4-9 9zm7.9 4.4c0-.6.5-1.1 1.1-1.1.6 0 1.1.5 1.1 1.1 0 .6-.5 1.1-1.1 1.1-.6 0-1.1-.5-1.1-1.1zm.1-3v-.6c0-.9.6-1.7 1.4-2.1.6-.2.9-.8.8-1.4-.1-.4-.4-.8-.9-.9-.6-.2-1.3.2-1.5.9-.1.5-.7.9-1.2.7-.5-.2-.8-.7-.7-1.3.5-1.7 2.2-2.7 3.9-2.3 1.2.3 2.1 1.2 2.4 2.4.4 1.6-.5 3.2-2 3.8-.1 0-.1.1-.1.2v.6c0 .6-.4 1-1 1s-1.1-.5-1.1-1z"
          }));
        case 'question-comment-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "question-comment-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4443",
            d: "M19 1.5H5c-1.6 0-3 1.2-3 2.8v11.9c0 1.6 1.3 2.9 2.9 2.9h3.7l3.4 3.3 3.4-3.3H19c1.6 0 3-1.2 3-2.8V4.4c0-1.6-1.3-2.9-2.9-2.9H19zm1 14.7c0 .5-.4 1-.9 1h-4.5L12 19.8l-2.6-2.6H5c-.5 0-1-.4-1-.9V4.4c0-.5.4-1 .9-1H19c.5 0 1 .4 1 .9v11.9z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4444",
            d: "M12 13.3c-.6 0-1 .4-1 1 0 .5.5 1 1 1 .6 0 1-.4 1-1 0-.5-.4-1-.9-1H12z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4445",
            d: "M12.7 5.5c-1.7-.4-3.4.6-3.8 2.3l1.9.5c.2-.6.8-1 1.4-.8.4.1.7.4.8.8.2.6-.1 1.2-.7 1.4-.9.3-1.4 1.2-1.4 2.1v.7h2v-.7c0-.1 0-.1.1-.2 1.5-.6 2.3-2.1 2-3.7-.2-1.2-1.1-2.1-2.3-2.4z"
          }));
        case 'random-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "random-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "random-alt-2",
            d: "M17.3 14.4l1.3 1.3h-1.2c-1.2 0-2.4-.5-3.1-1.5l-2-2.5 2-2.5c.7-1 1.9-1.5 3.1-1.5h1.2L17.3 9l1.4 1.4 3.7-3.7L18.7 3l-1.4 1.4 1.3 1.3h-1.2c-1.8 0-3.6.9-4.7 2.3L11 10.1 9.3 8C8.2 6.6 6.4 5.7 4.6 5.7H2v2h2.6c1.2 0 2.4.5 3.1 1.5l2 2.5-2 2.5c-.7 1-1.9 1.5-3.1 1.5H2v2h2.6c1.8 0 3.6-.9 4.7-2.3l1.7-2.1 1.7 2.1c1.1 1.4 2.9 2.3 4.7 2.3h1.2L17.3 19l1.4 1.4 3.7-3.7-3.7-3.7-1.4 1.4z"
          }));
        case 'rank-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "rank-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "rank-alt-2",
            d: "M3 17.4V1h18v16.5L12 23l-9-5.6zm2-1.1l7 4.4 7-4.4V3H5v13.3zm2-1.6v-2.4l5 3.3 5-3.3v2.4L12 18l-5-3.3zm0-4.9V7.4l5 3.3 5-3.3v2.4L12 13 7 9.8z"
          }));
        case 'rates':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "usd-circle"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            transform: "translate(1 1.01)",
            id: "Group_15785"
          }, /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15784"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8451",
            d: "M11 22C4.9 22 0 17.1 0 11S4.9 0 11 0s11 4.9 11 11c0 2.9-1.2 5.7-3.2 7.8-2.1 2-4.9 3.2-7.8 3.2M4.6 4.6c-3.5 3.5-3.5 9.2 0 12.7s9.2 3.5 12.7 0 3.5-9.2 0-12.7-9.2-3.5-12.7 0"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8452",
            d: "M14.8 12.7c0 .7-.3 1.3-.8 1.8-.6.5-1.4.8-2.2.8v1.6h-1v-1.5c-1 0-2-.2-3-.6v-1.5c.5.2 1 .4 1.5.5s1 .2 1.5.2v-2.7l-.6-.3c-.7-.2-1.3-.6-1.8-1.1-.4-.5-.6-1-.5-1.6 0-.6.3-1.3.8-1.7.6-.5 1.4-.7 2.1-.8V4.6h1v1.2c1 0 1.9.2 2.8.6L14 7.8c-.7-.3-1.5-.5-2.3-.5V10l.6.2c.7.2 1.4.6 1.9 1.1.4.3.6.8.6 1.4M9.6 8.3c0 .3.1.5.3.7l.9.6V7.3c-.3 0-.6.2-.9.4-.2.1-.3.3-.3.6m3.5 4.5c0-.3-.1-.5-.3-.7-.3-.2-.6-.4-1-.5v2.3c.8-.1 1.2-.5 1.3-1.1"
          }))));
        case 'refresh':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "refresh"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4588",
            d: "M12 1C5.9 1 1 5.9 1 12c0 .6.4 1 1 1s1-.4 1-1c0-5 4-9.1 9-9.1s9.1 4 9.1 9-4 9.1-9 9.1c-2.5 0-5-1-6.7-2.9l1.9.1c.6 0 1-.4 1-1s-.4-1-1-1L3.4 16c-.6 0-1 .4-1 1l-.1 4c0 .6.4 1 1 1 .5 0 1-.4 1-1v-1.2c4.3 4.3 11.3 4.2 15.6-.1 4.3-4.3 4.2-11.3-.1-15.6C17.7 2.1 14.9 1 12 1z"
          }));
        case 'rings-wedding-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "rings-wedding-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "rings-wedding",
            d: "M1 15c0-.4 0-.7.1-1.1v-.3c.1-.4.1-.7.3-1.1v-.1c.1-.3.2-.7.4-1 0-.1.1-.1.1-.2.1-.2.3-.5.5-.8.2-.3.4-.6.7-.9C4.7 7.9 6.8 7 9 7c.5 0 .9 0 1.4.1h.1c.3.1.7.1 1 .2.1 0 .2.1.2.1.3.1.6.2.9.4.1 0 .1.1.2.1l.9.6h.1c.3.2.6.5.9.7.1.1.1.2.2.2.2.2.4.4.5.6.1.1.2.2.3.4.1.1.1.2.2.3.5.9.9 1.8 1.1 2.8-.7.4-1.3.5-2 .5h-.1c-.3-1.5-1.1-2.9-2.3-3.8h-.1c-.2-.2-.5-.3-.7-.5-2-1.1-4.5-.9-6.3.5h-.1c-.4.3-.8.7-1.1 1v.1c-.1.2-.3.3-.4.5l-.1.2-.3.6c-.1.2-.2.5-.2.7v.2c0 .2-.1.4-.1.5v.2c-.2.3-.2.5-.2.8 0 3.3 2.7 6 6 6 .3 0 .6 0 .9-.1.1 0 .2 0 .3-.1.2 0 .4-.1.6-.2.1 0 .2-.1.3-.1l.6-.3c.1 0 .1-.1.2-.1.2-.1.5-.3.7-.5.7-.5 1.2-1.1 1.6-1.8h.8c.5 0 1 0 1.5-.1-.4 1.1-1 2-1.9 2.8l-.1.1s-.1 0-.1.1c-.3.2-.5.5-.8.6l-.1.1c-.3.2-.6.4-.9.5-.1 0-.1.1-.2.1-.3.1-.6.3-.9.4h-.1c-.3.1-.7.2-1 .2h-.3c-.3.4-.7.4-1.1.4-4.4 0-8-3.6-8-8zm13.7 2c-.3 0-.7-.1-1-.1-3.3-.6-5.9-3.2-6.5-6.5.5-.3 1.2-.4 1.8-.4h.1c.4 2.5 2.4 4.5 4.9 4.9 1.4.2 2.8 0 4-.7 2.9-1.6 3.9-5.3 2.3-8.2-1.6-2.9-5.3-3.9-8.2-2.3-1 .5-1.7 1.3-2.3 2.3H9c-.5 0-1 0-1.4.1C9.1 2 13.8-.1 17.9 1.5c4.1 1.6 6.2 6.2 4.6 10.3-1 2.5-3.1 4.3-5.6 4.9-.4.1-.7.1-1.1.2h-.7c-.2.1-.3.1-.4.1z"
          }));
        case 'RON':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_27784_1799)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 4H0v16h24V4z",
            fill: "#002B7F"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 4H8v16h16V4z",
            fill: "#FCD116"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 4h-8v16h8V4z",
            fill: "#CE1126"
          })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_27784_1799"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "24",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'roof-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "roof-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "roof-alt-2",
            d: "M18.5 11.4V9.2h-2v1l-4-2.2L0 14.2.9 16l11.6-5.7L23 16l1-1.8-5.5-2.8z"
          }));
        case 'round':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "round"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "round-2",
            d: "M12 1c6.1 0 11 4.9 11 11s-4.9 11-11 11S1 18.1 1 12 5.9 1 12 1z"
          }));
        case 'round-plus':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "round-plus"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4669",
            d: "M12 1C5.9 1 1 5.9 1 12s4.9 11 11 11 11-4.9 11-11S18.1 1 12 1zm6 12h-5v5c0 .6-.4 1-1 1s-1-.4-1-1v-5H6c-.6 0-1-.4-1-1s.4-1 1-1h5V6c0-.6.4-1 1-1s1 .4 1 1v5h5c.6 0 1 .4 1 1s-.4 1-1 1z"
          }));
        case 'RUB':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_4901_835)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M22.588 4H1.412C.632 4 0 4.716 0 5.6v12.8c0 .884.632 1.6 1.412 1.6h21.176c.78 0 1.412-.716 1.412-1.6V5.6c0-.884-.632-1.6-1.412-1.6z",
            fill: "#000"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 4H0v8h24V4z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 12H0v8h24v-8z",
            fill: "#D52B1E"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 9.336H0v5.336h24V9.336z",
            fill: "#0039A6"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M22.588 4.6c.487 0 .883.448.883 1v12.8c0 .552-.396 1-.883 1H1.412c-.487 0-.883-.448-.883-1V5.6c0-.552.396-1 .883-1h21.176zm0-.6H1.412C.635 4 0 4.72 0 5.6v12.8c0 .88.635 1.6 1.412 1.6h21.176c.777 0 1.412-.72 1.412-1.6V5.6c0-.88-.635-1.6-1.412-1.6z",
            fill: "#D8E0ED"
          })), /*#__PURE__*/_react.default.createElement("rect", {
            x: ".5",
            y: "4.5",
            width: "23",
            height: "15",
            rx: ".5",
            stroke: "#F0F0F0"
          }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_4901_835"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "24",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'SAR':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_4901_836)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 4H0v16h24V4z",
            fill: "#006C35"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M10.38 7.297s-.028 0-.056.024a.487.487 0 0 0-.176.335c0 .087-.022.087.035.143.035.056.07.056.148.008.042-.032.056-.056.07-.12.015-.095-.091.048-.105-.063-.021-.104.042-.144.113-.24 0-.047 0-.087-.022-.087h-.007zm1.066 0s-.042.032-.078.104c-.028.071-.134.19-.056.422.064.151.092.39.064.653a.904.904 0 0 1-.113.175c-.078.096-.17.072-.233.04-.064-.048-.113-.072-.141-.223 0-.239.02-.637-.022-.725-.056-.127-.155-.08-.19-.048-.198.2-.29.542-.353.813-.056.199-.113.143-.155.063-.099-.103-.106-.923-.226-.788-.19.613.113 1.29.318 1.226.148.072.247-.254.31-.605.042-.095.078-.111.099-.056 0 .47.028.574.134.717.24.207.437.024.451.008l.184-.207c.042-.048.099-.056.155-.008.057.056.05.16.17.231.106.048.324.008.374-.088.07-.135.084-.175.12-.23.049-.072.134-.04.134-.016-.007.04-.057.08-.021.15.056.049.07.017.105 0 .12-.063.212-.365.212-.365 0-.112-.05-.104-.085-.08-.049.032-.049.04-.098.072-.057.008-.177.055-.233-.048-.057-.12-.057-.287-.106-.406 0-.008-.078-.191 0-.2.035 0 .113.032.127-.04.035-.07-.085-.27-.162-.374-.071-.087-.17-.095-.261-.008-.064.072-.057.144-.071.215a.365.365 0 0 0 .063.295c.064.151.184.335.149.605 0 0-.071.128-.19.112-.05-.016-.135-.04-.177-.406-.036-.279.007-.677-.1-.86-.02-.072-.042-.136-.077-.136l-.021.016zm-.339.032s-.07.048-.098.127a1.825 1.825 0 0 0-.05.383c-.021.095.092.135.141.016.07-.223.078-.319.078-.414-.014-.072-.043-.112-.07-.104v-.008zm1.25.024s-.057.024-.071.08c-.014.127 0 .199.014.302.014.072.106.191.155.263.219.327.424.661.628.996.028.254.057.501.07.748.036.542.043 1.21.015 1.784.092 0 .233-.167.282-.406.035-.342-.014-1.035-.014-1.234 0-.08 0-.184-.014-.287.233.43.459.884.684 1.386.078-.04.064-.558.015-.63-.177-.43-.424-.86-.502-1.027-.028-.056-.127-.223-.24-.414a8.226 8.226 0 0 0-.056-.574c-.035-.286.106.032.085-.135-.05-.287-.184-.486-.353-.749-.056-.087-.05-.103-.134.024a.63.63 0 0 0-.035.335c-.021-.032-.05-.08-.085-.128-.141-.135-.155-.143-.268-.262-.035-.032-.106-.08-.162-.072h-.015zm3.697.04s-.035 0-.05.04a.286.286 0 0 0-.077.19c.007.152.035.311.042.463 0 .024 0 .04.008.063a.294.294 0 0 0-.036-.047c-.26-.311.12-.048-.05-.295-.14-.175-.183-.24-.31-.343-.063-.047-.098-.127-.12.016a3.675 3.675 0 0 0-.007.39.51.51 0 0 0 .106.24c.176.238.353.501.536.772.036.55.05 1.051.085 1.6 0 .24-.07.55-.127.574 0 0-.092.064-.155 0-.042-.024-.226-.342-.226-.342-.092-.096-.155-.072-.219 0-.183.199-.26.565-.388.82-.028.056-.12.104-.219 0-.254-.39-.105-.94-.134-.804-.225.286-.127.756-.077.86.077.167.134.27.275.358.134.112.233.04.29-.032.133-.15.133-.55.197-.629.042-.143.155-.12.204-.056.05.088.113.136.191.184.12.12.268.143.416.032.1-.064.163-.144.22-.303.063-.191.027-1.17.013-1.72l.275.454c.043.477.057.955.043 1.41-.007.087.282-.272.275-.439v-.414c.141.255.275.51.402.765.078-.048.05-.558 0-.622-.134-.255-.303-.525-.437-.74-.029-.271-.064-.582-.078-.685-.028-.152-.05-.375-.092-.558-.007-.071-.042-.294-.035-.318.014-.048.078 0 .106-.056.042-.056-.148-.621-.247-.788-.035-.072-.099-.048-.177.071-.07.08-.049.255-.02.422.07.43.14.868.19 1.306-.099-.159-.212-.358-.325-.541 0-.016-.014-.088-.014-.088s-.014-.35-.028-.438c0-.032-.007-.04.021-.04.035.032.035.032.057.04.035 0 .063-.055.042-.111-.106-.215-.205-.43-.31-.645-.015-.016-.029-.032-.043-.032l.007.016zM6.506 7.4c-.056 0-.12.04-.091.111-.015.04.112.183.134.263.02.056-.022.231.02.255.036.016.093-.128.114-.255.014-.072 0-.319-.148-.366h-.022L6.506 7.4zm10.875 0s-.029.024-.05.08c-.056.103-.077.302-.056.47.141 1.066.247 2.102.268 3.05-.014.087-.014.135-.05.254-.084.12-.176.271-.26.343-.085.071-.269.143-.332.19-.19.128-.19.264-.035.272.26-.032.578-.056.79-.422.056-.104.127-.383.127-.55.021-.995-.014-1.975-.141-2.7-.007-.071-.035-.23-.028-.255.014-.047.105 0 .134-.055.042-.056-.226-.438-.318-.606-.021-.04-.028-.08-.05-.071zm-2.767.016s-.028.024-.056.063c-.07.271-.099.494-.07.661.19 1.115.38 2.135.352 3.194.092 0 .19-.231.24-.462.021-.318-.014-.51-.02-.693-.008-.183-.184-1.696-.227-1.84-.042-.262.177-.031.149-.19-.078-.2-.262-.479-.325-.654-.021-.048-.028-.087-.043-.087v.008zm-6.739.024s-.042.023-.056.063c0 .024.007.064-.007.072-.014.016-.05 0-.05-.064 0-.024-.014-.04-.02-.056h-.029c-.021 0-.014 0-.028.024 0 .016-.007.032-.007.056s-.007.032-.028.032H7.62c-.007-.008-.014-.016-.014-.032s0-.048-.007-.056-.021-.016-.028-.016c-.07 0-.078.096-.07.128 0 0-.008.167.084.215.127.072.374.04.36-.191v-.112c-.014-.032-.035-.048-.064-.04l-.007-.023zm1.73 0a.219.219 0 0 0-.12.04c-.085.095-.107.238-.036.334.063.032.134.111.085.151-.184.223-.67.597-.692.661 0 0 .325.016.36 0 .106-.048.593-.677.593-.677-.028-.024-.05-.04-.078-.063-.028-.024-.021-.056 0-.08.12-.08.085-.255.021-.335a.353.353 0 0 0-.148-.031h.014zm4.523 0s-.029.023-.05.08a1.01 1.01 0 0 0-.091.47c.127.987.162 1.847.246 2.826 0 .096 0 .231-.063.287-.205.247-.508.55-.833.685-.035.048.085.23.247.23.261-.03.494-.198.713-.644.056-.104.155-.327.162-.494.021-.995-.042-1.776-.176-2.5a.618.618 0 0 1 .007-.176c.014-.024.078 0 .106-.056.042-.055-.12-.485-.212-.645-.021-.04-.028-.071-.05-.071l-.006.008zm-7.008.031c-.035 0-.07.04-.084.08 0 .16 0 .319.007.462.063.255.084.478.113.74.007.351-.177.152-.17-.023.043-.223.028-.582 0-.67-.028-.087-.063-.11-.141-.095-.056 0-.212.183-.254.494 0 0-.035.16-.05.303-.02.159-.112.27-.183-.024-.056-.215-.092-.741-.183-.622-.029.415-.057 1.14.254 1.219.374.04.17-.717.303-.852.028-.072.07-.072.078.016v.645c0 .207.12.27.211.318.1-.008.163 0 .205.104.014.374.028.74.05 1.115 0 0 .225.072.24-.63.014-.413-.071-.756-.022-.835 0-.08.092-.08.156-.048.098.08.14.175.296.135.233-.072.374-.199.374-.398a2.052 2.052 0 0 0-.106-.574c.007-.031-.042-.127-.035-.159.042.072.106.072.12 0-.043-.143-.1-.286-.198-.35-.085-.08-.205-.064-.247.103-.021.2.064.43.19.622a.69.69 0 0 1 .05.31c-.07.04-.134.024-.19-.04 0 0-.184-.159-.184-.19.05-.36.007-.399-.014-.495-.021-.135-.078-.175-.12-.27-.05-.056-.106-.056-.141 0-.085.159-.042.501.014.66.042.144.106.232.078.232-.029.08-.078.063-.12-.032-.057-.191-.064-.478-.064-.606-.014-.159-.035-.501-.127-.58-.028-.04-.056-.049-.085-.049l-.02-.016zm1.32 0l-.064.024c-.077.032-.155.104-.134.255.092.645.156 1.147.254 1.792.014.08-.042.175-.113.167-.127-.095-.155-.286-.367-.278-.155 0-.324.19-.345.374a.945.945 0 0 0 0 .422c.106.143.233.127.345.095.092-.04.17-.143.205-.119.021.04 0 .382-.437.637-.269.136-.48.168-.593-.08-.07-.15 0-.74-.17-.605-.515 1.505 1.207 1.713 1.405.064.014-.048.05-.096.077-.08.014 0 .022.024.029.056-.043 1.497-1.334 1.6-1.553 1.123-.056-.111-.07-.358-.077-.502-.008-.087-.029-.143-.05-.159-.05-.048-.12.072-.141.27-.021.16-.014.208-.014.367.07 1.179 1.736.677 2.004-.303.134-.501 0-.884.042-.931.163.199.395.024.452-.048.021-.032.078-.056.113-.016.127.104.353.056.402-.127.028-.184.05-.367.057-.558-.085.032-.156.048-.177.088 0 .008-.014.016-.014.024l-.021.159v.016s-.007.016-.014.016c-.029.016-.085 0-.085-.04-.042-.207-.205-.231-.303.088-.071.063-.19.071-.205-.016.014-.215-.056-.24-.212-.144l-.148-1.25c.064 0 .12.048.184-.032-.064-.223-.198-.669-.269-.717l-.014-.016h-.007-.021l-.021-.016zm5.151 0c-.063 0-.14.048-.113.136-.014.048.142.223.17.318.05.144-.035.287.014.303.042.024.106-.151.127-.31.028-.128-.057-.39-.17-.447h-.028zm-4.015.16s.064.024.085.071c.02.048.007.096-.021.104-.029.008-.071-.024-.092-.072-.021-.048-.007-.095.02-.103h.008zm7.445.215c-.064 0-.127.047-.099.151-.014.056.127.239.155.342.021.072-.035.311.014.327.043.024.1-.16.12-.335.015-.095-.049-.43-.155-.485h-.035zm-4.114.111s.014.056.014.088c.014.064.021.12.035.183-.05-.072-.085-.135-.106-.151-.105-.144 0-.096.057-.112v-.008zm.945.526s-.042.024-.056.064c0 .023.007.063-.007.071-.014.016-.05 0-.05-.056 0-.023-.014-.04-.02-.055h-.029c-.021 0-.014 0-.028.024 0 .016-.007.031-.007.055s-.007.032-.021.032h-.029c-.007-.008-.014-.016-.014-.032s0-.047-.007-.055-.02-.016-.028-.016c-.07 0-.078.087-.07.127 0 0-.008.167.084.215.127.072.374.04.36-.199v-.111c-.014-.032-.035-.048-.063-.04l-.015-.024zm-4.332.048s-.036 0-.064.024c-.113.071-.155.278-.085.398.064.103.17.063.184.063.113.016.176-.239.176-.239s0-.071-.127.064c-.056.008-.063-.008-.077-.048a.384.384 0 0 1 .014-.199c.014-.04 0-.063-.029-.063h.008zm6.118.031c-.064 0-.134.04-.148.144 0 .056.02.087.02.143 0 .032-.035.048-.098.016.007-.008-.042-.095-.042-.095-.05-.032-.12 0-.163.031a.326.326 0 0 0-.014.223c.07.152.325.415.445.415 0-.136.014-.319.02-.43 0-.04.015-.088.05-.104.036-.008.1.04.1 0a.593.593 0 0 0-.064-.279c-.022-.04-.057-.056-.1-.056l-.006-.008zm-5.067.478c-.014.008-.028.032-.063.064-.057.072-.064.12-.064.263 0 .016.106.342.19.565.057.24.113.51.071.765a1.763 1.763 0 0 1-.684.804c-.135.048-.254.032-.29 0-.077-.064-.077-.167-.077-.183.225-.175.486-.319.684-.804.057-.184.078-.295.021-.574a.604.604 0 0 0-.113-.27c.036-.024.141.063.156.007a.883.883 0 0 0-.198-.414c-.078-.08-.17-.095-.24-.016-.085.056-.099.24-.063.407.042.127.162.143.247.39 0 .016.028.183-.014.255-.036.12-.487.525-.516.55v-.08c0-.072.022-.247.022-.271-.149.111-.198.438-.226.533-.374.295-.805.51-1.045.805-.127.223.882-.255.995-.319.021.024.021.128.092.215.106.16.325.263.543.2.367-.152.572-.43.784-.741.028-.048.077-.088.12-.048.148.374.571.637 1.115.66.127-.174.063-.262.014-.294-.014-.008-.275-.127-.31-.239-.029-.103.035-.199.155-.263.352-.047.698-.103 1.03-.222 0-.128.07-.32.113-.399.028-.056.05-.064.056-.071v-.008l-.056-.04h-1.122s-.021-.016-.028-.024c0-.008.02-.016.035-.024.268-.04.74-.127.776-.645 0-.27-.099-.446-.395-.494-.212.016-.367.255-.346.51-.007.072.021.207-.042.223-.41.04-.861.334-.875.541-.029-.008-.064-.055-.057-.127a2.75 2.75 0 0 0-.282-1.083c-.056-.064-.085-.096-.099-.096l-.014-.008zm1.073.191s-.043.024-.057.064c0 .024.007.064-.007.072-.014.016-.05 0-.05-.056 0-.024-.013-.04-.02-.056h-.029c-.02 0-.02 0-.028.024 0 .016-.007.032-.007.056s-.007.032-.021.032h-.028c-.007-.008-.021-.016-.021-.032s0-.048-.008-.056a.05.05 0 0 0-.035-.016c-.07 0-.078.088-.07.128 0 0-.008.167.084.215.127.071.438.032.36-.2v-.11c-.014-.033-.035-.049-.063-.04v-.025zm4.325.2h-.014s-.6.477-.614.493c-.056.056-.028.271 0 .247.043.016.643-.438.636-.494.028 0 .042-.238-.008-.246zm-3.76.071s.056 0 .084.024c.042.032.07.072.07.104v.008c-.02.024-.07.016-.12-.008-.042-.032-.07-.072-.07-.104V9.52c.007 0 .014-.008.028-.016h.007zm-5.237.12c-.31 0-.762.462-.776.709.324-.176.649-.35.98-.534-.056-.088 0-.175-.204-.175zm1.002.159s.064.016.078.064a.14.14 0 0 1-.014.111c-.014.016-.057.008-.092.008-.042 0-.057-.008-.085-.048-.014-.04.021-.08.035-.111v-.008a.075.075 0 0 1 .057-.024h.014l.007.008zm7.876.135c-.057 0-.106.064-.085.16-.014.055.077.246.099.35.02.072-.029.279.014.303.042.024.148-.12.14-.303.015-.095-.027-.446-.133-.502h-.035v-.008zm-6.69.343c-.05 0-.092.032-.07.111 0 .056.133.128.147.255.021.056-.028.223.014.24.036.015.092-.12.113-.248.014-.072-.05-.31-.148-.358H9.16zm2.004.31h.014c.127.04.31.04.466.064.127.008.197.128.07.175-.12.048-.233.08-.233.28.014.095.014.15 0 .174-.028 0-.07-.024-.098-.047-.071-.064-.283-.207-.311-.518 0-.072.042-.128.12-.136l-.028.008zm-4.89.24s-.022.023-.043.055c-.183.335-.197.828-.099.972.057.071.141.103.212.08.113-.056.17-.32.141-.415-.035-.071-.07-.08-.106-.024-.084.184-.113.056-.12-.047-.014-.2 0-.383.022-.526.007-.072.007-.104 0-.096h-.008zm6.273.437s-.028 0-.042.008c0 0-.135.096-.177.168-.028.024-.021.04-.014.08.021.047.056.031.092.007.05-.008.077.032.07.104-.02.087.014.12.014.127 0 .008.05.056.113.016.127-.056.205-.103.381-.151.05 0 .043-.144-.028-.144-.091 0-.183.008-.275.096-.056.016-.07-.024-.085-.064-.014-.087.036-.151.021-.215 0 0-.028-.032-.07-.032zm4.015.168h-.085c-.035.008-.049.032-.056.08 0 .079.05.079.092.103.028.04.042.071 0 .127-.043.04-.07.064-.113.112-.021.04-.035.095.028.111.113.032.367-.151.367-.16.042-.03.028-.103.021-.103-.02-.031-.077-.016-.12-.016-.014 0-.077-.008-.05-.063.022-.04.03-.056.05-.104.014-.04 0-.071-.063-.095-.035 0-.057-.008-.078 0l.007.008zm-1.68 3.838c-.183.056-.183.271-.063.367-1.962 0-4.975-.04-5.617-.04-.36 0-1.503-.048-1.524-.048.247.406.6.486 1.065.494.875 0 4.912-.016 6.062-.016-.085.167.007.43.07.478h.008c.077.024.113-.04.134-.088.12.016.818.024.882 0 .042.072.085.136.17.128.14-.032.253-.056.26-.383 0 0-.014-.557-.338-.525-.078.016-.297.04-.297.04a6.513 6.513 0 0 0-.713-.048c.029-.04.071-.191.015-.24-.014-.015-.036-.023-.064-.015-.014-.024-.021-.08-.028-.096l-.021-.008zm.135.797c.29.016.557 0 .84.016.042.04.02.143 0 .159h-.24v-.016c-.022-.072-.184-.072-.22-.008v.008c-.126.016-.24 0-.366-.008-.035-.056-.035-.143.014-.167l-.028.016z",
            fill: "#fff"
          })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_4901_836"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "24",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'screen':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "Layer_1"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M21 1.8H3c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h8v1.5H8c-.6 0-1 .4-1 1s.4 1 1 1h8c.6 0 1-.4 1-1s-.4-1-1-1h-3v-1.5h8c1.1 0 2-.9 2-2v-13c0-1.2-.9-2-2-2zm-18 15v-13h18v13H3z"
          }));
        case 'search':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "search"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "search-2",
            d: "M21.7 20.3l-4.5-4.5c2.9-3.7 2.3-9-1.4-11.9s-9-2.3-11.9 1.4-2.3 9 1.4 11.9c3.1 2.4 7.4 2.4 10.5 0l4.5 4.5c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4zM4.1 10.5C4.1 7 7 4.1 10.5 4.1S17 7 17 10.5 14.1 17 10.5 17c-3.5 0-6.4-2.9-6.4-6.5z"
          }));
        case 'search-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "search-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "search-alt-2",
            d: "M17.1 15.5C19.8 12 19.2 7 15.7 4.3h-.1C12.1 1.4 7 2 4.2 5.5S2 14.2 5.5 16.9l.1.1c2.9 2.3 7.1 2.3 10 0l4.5 4.4 1.4-1.4-4.4-4.5zm-6.5 1.1c-3.4 0-6.1-2.7-6-6.1 0-3.4 2.7-6.1 6.1-6 3.3 0 6 2.7 6 6.1.1 3.3-2.6 6-5.9 6.1 0-.1-.1-.1-.2-.1z"
          }));
        case 'SEK':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_4901_837)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 4H0v16h24V4z",
            fill: "#006AA7"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M10.313 4H7.532v16h2.78V4z",
            fill: "#FECC00"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 10.4H0v3.2h24v-3.2z",
            fill: "#FECC00"
          })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_4901_837"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "24",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'settings':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "Layer_1"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "settings",
            transform: "translate(.5 .5)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Union_3",
            d: "M10.4 22.5c-1.1 0-1.9-.9-1.9-1.9v-.4c-.3-.1-.7-.3-1-.4l-.3.3c-.8.7-1.9.7-2.7 0L3 18.6c-.7-.7-.7-2 0-2.7l.3-.3c-.2-.3-.3-.7-.4-1h-.5c-1.1 0-1.9-.9-1.9-1.9v-2.2c0-1.1.9-1.9 1.9-1.9h.4c.1-.3.3-.7.4-1l-.3-.4c-.7-.7-.7-2 0-2.7L4.4 3c.8-.7 1.9-.7 2.7 0l.3.3c.3-.2.7-.3 1-.4v-.5c0-1.1.9-1.9 1.9-1.9h2.2c1.1 0 1.9.9 1.9 1.9v.4c.3.1.7.3 1 .4l.3-.3c.8-.7 1.9-.7 2.7 0l1.5 1.5c.7.7.7 2 0 2.7l-.3.3c.2.3.3.7.4 1h.4c1.1 0 1.9.9 1.9 1.9v2.2c0 1.1-.9 1.9-1.9 1.9H20c-.1.3-.3.7-.4 1l.3.3c.7.7.7 2 0 2.7l-1.5 1.5c-.8.7-1.9.7-2.7 0l-.3-.3c-.3.2-.7.3-1 .4v.4c0 1.1-.9 1.9-1.9 1.9h-2.1zm-2.6-4.8c.6.4 1.2.6 1.9.8.4.1.8.5.8 1v1.1h2v-1.1c0-.5.3-.9.8-1 .7-.2 1.3-.4 1.9-.8.4-.2.9-.2 1.2.2l.8.8 1.4-1.4-.8-.8c-.3-.3-.4-.8-.2-1.2.4-.6.6-1.2.8-1.9.1-.4.5-.8 1-.8h1.1v-2h-1.1c-.5 0-.9-.3-1-.8-.2-.7-.4-1.3-.8-1.9-.2-.4-.2-.9.2-1.2l.8-.8-1.4-1.4-.8.8c-.3.3-.8.4-1.2.2-.6-.4-1.2-.6-1.9-.8-.4-.1-.8-.5-.8-1V2.5h-2v1.1c0 .5-.3.9-.8 1-.6.1-1.3.4-1.9.7-.4.3-.9.2-1.2-.1l-.8-.8-1.4 1.4.8.8c.3.3.4.8.2 1.2-.4.6-.7 1.3-.9 1.9-.1.4-.5.8-1 .8h-1v2h1.1c.5 0 .9.3 1 .8.2.7.4 1.3.8 1.9.2.4.2.9-.2 1.2l-.8.8 1.4 1.4.8-.8c.3-.3.8-.4 1.2-.1zm-.3-6.2c0-2.2 1.8-4 4-4s4 1.8 4 4-1.8 4-4 4-4-1.8-4-4zm2 0c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2z"
          })));
        case 'SGD':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_27784_1800)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M0 4h24v16H0V4z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M0 4h24v8H0V4z",
            fill: "#ED2939"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M4.615 10.981a2.49 2.49 0 1 0 0-4.981 2.49 2.49 0 0 0 0 4.981z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M5.743 10.981a2.49 2.49 0 1 0 0-4.981 2.49 2.49 0 0 0 0 4.981z",
            fill: "#ED2939"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M5.978 6.414l-.381 1.173.997-.725H5.361l.998.725-.381-1.173zM7.953 7.849H6.72l.997.725-.38-1.173-.382 1.173.998-.725zM4.757 10.17l.998-.724H4.52l.998.725-.381-1.173-.381 1.173zM7.199 10.17l-.382-1.172-.38 1.173.997-.725H6.201l.998.725zM4.002 7.849L5 8.574 4.62 7.4l-.382 1.173.998-.725H4.002z",
            fill: "#fff"
          })), /*#__PURE__*/_react.default.createElement("rect", {
            x: ".5",
            y: "4.5",
            width: "23",
            height: "15",
            rx: ".5",
            stroke: "#F0F0F0"
          }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_27784_1800"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "24",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'share':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "share"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4677",
            d: "M18.7 7.3l-5-5c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4L15.6 7H10c-2.8 0-5 2.2-5 5v9c0 .6.4 1 1 1s1-.4 1-1v-9c0-1.7 1.3-3 3-3h5.6l-3.3 3.3c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l5-5c.4-.4.4-1 0-1.4z"
          }));
        case 'share-nodes':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "share-nodes"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_9384",
            d: "M18 14c-1.2 0-2.2.5-3 1.4l-5.1-2.5c.1-.6.1-1.1 0-1.7L15 8.6c1.4 1.6 3.9 1.8 5.6.3 1.6-1.4 1.8-3.9.3-5.6S17 1.5 15.3 3c-1.1.9-1.5 2.4-1.2 3.8L9 9.4C7.6 7.7 5 7.5 3.4 9s-1.9 4-.4 5.6 4 1.9 5.6.4l.4-.4 5.1 2.5c-.5 2.2.9 4.3 3.1 4.7 2.2.5 4.3-.9 4.7-3.1.5-2.2-.9-4.3-3.1-4.7H18m0-10c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2M6 14c-1.1 0-2-.9-2-2s.9-2 2-2c.8 0 1.5.4 1.8 1.1.5 1 .1 2.2-.9 2.7-.3.1-.6.2-.9.2m12 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2"
          }));
        case 'shield':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "shield"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10849",
            transform: "translate(-1104.239 -530.998)"
          }, /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10847"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4675",
            d: "M1115 546c-.3 0-.5-.1-.7-.3l-2.7-2.5c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l2 1.9 4.7-4.4c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-5.3 5c-.3.2-.5.3-.8.3z"
          })), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10848"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4676",
            d: "M1116.3 554h-.1c-.4 0-9.9-1.3-10-17 0-.5.3-.9.8-1 3.1-.7 6.1-2 8.7-3.8.4-.3.8-.3 1.2 0 2.6 1.8 5.6 3.1 8.7 3.8.5.1.8.5.8 1-.1 15.7-9.6 16.9-10 17h-.1zm-8-16.2c.4 12.3 7.1 14 8.1 14.2 1-.2 7.7-1.8 8.1-14.2-2.9-.7-5.6-1.9-8.1-3.6-2.5 1.7-5.3 2.9-8.1 3.6z"
          }))));
        case 'shop':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "shop"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_9392",
            d: "M24 9.8c0-.2-.1-.4-.1-.5l-1.9-3V2.5c0-.6-.4-1-1-1H3c-.6 0-1 .4-1 1v3.7l-1.9 3c0 .2-.1.4-.1.6 0 1.4.8 2.7 2 3.3v8.4c0 .6.4 1 1 1h18c.6 0 1-.4 1-1V13c1.2-.6 2-1.9 2-3.2m-3.8 1.7c-1 0-1.7-.8-1.8-1.8v-.2l-.3-2.1h2.3L22 10c-.1.9-.9 1.5-1.8 1.5m-3.7-1.7c0 1-.8 1.7-1.8 1.7S13 10.7 13 9.7V7.5h3.1l.4 2.3zm-11-.2v.1c0 1-.8 1.7-1.8 1.7-.9 0-1.6-.6-1.7-1.5l1.5-2.5h2.3l-.3 2.2zm2.4-2.1H11v2.2c0 1-.7 1.8-1.7 1.8s-1.8-.7-1.8-1.7l.4-2.3zm12.1-2H4v-2h16v2zm-10 11h4v4h-4v-4zm6 4v-5c0-.6-.4-1-1-1H9c-.6 0-1 .4-1 1v5H4v-7c1-.1 1.9-.5 2.5-1.2 1.4 1.5 3.7 1.6 5.2.3l.3-.3c1.4 1.5 3.7 1.6 5.2.3l.3-.3c.6.7 1.5 1.1 2.5 1.2v7h-4z"
          }));
        case 'signature':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "signature"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10701",
            transform: "translate(-938.5 -409.806)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4487",
            d: "M960.2 417.5c.4-.4.4-1 0-1.4l-4-4c-.4-.4-1-.4-1.4 0l-14 14c-.2.2-.3.4-.3.7v4c0 .6.4 1 1 1h4c.3 0 .5-.1.7-.3l14-14zm-4.7-3.3l2.6 2.6-1.6 1.6-2.6-2.6 1.6-1.6zm-10.4 15.6h-2.6v-2.6l10-10 2.6 2.6-10 10z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4488",
            d: "M959.5 429.8h-9c-.6 0-1 .4-1 1s.4 1 1 1h9c.6 0 1-.4 1-1s-.4-1-1-1z"
          })));
        case 'slider-h':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "slider-h"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10882",
            transform: "translate(-1211.5 -227.806)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4702",
            d: "M1214.5 233.8h13v1c0 .6.4 1 1 1s1-.4 1-1v-1h3c.6 0 1-.4 1-1s-.4-1-1-1h-3v-1c0-.6-.4-1-1-1s-1 .4-1 1v1h-13c-.6 0-1 .4-1 1s.4 1 1 1z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4703",
            d: "M1232.5 238.8h-13v-1c0-.6-.4-1-1-1s-1 .4-1 1v1h-3c-.6 0-1 .4-1 1s.4 1 1 1h3v1c0 .6.4 1 1 1s1-.4 1-1v-1h13c.6 0 1-.4 1-1s-.4-1-1-1z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4704",
            d: "M1232.5 245.8h-3v-1c0-.6-.4-1-1-1s-1 .4-1 1v1h-13c-.6 0-1 .4-1 1s.4 1 1 1h13v1c0 .6.4 1 1 1s1-.4 1-1v-1h3c.6 0 1-.4 1-1s-.4-1-1-1z"
          })));
        case 'sliders-h':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "Layer_1"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Layer_2_1_"
          }, /*#__PURE__*/_react.default.createElement("g", {
            id: "Layer_2-2"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M2 5h2c.6 0 1-.4 1-1s-.4-1-1-1H2c-.6 0-1 .4-1 1s.4 1 1 1zM22 11h-3v-1c0-.6-.4-1-1-1s-1 .4-1 1v4c0 .6.4 1 1 1s1-.4 1-1v-1h3c.6 0 1-.4 1-1s-.4-1-1-1zM2 13h12c.6 0 1-.4 1-1s-.4-1-1-1H2c-.6 0-1 .4-1 1s.4 1 1 1zM22 19h-9v-1c0-.6-.4-1-1-1s-1 .4-1 1v4c0 .6.4 1 1 1s1-.4 1-1v-1h9c.6 0 1-.4 1-1s-.4-1-1-1zM8 19H2c-.6 0-1 .4-1 1s.4 1 1 1h6c.6 0 1-.4 1-1s-.4-1-1-1zM8 7c.6 0 1-.4 1-1V5h13c.6 0 1-.4 1-1s-.4-1-1-1H9V2c0-.6-.4-1-1-1s-1 .4-1 1v4c0 .6.4 1 1 1z"
          }))));
        case 'smiley':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "smiley"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10905",
            transform: "translate(-1261.505 -332.81)"
          }, /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10901"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4732",
            d: "M1273.5 355.8c-6.1 0-11-4.9-11-11 0-2.9 1.2-5.7 3.2-7.8 4.3-4.3 11.3-4.3 15.6 0 4.3 4.3 4.3 11.3 0 15.6-2.1 2-4.9 3.2-7.8 3.2zm-6.4-17.4c-3.5 3.5-3.5 9.2 0 12.7s9.2 3.5 12.7 0 3.5-9.2 0-12.7-9.1-3.5-12.7 0z"
          })), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10902"
          }, /*#__PURE__*/_react.default.createElement("circle", {
            id: "Ellipse_45",
            cx: "1270",
            cy: "342.3",
            r: "1.5"
          })), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10903"
          }, /*#__PURE__*/_react.default.createElement("circle", {
            id: "Ellipse_46",
            cx: "1277",
            cy: "342.3",
            r: "1.5"
          })), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10904"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4733",
            d: "M1273.5 349.8c-2 .1-3.9-.8-5.1-2.4-.3-.4-.2-1.1.2-1.4.4-.3 1.1-.2 1.4.2.9 1 2.2 1.6 3.5 1.6 1.4.1 2.8-.6 3.6-1.8.3-.5.9-.6 1.4-.4.5.3.6.9.4 1.4-1.2 1.8-3.3 2.9-5.4 2.8z"
          }))));
        case 'sort':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "sort"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4248",
            d: "M6 15l6 7 6-7H6z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4249",
            d: "M18 9l-6-7-6 7h12z"
          }));
        case 'sort-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "sort-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4451",
            d: "M2 8.7l1.4 1.4 2.3-2.3v12.6h2V7.8l2.3 2.3 1.4-1.4L6.7 4 2 8.7z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4452",
            d: "M20 14.7L17.7 17V4.4h-2V17l-2.3-2.3-1.4 1.4 4.7 4.7 4.7-4.7-1.4-1.4z"
          }));
        case 'sort-down':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "sort-down"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10853",
            transform: "translate(-998.926 -635.806)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4595",
            d: "M1020.6 641.8l-10 12-10-12h20z"
          })));
        case 'sort-up':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "sort-up"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10854",
            transform: "rotate(180 511.314 329.903)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4595",
            d: "M1020.6 641.8l-10 12-10-12h20z"
          })));
        case 'spin':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M22 13c-.6 0-1-.4-1-1 0-5-4-9-9-9-.6 0-1-.4-1-1s.4-1 1-1c6.1 0 11 4.9 11 11 0 .6-.4 1-1 1z"
          }));
        case 'star':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "star"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10765",
            transform: "translate(-946.5 -531.806)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4544",
            d: "M969.4 541c-.2-.6-.7-1-1.2-1.1l-5.5-1.1-2.7-5.2c-.5-.8-1.5-1.1-2.3-.6-.2.1-.4.3-.6.6l-2.7 5.2-5.5 1.1c-.6.1-1.1.6-1.2 1.1-.2.6-.1 1.2.3 1.7l3.9 4.3-.7 5.9c-.1.6.2 1.2.7 1.6.5.4 1.1.4 1.7.2l5.1-2.5 5.1 2.5c.5.3 1.2.2 1.7-.2s.7-1 .7-1.6l-.7-5.9 3.9-4.3c.1-.4.2-1.1 0-1.7z"
          })));
        case 'success':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "success"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Union_14",
            d: "M1 12C1 5.9 5.9 1 11.9 1c6.1 0 11 4.9 10.9 11 0 6.1-4.9 11-10.9 11S1 18.1 1 12zm2 0c0 5 4 9 8.9 9 5 0 9-4 8.9-9 0-5-4-9-8.9-9S3 7 3 12zm6.7 3.7l-3-3c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l2.3 2.3 5.3-5.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-6 6c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3z"
          }));
        case 'sun':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "sun"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15804"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8486",
            d: "M12 18c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6m0-10c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8487",
            d: "M22 13h-1c-.6 0-1-.4-1-1s.4-1 1-1h1c.6 0 1 .4 1 1s-.4 1-1 1"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8488",
            d: "M3 13H2c-.6 0-1-.4-1-1s.4-1 1-1h1c.6 0 1 .4 1 1s-.4 1-1 1"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8489",
            d: "M18.4 6.6c-.6 0-1-.4-1-1 0-.3.1-.5.3-.7l.7-.7c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-.7.7c-.2.2-.5.3-.7.3"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8490",
            d: "M4.9 20.1c-.6 0-1-.4-1-1 0-.3.1-.5.3-.7l.7-.7c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-.7.7c-.2.2-.4.3-.7.3"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8491",
            d: "M5.6 6.6c-.3 0-.5-.1-.7-.3l-.7-.7c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l.7.7c.4.4.4 1 0 1.4-.1.2-.4.3-.7.3"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8492",
            d: "M19.1 20.1c-.3 0-.5-.1-.7-.3l-.7-.7c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l.7.7c.4.4.4 1 0 1.4-.2.2-.5.3-.7.3"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8493",
            d: "M12 4c-.6 0-1-.4-1-1V2c0-.6.4-1 1-1s1 .4 1 1v1c0 .6-.4 1-1 1"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8494",
            d: "M12 23c-.6 0-1-.4-1-1v-1c0-.6.4-1 1-1s1 .4 1 1v1c0 .6-.4 1-1 1"
          })));
        case 'swap-right':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "swap-right"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4681",
            d: "M19.9 15.4c.2-.4.1-.8-.2-1.1l-6-6c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l4.3 4.3H5c-.6 0-1 .4-1 1s.4 1 1 1h14c.4 0 .8-.2.9-.6z"
          }));
        case 'tachometer-average':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "tachometer-average"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_7516",
            d: "M13 5c0-.6-.4-1-1-1s-1 .4-1 1c-5.7.6-10 5.3-10 11 0 .6.4 1 1 1s1-.4 1-1c0-2 .7-4 2-5.6l.3.3c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4L6.4 9C7.7 7.9 9.3 7.2 11 7.1v6.1c-1.6.6-2.4 2.3-1.8 3.8.6 1.6 2.3 2.4 3.8 1.8s2.4-2.3 1.8-3.8c-.3-.9-1-1.5-1.8-1.8V7.1c1.7.2 3.3.9 4.6 1.9l-.3.3c-.4.4-.4 1 0 1.4s1 .4 1.4 0l.3-.3c1.3 1.6 2 3.6 2 5.6 0 .6.4 1 1 1s1-.4 1-1c0-5.7-4.3-10.4-10-11zm-1 12c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
          }));
        case 'tachometer-fast':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "tachometer-fast"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_7515",
            d: "M20.4 9l.3-.3c.4-.4.4-1 0-1.4s-1-.4-1.4 0l-.3.3C14.4 3.7 7.4 4.3 3.6 8.9 1.9 10.9 1 13.4 1 16c0 .6.4 1 1 1s1-.4 1-1c0-2 .7-4 2-5.6l.3.3c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4L6.4 9C7.7 7.9 9.3 7.2 11 7.1V8c0 .6.4 1 1 1s1-.4 1-1v-.9c1.7.2 3.3.9 4.6 1.9l-.3.3-4 4c-.4-.2-.9-.3-1.3-.3-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3c0-.4-.1-.9-.3-1.3l4-4 .3-.3c1.3 1.6 2 3.6 2 5.6 0 .6.4 1 1 1s1-.4 1-1c0-2.6-.9-5.1-2.6-7zM12 17c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
          }));
        case 'tachometer-fastest':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "tachometer-fastest"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_7518",
            d: "M23 15c-.6-6-6-10.5-12.1-9.9C5.3 5.6 1 10.4 1 16c0 .6.4 1 1 1s1-.4 1-1c0-2 .7-4 2-5.6l.3.3c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4L6.4 9C7.7 7.9 9.3 7.2 11 7.1V8c0 .6.4 1 1 1s1-.4 1-1v-.9c1.7.2 3.3.9 4.6 1.9l-.3.3c-.4.4-.4 1 0 1.4s1 .4 1.4 0l.3-.3c1.1 1.3 1.7 2.9 1.9 4.6h-6.1c-.6-1.6-2.3-2.4-3.8-1.8-1.6.6-2.4 2.3-1.8 3.8s2.3 2.4 3.8 1.8c.9-.3 1.5-1 1.8-1.8H23c.6 0 1-.4 1-1s-.4-1-1-1zm-11 2c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
          }));
        case 'tachometer-slow':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "tachometer-slow"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_7517",
            d: "M12 5c-2.6 0-5.1.9-7 2.6l-.3-.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l.3.3C1.9 11 1 13.5 1 16c0 .6.4 1 1 1s1-.4 1-1c0-2 .7-4 2-5.6l.3.3 4 4c-.2.4-.3.9-.3 1.3 0 1.7 1.3 3 3 3s3-1.3 3-3-1.3-3-3-3c-.4 0-.9.1-1.3.3l-4-4-.3-.3C7.7 7.9 9.3 7.2 11 7.1V8c0 .6.4 1 1 1s1-.4 1-1v-.9c1.7.2 3.3.9 4.6 1.9l-.3.3c-.4.4-.4 1 0 1.4s1 .4 1.4 0l.3-.3c1.3 1.6 2 3.6 2 5.6 0 .6.4 1 1 1s1-.4 1-1c0-6.1-4.9-11-11-11zm0 10c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1z"
          }));
        case 'thumb-tack':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "thumb-tack"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Union_17",
            d: "M13.6 20.7l-4.4-4.4-4.4 4.4c-.3.2-.5.3-.8.3-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l4.4-4.4-4.4-4.4c-.3-.4-.4-.7-.3-1.1.2-.4.5-.6.8-.7l6.5-1.1 4.3-4.3c.4-.4 1-.4 1.4 0l4.6 4.6c.4.4.4 1 0 1.4l-4.3 4.3-1.1 6.5c-.1.4-.3.7-.7.8h-.3c-.2.1-.4 0-.6-.2zm-2-11.4c-.1.1-.3.2-.5.3l-4.9.8 7.5 7.5.8-4.9c0-.2.1-.4.3-.5l3.9-3.9-3.2-3.2-3.9 3.9z"
          }));
        case 'thumb-tack-f':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "thumb-tack-f"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_7568",
            d: "M20.7 7.9l-4.6-4.6c-.4-.4-1-.4-1.4 0l-4.3 4.3-6.6 1.1c-.5.1-.9.6-.8 1.2 0 .2.1.4.3.5l4.4 4.4-4.4 4.4c-.4.4-.4 1 0 1.4s1 .4 1.4 0l4.4-4.4 4.4 4.4c.4.4 1 .4 1.4 0 .1-.1.2-.3.3-.5l1.1-6.5 4.3-4.3c.5-.4.5-1 .1-1.4z"
          }));
        case 'thumbs-down':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "thumbs-down"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            transform: "translate(2 2)",
            id: "Group_15744"
          }, /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15743"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8413",
            d: "M19 13c-.6 0-1-.4-1-1V2c0-.6.4-1 1-1s1 .4 1 1v10c0 .6-.4 1-1 1"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8414",
            d: "M11 20h-.6c-1.7 0-3-1.3-3-3v-.5l.4-2.5H2c-1.1 0-2-.9-2-2V6.6C0 6 .1 5.5.4 5l2.1-3.6C3.1.6 4.1 0 5.1 0H14c1.7 0 3 1.3 3 3v8.4c0 .6-.2 1.2-.6 1.7l-4.6 6.5c-.2.2-.5.4-.8.4M5.1 2c-.3 0-.6.2-.8.5L2.1 6c-.1.2-.1.4-.1.6V12h7c.6 0 1 .4 1 1v.2l-.6 3.7c-.1.5.3 1.1.8 1.2H10.5l4.3-6.1c.1-.2.2-.4.2-.6V3c0-.6-.4-1-1-1H5.1zm10.5 10.5z"
          }))));
        case 'thumbs-up':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "thumbs-up"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            transform: "translate(2 2)",
            id: "Group_15738"
          }, /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15736"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8401",
            d: "M1 19c-.6 0-1-.4-1-1V8c0-.6.4-1 1-1s1 .4 1 1v10c0 .6-.4 1-1 1"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8402",
            d: "M14.9 20H6c-1.7 0-3-1.3-3-3V8.6c0-.6.2-1.2.6-1.7L8.2.4c.2-.2.5-.4.8-.4h.6c1.7 0 3 1.3 3 3v.5L12.2 6H18c1.1 0 2 .9 2 2v5.4c0 .5-.1 1.1-.4 1.5l-2.1 3.6c-.6.9-1.6 1.5-2.6 1.5M5.2 8.1c-.1.1-.2.3-.2.5V17c0 .6.4 1 1 1h8.9c.4 0 .7-.2.9-.5l2.1-3.6c.1-.2.1-.3.1-.5V8h-7c-.6 0-1-.4-1-1v-.2l.6-3.7c.1-.5-.3-1.1-.8-1.2-.1.1-.1.1-.2.1h-.1L5.2 8.1z"
          }))));
        case 'ticket':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "ticket"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4709",
            d: "M22.7 9.1l-2.5-2.5c-.4-.4-1-.4-1.4 0-.4.4-1.1.4-1.5 0s-.4-1.1 0-1.5c.4-.4.4-1 0-1.4l-2.5-2.5c-.4-.4-1-.4-1.4 0L1.3 13.5c-.4.4-.4 1 0 1.4l2.5 2.5c.4.4 1 .4 1.4 0 .4-.4 1.1-.4 1.5 0s.4 1.1 0 1.5c-.4.4-.4 1 0 1.4l2.5 2.5c.4.4 1 .4 1.4 0l12.2-12.2c.3-.5.3-1.1-.1-1.5zM9.8 20.6l-1.2-1.2c.7-1.5.1-3.3-1.4-4.1-.8-.4-1.8-.4-2.6 0l-1.2-1.2 4.7-4.7 6.4 6.4-4.7 4.8zm6.1-6.1L9.5 8.1l4.7-4.7 1.2 1.2c-.7 1.5-.1 3.3 1.4 4.1.8.4 1.8.4 2.6 0l1.2 1.2-4.7 4.6z"
          }));
        case 'TR':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_4901_838)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 4H0v16h24V4z",
            fill: "#E30A17"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M8.499 15.969c2.21 0 4.002-1.777 4.002-3.969S10.71 8.031 8.5 8.031 4.496 9.808 4.496 12s1.792 3.969 4.003 3.969z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M9.501 15.171c1.766 0 3.198-1.42 3.198-3.171S11.267 8.829 9.5 8.829 6.304 10.249 6.304 12s1.431 3.171 3.197 3.171z",
            fill: "#E30A17"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M11.668 12l3.614 1.169-2.23-3.052v3.766l2.23-3.052L11.668 12z",
            fill: "#fff"
          })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_4901_838"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "24",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'trash':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "trash"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4671",
            d: "M20.2 7h-2V4c0-.6-.4-1-1-1h-10c-.6 0-1 .4-1 1v3h-2c-.6 0-1 .4-1 1s.4 1 1 1h1v11c0 .6.4 1 1 1h12c.6 0 1-.4 1-1V9h1c.6 0 1-.4 1-1s-.4-1-1-1zm-12-2h8v2h-8V5zm9 14h-10V9h10v10z"
          }));
        case 'trash-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "trash-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "trash-alt-2",
            d: "M19 7h-2V4H7v3H5v2h1v11h12V9h1V7zM9 6h6v1H9V6zm7 12H8V9h8v9z"
          }));
        case 'turn-left':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M14.576 6.363H4.702l3.38-3.387a1.012 1.012 0 0 0 0-1.43 1.006 1.006 0 0 0-1.427 0l-5.11 5.111a1.012 1.012 0 0 0 0 1.43l5.11 5.121a.992.992 0 0 0 .718.294c.263 0 .516-.101.718-.294a1.012 1.012 0 0 0 0-1.43L4.712 8.391h9.864c3.389 0 6.15 2.769 6.15 6.166 0 3.397-2.761 6.165-6.15 6.165H4.824c-.557 0-1.012.456-1.012 1.014s.455 1.014 1.012 1.014h9.752c4.512 0 8.174-3.68 8.174-8.193s-3.672-8.194-8.174-8.194z"
          }));
        case 'upload':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "upload"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Union_11",
            d: "M2 23c-.6 0-1-.4-1-1v-7c0-.6.4-1 1-1s1 .4 1 1v6h18v-6c0-.6.4-1 1-1s1 .4 1 1v7c0 .6-.4 1-1 1H2zm9-7V4.4L6.7 8.7c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l6-6c.1-.1.2-.2.3-.2.2-.1.5-.1.8 0 .1.1.2.1.3.2l6 6c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3L13 4.4V16c0 .6-.4 1-1 1s-1-.4-1-1z"
          }));
        case 'USD':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_4901_839)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M22.588 4H1.412A1.4 1.4 0 0 0 0 5.387v11.098a1.4 1.4 0 0 0 1.412 1.387h21.176A1.4 1.4 0 0 0 24 16.485V5.386A1.4 1.4 0 0 0 22.588 4z",
            fill: "#000"
          }), /*#__PURE__*/_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M24 17.872V4H0v13.872h24z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M24 7.253V6.115H12.099v1.138H24zM24 9.368V8.231H12.099v1.137H24zM24 11.477v-1.13H12.099v1.13H24zM24 5.137V4H12.099v1.137H24z",
            fill: "#FD1813"
          }), /*#__PURE__*/_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.085 11.477V4H.028v7.477h12.057z",
            fill: "#0F238C"
          }), /*#__PURE__*/_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M24 13.64v-1.137H0v1.138h24zM24 15.756V14.62H0v1.137h24zM24 17.872v-1.138H0v1.138h24zM24 20v-1.137H0V20h24z",
            fill: "#FD1813"
          }), /*#__PURE__*/_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.04 8.155l.12-.354-.303-.222h.38l.12-.354.114.354h.374l-.31.222.12.354-.297-.222-.31.222h-.008zM11.04 9.674l.12-.354-.303-.222h.38l.12-.354.114.354h.374l-.31.222.12.354-.297-.222-.31.222h-.008zM11.075 11.185l.12-.353-.31-.222h.38l.114-.354.12.354h.381l-.304.222.12.353-.31-.228-.297.228h-.014zM.586 5.172l.113-.354-.304-.222h.367l.12-.353.12.353h.367l-.303.222.12.354-.304-.222-.296.222zM.614 6.691l.113-.354-.296-.222h.367l.113-.353.12.353h.367l-.297.222.113.354-.303-.222-.297.222zM.635 8.217l.113-.36-.296-.209h.367l.12-.36.113.36h.38l-.303.208.113.361-.296-.222-.304.222H.635zM.635 9.729l.113-.354-.296-.229h.367l.12-.353.113.353h.38l-.303.23.113.353L.946 9.5l-.304.229H.635zM.664 11.241l.12-.347-.304-.222h.367l.12-.36.113.36h.381l-.303.222.12.347-.304-.222-.303.222H.664zM1.638 5.956l.12-.354-.304-.222h.367l.12-.353.113.353h.381l-.303.222.113.354-.297-.222-.303.222h-.007zM1.666 7.447l.12-.354-.304-.222h.367l.12-.353.113.353h.382l-.304.222.12.354-.304-.222-.303.222h-.007zM1.666 9.022l.12-.354-.304-.222h.367l.12-.354.113.354h.382l-.304.222.12.354-.304-.222-.303.222h-.007zM1.638 10.596l.12-.354-.304-.222h.367l.12-.36.113.36h.381l-.303.222.113.354-.297-.222-.303.222h-.007zM2.69 5.144l.12-.353-.304-.222h.367l.12-.354.12.354h.367l-.296.222.112.353-.303-.222-.304.222zM2.71 6.663l.12-.353-.303-.222h.381l.12-.354.113.354h.367l-.303.222.12.353-.297-.222-.31.222H2.71zM2.746 8.182l.12-.353-.31-.222h.38l.12-.354.106.354h.382l-.304.222.113.353-.297-.222-.303.222h-.007zM2.746 9.708l.12-.36-.31-.222h.38l.12-.354.106.354h.382l-.304.222.113.36-.297-.222-.303.222h-.007zM2.774 11.213l.12-.346-.303-.23h.367l.12-.353.113.354h.38l-.303.229.12.346-.303-.229-.304.23h-.007zM3.748 5.928l.12-.354-.303-.222h.367L4.052 5l.113.353h.38l-.303.222.12.361-.303-.229-.304.222h-.007zM3.776 7.42l.12-.354-.303-.222h.367l.12-.354.12.354h.367l-.303.222.12.353-.304-.222-.304.222zM3.776 9l.12-.353-.303-.222h.367l.12-.36.12.36h.367l-.303.222.12.354-.304-.222L3.776 9zM3.748 10.568l.12-.354-.303-.221h.367l.12-.354.113.354h.38l-.303.221.12.354-.303-.208-.304.208h-.007zM4.8 5.124l.12-.354-.304-.222h.382l.113-.36.12.36h.367l-.304.222.12.354-.303-.222-.304.222H4.8zM4.828 6.636l.113-.354-.303-.222h.38l.114-.354.12.354h.38l-.31.222.12.354-.303-.222-.297.222h-.014zM4.856 8.155L4.97 7.8l-.296-.222h.367l.113-.354.12.354h.381l-.303.222.12.354-.311-.222-.296.222h-.008zM4.856 9.674l.113-.354-.296-.222h.367l.113-.354.12.354h.381l-.303.222.12.354-.311-.222-.296.222h-.008zM4.885 11.185l.113-.353-.297-.222h.367l.12-.354.12.354h.367l-.303.222.12.353-.304-.228-.303.228zM5.859 5.907l.113-.353-.297-.222h.367l.12-.354.113.354h.367l-.296.222.12.353-.304-.222-.303.222zM5.88 7.399L6 7.045l-.304-.222h.368l.12-.354.12.354h.367l-.304.222.12.354-.303-.222-.304.222zM5.88 8.973l.12-.36-.304-.223h.368l.12-.353.12.353h.367l-.304.222.12.361-.303-.222-.304.222zM5.859 10.54l.113-.353-.297-.222h.367l.12-.354.113.354h.367l-.296.222.12.354-.304-.222-.303.221zM6.91 5.089l.12-.354-.303-.222h.367l.12-.353.12.353h.367l-.303.222.12.354-.304-.222-.303.222zM6.939 6.615l.113-.354-.304-.222h.367l.12-.36.12.36h.367l-.296.222.113.354-.304-.222-.296.222zM6.96 8.127l.12-.354-.296-.222h.367l.12-.354.113.354h.374l-.304.222.113.354-.296-.222-.311.222zM6.96 9.646l.12-.354-.296-.222h.367l.12-.354.113.354h.374l-.304.222.113.354-.296-.222-.311.222zM6.995 11.158l.12-.347-.303-.222h.367l.12-.354.113.354h.38l-.303.222.12.347-.303-.222-.304.222h-.007zM7.97 5.873l.112-.354-.296-.229h.367l.12-.354.113.354h.381l-.303.229.112.354-.296-.222-.304.222H7.97zM7.99 7.37l.12-.353-.303-.229h.367l.12-.354.113.354h.381l-.303.23.12.353-.304-.222-.303.222H7.99zM7.99 8.938l.12-.353-.303-.222h.367l.12-.354.113.354h.381l-.303.222.12.353-.304-.222-.303.222H7.99zM7.97 10.513l.112-.354-.296-.222h.367l.12-.354.113.354h.381l-.303.222.112.354-.296-.222-.304.222H7.97zM10.99 5.124l.12-.354-.303-.222h.367l.12-.36.12.36h.367l-.303.222.12.354-.304-.222-.303.222zM11.019 6.636l.12-.354-.304-.222h.367l.12-.354.12.354h.367l-.303.222.12.354-.304-.222-.303.222zM9.014 5.061l.12-.354-.303-.221h.367l.12-.354.12.354h.367l-.304.221.12.354-.303-.222-.304.222zM9.042 6.58l.12-.354-.303-.215h.381l.113-.353.12.353h.367l-.304.222.12.354-.303-.222-.304.222-.007-.007zM9.078 8.106l.113-.354-.304-.222h.381l.12-.36.113.36h.374l-.31.222.12.354-.297-.222-.303.222h-.007zM9.078 9.625l.113-.354-.304-.222h.381l.12-.353.113.353h.374l-.31.222.12.354-.297-.222-.303.222h-.007zM9.099 11.13l.12-.347-.304-.222h.367l.12-.36.113.36h.381l-.303.222.12.347-.304-.208-.303.208h-.007zM10.073 5.852l.12-.354-.31-.229h.38l.12-.353.106.353h.382l-.304.23.113.353-.296-.229-.304.229h-.007zM10.101 7.343l.12-.354-.303-.229h.367l.12-.353.113.353h.38l-.303.23.12.353-.303-.229-.304.23h-.007zM10.101 8.91l.12-.353-.303-.222h.367l.12-.354.113.354h.38l-.303.222.12.354-.303-.222-.304.222h-.007zM10.073 10.492l.12-.354-.31-.222h.38l.12-.36.106.36h.382l-.304.222.113.354-.296-.222-.304.222h-.007z",
            fill: "#fff"
          })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_4901_839"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "24",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'usd-circle':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "usd-circle"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            transform: "translate(1 1.01)",
            id: "Group_15785"
          }, /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15784"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8451",
            d: "M11 22C4.9 22 0 17.1 0 11S4.9 0 11 0s11 4.9 11 11c0 2.9-1.2 5.7-3.2 7.8-2.1 2-4.9 3.2-7.8 3.2M4.6 4.6c-3.5 3.5-3.5 9.2 0 12.7s9.2 3.5 12.7 0 3.5-9.2 0-12.7-9.2-3.5-12.7 0"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8452",
            d: "M14.8 12.7c0 .7-.3 1.3-.8 1.8-.6.5-1.4.8-2.2.8v1.6h-1v-1.5c-1 0-2-.2-3-.6v-1.5c.5.2 1 .4 1.5.5s1 .2 1.5.2v-2.7l-.6-.3c-.7-.2-1.3-.6-1.8-1.1-.4-.5-.6-1-.5-1.6 0-.6.3-1.3.8-1.7.6-.5 1.4-.7 2.1-.8V4.6h1v1.2c1 0 1.9.2 2.8.6L14 7.8c-.7-.3-1.5-.5-2.3-.5V10l.6.2c.7.2 1.4.6 1.9 1.1.4.3.6.8.6 1.4M9.6 8.3c0 .3.1.5.3.7l.9.6V7.3c-.3 0-.6.2-.9.4-.2.1-.3.3-.3.6m3.5 4.5c0-.3-.1-.5-.3-.7-.3-.2-.6-.4-1-.5v2.3c.8-.1 1.2-.5 1.3-1.1"
          }))));
        case 'user':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "user"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Union_1",
            d: "M5 22.1c-.6 0-1-.4-1-1 0-4.4 3.6-8 8-8s8 3.6 8 8c0 .6-.4 1-1 1H5zm1.1-2h11.8c-.5-2.9-3-5-5.9-5-2.9 0-5.4 2.1-5.9 5zM7 7c0-2.8 2.2-5 5-5s5 2.2 5 5-2.2 5-5 5-5-2.2-5-5zm2 0c0 1.7 1.3 3 3 3s3-1.3 3-3-1.3-3-3-3-3 1.3-3 3z"
          }));
        case 'user-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "user-alt"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4458",
            d: "M17 8c0 2.8-2.2 5.1-5 5.1s-5.1-2.2-5.1-5S9.1 3 11.9 3 17 5.2 17 8z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4459",
            d: "M11.9 14c-4 0-7.4 3-7.9 7h16c-.6-4-4-7-8.1-7z"
          }));
        case 'user-arrow-down':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "user-arrow-down"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8386",
            d: "M17.3 11.4l-.3.3V10c0-.6-.4-1-1-1s-1 .4-1 1v1.7l-.3-.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l2 2c.1.1.2.2.3.2.2.1.5.1.8 0 .1-.1.2-.1.3-.2l2-2c.4-.4.4-1 0-1.4s-1-.4-1.4 0z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8387",
            d: "M23 12c0-3.9-3.1-7-7-7-.8 0-1.6.1-2.3.4-.9-2.6-3.7-4-6.3-3.1S3.4 6 4.3 8.6c.6 2 2.6 3.4 4.7 3.4 0 .3 0 .7.1 1H9c-4.4 0-8 3.6-8 8 0 .6.4 1 1 1h14c.6 0 1-.4 1-1 0-.7-.1-1.4-.3-2 3.6-.4 6.3-3.4 6.3-7zM9 10c-1.7 0-3-1.3-3-3s1.3-3 3-3c1.4 0 2.6 1 2.9 2.3-1.2.9-2.1 2.2-2.6 3.7H9zM3.1 20c.5-2.9 3-5 5.9-5 .2 0 .5 0 .7.1 1 2 2.8 3.4 4.9 3.8.1.4.3.8.3 1.1H3.1zM16 17c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5z"
          }));
        case 'user-arrow-up':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "user-arrow-up"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8384",
            d: "M16.7 9.2c-.4-.4-1-.4-1.4 0l-2 2c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l.3-.3V14c0 .6.4 1 1 1s1-.4 1-1v-1.7l.3.3c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4l-2-2z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8385",
            d: "M23 12c0-3.9-3.1-7-7-7-.8 0-1.6.1-2.3.4-.9-2.6-3.7-4-6.3-3.1S3.4 6 4.3 8.6c.6 2 2.6 3.4 4.7 3.4 0 .3 0 .7.1 1H9c-4.4 0-8 3.6-8 8 0 .6.4 1 1 1h14c.6 0 1-.4 1-1 0-.7-.1-1.4-.3-2 3.6-.4 6.3-3.4 6.3-7zM9 10c-1.7 0-3-1.3-3-3s1.3-3 3-3c1.4 0 2.6 1 2.9 2.3-1.2.9-2.1 2.2-2.6 3.7H9zM3.1 20c.5-2.9 3-5 5.9-5 .2 0 .5 0 .7.1 1 2 2.8 3.4 4.9 3.8.1.4.3.8.3 1.1H3.1zM16 17c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5z"
          }));
        case 'user-f':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "user-f"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10879",
            transform: "translate(-1154.5 -306.806)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4695",
            d: "M1166.5 319.8c-4.4 0-8 3.6-8 8 0 .6.4 1 1 1h14c.6 0 1-.4 1-1 0-4.4-3.6-8-8-8z"
          }), /*#__PURE__*/_react.default.createElement("circle", {
            id: "Ellipse_37",
            cx: "1166.5",
            cy: "313.8",
            r: "5"
          })));
        case 'user-friends':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "user-friends"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4705",
            d: "M9 12c1.1 0 2.1-.4 3-1 2.2 1.7 5.3 1.2 7-1s1.2-5.3-1-7c-1.8-1.4-4.3-1.4-6 0-.9-.7-1.9-1-3-1-2.8 0-5 2.2-5 5s2.2 5 5 5zm9-5c0 1.6-1.3 3-3 3-.6 0-1.2-.2-1.7-.5.9-1.5.9-3.4 0-4.9 1.4-.9 3.2-.6 4.2.8.3.4.5 1 .5 1.6zM9 4c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4706",
            d: "M15 13c-1.9.8-4.1.8-6 0-4.4 0-8 3.6-8 8 0 .6.4 1 1 1h20c.6 0 1-.4 1-1 0-4.4-3.6-8-8-8zm-7 7H3.1c.5-3.3 3.6-5.5 6.9-4.9 2.5.4 4.5 2.4 4.9 4.9H8zm8.9 0c-.2-1.9-1.2-3.7-2.6-5h.7c2.9 0 5.4 2.1 5.9 5h-4z"
          }));
        case 'user-friends-f':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "user-friends-f"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10883",
            transform: "translate(-1218.5 -306.806)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4710",
            d: "M1227.5 318.8c1.8-1.4 4.2-1.4 6 0 2.8 0 5-2.2 5-5s-2.2-5-5-5c-1.1 0-2.2.4-3 1-.9-.7-1.9-1-3-1-2.8 0-5 2.2-5 5s2.2 5 5 5zm0-8c1.7 0 3 1.3 3 3s-1.4 3-3 3-3-1.4-3-3c0-1.7 1.3-3 3-3z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4711",
            d: "M1233.5 319.8c-1.9.8-4.1.8-6 0-4.4 0-8 3.6-8 8 0 .6.4 1 1 1h20c.6 0 1-.4 1-1 0-4.4-3.6-8-8-8zm-6 2c2.9 0 5.4 2.1 5.9 5h-11.8c.5-2.9 3-5 5.9-5z"
          })));
        case 'user-plus':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "user-plus"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15717",
            transform: "translate(-1128.5 -159.806)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8388",
            d: "M1150.5 170.8h-3v-3c0-.6-.4-1-1-1s-1 .4-1 1v3h-3c-.6 0-1 .4-1 1s.4 1 1 1h3v3c0 .6.4 1 1 1s1-.4 1-1v-3h3c.6 0 1-.4 1-1s-.4-1-1-1z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8389",
            d: "M1137.5 171.8c2.8 0 5-2.2 5-5s-2.2-5-5-5-5 2.2-5 5 2.2 5 5 5zm0-8c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8390",
            d: "M1137.5 172.8c-4.4 0-8 3.6-8 8 0 .6.4 1 1 1h14c.6 0 1-.4 1-1 0-4.4-3.6-8-8-8zm-5.9 7c.5-3.3 3.6-5.5 6.9-4.9 2.5.4 4.5 2.4 4.9 4.9h-11.8z"
          })));
        case 'users-f':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "users-f"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10880",
            transform: "translate(-717 -2829.333)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4696",
            d: "M729 2842.1c-3.3 0-6 2.7-6 6 0 .5.4.9.9.9h10.3c.5 0 .9-.4.9-.9-.1-3.3-2.8-6-6.1-6z"
          }), /*#__PURE__*/_react.default.createElement("circle", {
            id: "Ellipse_38",
            cx: "729",
            cy: "2837.7",
            r: "3.3"
          }), /*#__PURE__*/_react.default.createElement("circle", {
            id: "Ellipse_39",
            cx: "736.5",
            cy: "2839.5",
            r: "2.5"
          }), /*#__PURE__*/_react.default.createElement("circle", {
            id: "Ellipse_40",
            cx: "721.5",
            cy: "2839.5",
            r: "2.5"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4697",
            d: "M723.8 2843.5c-.7-.4-1.5-.6-2.3-.6-2.5 0-4.5 2-4.5 4.5 0 .4.3.6.6.6h4.4c0-1.7.7-3.3 1.8-4.5z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4698",
            d: "M736.5 2842.9c-.8 0-1.6.2-2.3.6 1.1 1.2 1.7 2.8 1.8 4.5h4.4c.4 0 .6-.3.6-.6 0-2.5-2-4.5-4.5-4.5z"
          })));
        case 'venus':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "venus"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4723",
            d: "M19 8c0-3.9-3.1-7-7-7S5 4.1 5 8c0 3.5 2.6 6.4 6 6.9V18H9c-.6 0-1 .4-1 1s.4 1 1 1h2v2c0 .6.4 1 1 1s1-.4 1-1v-2h2c.6 0 1-.4 1-1s-.4-1-1-1h-2v-3.1c3.4-.5 6-3.4 6-6.9zM7 8c0-2.8 2.2-5 5-5s5 2.2 5 5-2.2 5-5 5-5-2.2-5-5z"
          }));
        case 'video':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "video"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            transform: "translate(1 5)",
            id: "Group_15750"
          }, /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15749"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8419",
            d: "M21.5 1.1c-.3-.2-.7-.2-1 0L16 3.4V3c0-1.7-1.3-3-3-3H3C1.3 0 0 1.3 0 3v9c0 1.7 1.3 3 3 3h10c1.7 0 3-1.3 3-3v-.4l4.6 2.3c.5.2 1.1 0 1.3-.4.1-.2.1-.3.1-.5V2c0-.3-.2-.7-.5-.9M14 12c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1V3c0-.6.4-1 1-1h10c.6 0 1 .4 1 1v9zm6-.6l-4-2V5.6l4-2v7.8z"
          }))));
        case 'video-slash':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "video-slash"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            transform: "translate(1 1)",
            id: "Group_15748"
          }, /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_15747"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8417",
            d: "M21.5 5.1c-.3-.2-.7-.2-1 0L16 7.4V7c0-1.7-1.3-3-3-3H9.9c-.6 0-1 .4-1 1s.4 1 1 1H13c.6 0 1 .4 1 1v4c0 .6.4 1 1 1s1-.4 1-1V9.6l4-2V17c0 .6.4 1 1 1s1-.4 1-1V6c0-.3-.2-.7-.5-.9"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_8418",
            d: "M15.7 14.3l-10-10-4-4C1.3-.1.7-.1.3.3c-.4.4-.4 1 0 1.4L2.6 4C1.1 4.2 0 5.5 0 7v9c0 1.7 1.3 3 3 3h10c1.2 0 2.3-.7 2.8-1.8l4.5 4.5c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4l-6-6zM14 16c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1V7c0-.6.4-1 1-1h1.6l9.4 9.4v.6z"
          }))));
        case 'wallet':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "wallet"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4716",
            d: "M20 3H4C2.3 3 1 4.3 1 6v12c0 1.7 1.3 3 3 3h16c1.7 0 3-1.3 3-3V6c0-1.7-1.3-3-3-3zm0 16H4c-.6 0-1-.4-1-1V6c0-.6.4-1 1-1h16c.6 0 1 .4 1 1v2.3h-2c-2 0-3.7 1.6-3.7 3.7 0 2 1.6 3.7 3.7 3.7h2V18c0 .6-.4 1-1 1zm1-5.3h-2c-.9 0-1.7-.7-1.7-1.7 0-.9.7-1.7 1.7-1.7h2v3.4z"
          }));
        case 'warning':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "warning"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10749",
            transform: "translate(-920.5 -505.806)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4511",
            d: "M932.5 506.8c-6.1 0-11 4.9-11 11s4.9 11 11 11 11-4.9 11-11-4.9-11-11-11zm0 20c-5 0-9-4-9-9s4-9 9-9 9 4 9 9-4 9-9 9z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4512",
            d: "M932.5 521.5c-.5 0-.9.4-.9.9s.4.9.9.9.9-.4.9-.9-.4-.9-.9-.9z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4513",
            d: "M932.5 511.8c-.6 0-1 .4-1 1v7c0 .6.4 1 1 1s1-.4 1-1v-7c0-.5-.4-1-1-1z"
          })));
        case 'warning-circle':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "warning-circle"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4668",
            d: "M12 23c6.1 0 11-4.9 11-11S18.1 1 12 1 1 5.9 1 12s4.9 11 11 11zM11 7c0-.6.4-1 1-1s1 .4 1 1v7c0 .6-.4 1-1 1s-1-.4-1-1V7zm1 9c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1z"
          }));
        case 'wheelchair':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
            id: "wheelchair"
          }, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("g", {
            id: "Group_10900",
            transform: "translate(-1262.5 -306.806)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4730",
            d: "M1278.5 324c-.5-.2-1.1.1-1.3.6-.2.5-.5 1-.9 1.5-1.8 2.1-4.9 2.4-7 .6s-2.4-4.9-.6-7c.4-.5.9-.9 1.5-1.2.5-.3.7-.9.4-1.3-.3-.5-.9-.7-1.3-.4-3.4 1.8-4.7 6.1-2.9 9.5 1.8 3.4 6.1 4.7 9.5 2.9 1.5-.8 2.7-2.1 3.3-3.7.1-.8-.2-1.3-.7-1.5z"
          }), /*#__PURE__*/_react.default.createElement("path", {
            id: "Path_4731",
            d: "M1283.4 327.5l-2-6c-.1-.4-.5-.7-.9-.7h-6.1l-.3-2h5.4c.6 0 1-.4 1-1s-.4-1-1-1h-5.6l-.4-3.1c-.1-.5-.5-.9-1.1-.9-.5.1-.9.5-.9 1.1l1 8c.1.5.5.9 1 .9h6.3l1.8 5.3c.2.5.7.8 1.3.6s.7-.7.5-1.2z"
          }), /*#__PURE__*/_react.default.createElement("circle", {
            id: "Ellipse_44",
            cx: "1272.5",
            cy: "309.8",
            r: "2"
          })));
        case 'XAU':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_4901_840)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M22.588 4H1.412C.635 4 0 4.72 0 5.6v12.8c0 .88.635 1.6 1.412 1.6h21.176c.777 0 1.412-.72 1.412-1.6V5.6c0-.88-.635-1.6-1.412-1.6z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M18.473 16.56s-.028.056-.035.088c-.092.424-.403.704-.784.704h-4.242c.07-.216.176-.424.19-.648.043-.472.07-.944-.098-1.408-.255-.688-.487-1.392-.742-2.08-.077-.208-.183-.392-.29-.616.142-.032.29-.096.439-.096 1.186-.008 2.378-.024 3.564 0 .544.008.94.352 1.15.92.27.728.523 1.464.777 2.2.029.08.05.16.07.24v.696zm-1.362-.392c.204 0 .338-.208.275-.432-.17-.608-.353-1.208-.53-1.816-.056-.184-.204-.264-.353-.208-.155.056-.24.224-.183.408.177.608.353 1.216.537 1.824.042.136.134.216.254.224zM11.986 11.856h-2.93c-.472 0-.79-.384-.818-.92-.029-.504.098-.952.268-1.408.19-.512.367-1.024.55-1.536.233-.648.685-.992 1.3-.992h3.324c.572 0 1.045.352 1.264.952.254.704.5 1.416.748 2.128.127.376.106.768.035 1.144a.774.774 0 0 1-.748.64h-2.986l-.007-.008zm1.92-3.664c-.219 0-.346.216-.283.44l.255.864c.091.312.183.632.282.944.056.176.198.256.339.2a.315.315 0 0 0 .19-.392c-.176-.616-.36-1.232-.543-1.84-.043-.144-.134-.216-.247-.224l.007.008zM9.304 17.352h-2.93c-.501 0-.826-.384-.847-.952a2.982 2.982 0 0 1 .198-1.168c.226-.584.416-1.184.628-1.776.219-.616.685-.96 1.263-.968 1.102 0 2.196.008 3.297 0 .65-.008 1.143.424 1.348 1.032.226.688.48 1.36.713 2.048.127.376.106.776.035 1.152a.766.766 0 0 1-.734.624H9.296l.008.008zM12 15.784c-.035-.112-.078-.272-.127-.424-.141-.48-.275-.96-.424-1.432-.056-.192-.204-.272-.36-.216-.155.064-.226.224-.176.408.05.184.106.36.155.544.127.424.247.848.374 1.272.05.16.184.256.31.224.142-.032.234-.16.234-.376H12z",
            fill: "#FFC342"
          })), /*#__PURE__*/_react.default.createElement("rect", {
            x: ".5",
            y: "4.5",
            width: "23",
            height: "15",
            rx: ".5",
            stroke: "#F0F0F0"
          }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_4901_840"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "24",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'XPT':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_27784_1613)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M22.588 4H1.412C.635 4 0 4.72 0 5.6v12.8c0 .88.635 1.6 1.412 1.6h21.176c.777 0 1.412-.72 1.412-1.6V5.6c0-.88-.635-1.6-1.412-1.6z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M18.473 16.56s-.028.056-.035.088c-.092.424-.403.704-.784.704h-4.242c.07-.216.176-.424.19-.648.043-.472.07-.944-.098-1.408-.255-.688-.487-1.392-.742-2.08-.077-.208-.183-.392-.29-.616.142-.032.29-.096.439-.096 1.186-.008 2.378-.024 3.564 0 .544.008.94.352 1.15.92.27.728.523 1.464.777 2.2.029.08.05.16.07.24v.696zm-1.362-.392c.204 0 .338-.208.275-.432-.17-.608-.353-1.208-.53-1.816-.056-.184-.204-.264-.353-.208-.155.056-.24.224-.183.408.177.608.353 1.216.537 1.824.042.136.134.216.254.224zM11.986 11.856h-2.93c-.472 0-.79-.384-.818-.92-.029-.504.098-.952.268-1.408.19-.512.367-1.024.55-1.536.233-.648.685-.992 1.3-.992h3.324c.572 0 1.045.352 1.264.952.254.704.5 1.416.748 2.128.127.376.106.768.035 1.144a.774.774 0 0 1-.748.64h-2.986l-.007-.008zm1.92-3.664c-.219 0-.346.216-.283.44l.255.864c.091.312.183.632.282.944.056.176.198.256.339.2a.315.315 0 0 0 .19-.392c-.176-.616-.36-1.232-.543-1.84-.043-.144-.134-.216-.247-.224l.007.008zM9.304 17.352h-2.93c-.501 0-.826-.384-.847-.952a2.982 2.982 0 0 1 .198-1.168c.226-.584.416-1.184.628-1.776.219-.616.685-.96 1.263-.968 1.102 0 2.196.008 3.297 0 .65-.008 1.143.424 1.348 1.032.226.688.48 1.36.713 2.048.127.376.106.776.035 1.152a.766.766 0 0 1-.734.624H9.296l.008.008zM12 15.784c-.035-.112-.078-.272-.127-.424-.141-.48-.275-.96-.424-1.432-.056-.192-.204-.272-.36-.216-.155.064-.226.224-.176.408.05.184.106.36.155.544.127.424.247.848.374 1.272.05.16.184.256.31.224.142-.032.234-.16.234-.376H12z",
            fill: "#B4B4B4"
          })), /*#__PURE__*/_react.default.createElement("rect", {
            x: ".5",
            y: "4.5",
            width: "23",
            height: "15",
            rx: ".5",
            stroke: "#F0F0F0"
          }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_27784_1613"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "24",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'YER':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip0_27784_1801)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M0 4h24v16H0V4z",
            fill: "#000"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M0 4h24v10.667H0V4z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M0 4h24v5.333H0V4z",
            fill: "#CE1126"
          })), /*#__PURE__*/_react.default.createElement("rect", {
            x: ".5",
            y: "4.5",
            width: "23",
            height: "15",
            rx: ".5",
            stroke: "#F0F0F0"
          }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_27784_1801"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            y: "4",
            width: "24",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
        case 'ykb-alt':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M23.7 9.8c-1.3-3.7-5-3.9-5.4-3.9-1.8 0-3.6.7-4.9 1.9-.5.5-1 1.1-1.4 1.7-.4-.6-.9-1.2-1.4-1.7-1.3-1.3-3.1-2-4.9-1.9-.4 0-4.1.2-5.4 3.9-.5 1.4-.4 3 .3 4.4.7 1.5 2.3 2.7 4.1 2.5 1.4 0 2.6-.9 3.1-2.1.5-1.1.2-2.5-.7-3.4 0 .3 0 .7-.2.9-.4.5-1.1.7-1.7.5-.5-.2-.8-.7-.7-1.2.1-.5.4-.8.8-1 .8-.3 1.5-.2 2.1.5 1.1 1.2 1.2 3.2 1.8 4.6.4 1.2 1 2.2 2.3 2.5h1c1.3-.3 1.9-1.3 2.3-2.5.5-1.4.7-3.3 1.8-4.6.7-.7 1.4-.8 2.1-.5.4.2.7.5.8 1 .1.5-.2 1.1-.7 1.2-.6.2-1.3.1-1.7-.5-.2-.3-.3-.6-.2-.9-.9.9-1.1 2.2-.7 3.4.5 1.2 1.8 2.1 3.1 2.1 1.7.1 3.4-1.1 4.1-2.5.7-1.3.8-2.9.3-4.4zm-2.6 4.5c-.7.7-1.8.9-2.7.5-.5-.2-.9-.7-1-1.1.7.7 2 1.1 3.2-.2 0 0 1.1-1 .5-3-.3-.9-1.5-1.8-2.5-1.8-1.5-.3-3 .3-3.9 1.6-1.1 1.7-1.2 3.7-2.1 5.6-.1.3-.4.5-.7.5-.3 0-.6-.2-.7-.5-.8-1.9-.9-3.9-2.1-5.6C8.3 9 6.8 8.4 5.4 8.7c-1 .1-2.2.9-2.5 1.8-.7 1.9.5 3 .5 3 1.2 1.2 2.5.9 3.2.2-.2.5-.5.9-1 1.1-.9.4-2 .2-2.7-.5-1.1-1-1.4-2.6-.9-4 .6-1.6 2.3-2.5 3.6-2.6 1.6-.1 3.8.8 4.6 2.5.2.4.6 1.4.6 1.4H13s.4-1 .6-1.4c.9-1.6 3.1-2.6 4.6-2.5 1.4.1 3 .9 3.6 2.6.7 1.4.4 3-.7 4z"
          }));
        case 'ZAR':
          return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, rest, {
            height: height || size,
            width: width || size,
            onClick: onClick,
            style: style,
            className: className,
            viewBox: "0 0 24 24",
            fill: "none"
          }), /*#__PURE__*/_react.default.createElement("g", {
            clipPath: "url(#clip1_4901_841)"
          }, /*#__PURE__*/_react.default.createElement("path", {
            d: "M22.588 4H1.412C.632 4 0 4.716 0 5.6v12.793c0 .883.632 1.599 1.412 1.599h21.176c.78 0 1.412-.716 1.412-1.6V5.6C24 4.716 23.368 4 22.588 4z",
            fill: "#000"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M0 5.919V4h2.534c.021.016.035.04.057.048l8.322 6.309c.035.024.085.04.127.04h12.953v3.198H11.06a.305.305 0 0 0-.183.064c-2.76 2.095-5.52 4.182-8.28 6.277-.029.016-.05.04-.07.064H0v-1.927l.882-.664c2.35-1.775 4.694-3.558 7.045-5.341.028-.024.057-.048.092-.08-.043-.032-.07-.056-.099-.08-2.167-1.64-4.334-3.286-6.494-4.925C.946 6.63.473 6.279 0 5.919z",
            fill: "#007B4C"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M4.25 4H24v5.333H11.365a.256.256 0 0 1-.177-.064C9.36 7.886 7.538 6.503 5.711 5.12c-.487-.367-.975-.743-1.462-1.111V4z",
            fill: "#E03629"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M24 14.659v5.333H4.25s.042-.04.063-.056c2.294-1.743 4.588-3.478 6.89-5.221a.255.255 0 0 1 .148-.048H24v-.008z",
            fill: "#001C98"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M0 16.794v-9.58c.021.008.042.016.056.032 2.069 1.568 4.144 3.135 6.212 4.71.014.016.036.032.057.048-2.11 1.6-4.221 3.19-6.325 4.79z",
            fill: "#000"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M4.25 4c.486.368.974.744 1.46 1.111 1.829 1.384 3.657 2.767 5.478 4.15.057.04.106.064.177.064H24v1.064H11.047a.241.241 0 0 1-.127-.04C8.139 8.254 5.365 6.15 2.59 4.048A.174.174 0 0 1 2.535 4H4.25zM24 14.659H11.351a.255.255 0 0 0-.149.048c-2.294 1.743-4.588 3.478-6.89 5.221-.02.016-.041.04-.063.056H2.534s.05-.048.07-.064c2.76-2.095 5.52-4.182 8.28-6.277a.261.261 0 0 1 .184-.064H24v1.08z",
            fill: "#fff"
          }), /*#__PURE__*/_react.default.createElement("path", {
            d: "M0 16.794c2.104-1.6 4.214-3.19 6.325-4.798-.021-.024-.036-.04-.057-.048C4.2 10.381 2.132 8.814.056 7.246.036 7.23.014 7.222 0 7.214V5.92c.473.36.946.712 1.419 1.072 2.167 1.639 4.334 3.286 6.494 4.925.028.024.063.048.099.08a3.521 3.521 0 0 1-.092.08c-2.35 1.783-4.694 3.558-7.045 5.341l-.882.664v-1.28L0 16.795z",
            fill: "#FFB700"
          })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip0_4901_841"
          }, /*#__PURE__*/_react.default.createElement("path", {
            fill: "#fff",
            d: "M0 0h24v24H0z"
          })), /*#__PURE__*/_react.default.createElement("clipPath", {
            id: "clip1_4901_841"
          }, /*#__PURE__*/_react.default.createElement("rect", {
            x: "-.007",
            y: "4",
            width: "24.007",
            height: "16",
            rx: "1",
            fill: "#fff"
          }))));
      }
    }
  }]);
}(_react.Component);
(0, _defineProperty2.default)(Icon, "propTypes", {
  className: _propTypes.default.string,
  height: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  kind: _propTypes.default.oneOf(['AED', 'angle-double-left', 'angle-double-right', 'angle-down', 'angle-down-alt', 'angle-left', 'angle-left-alt', 'angle-right', 'angle-right-alt', 'angle-up', 'angle-up-alt', 'arrow-down', 'arrow-from-left', 'arrow-from-right', 'arrow-left', 'arrow-left-alt', 'arrow-right', 'arrow-right-alt', 'arrow-right-arrow-left', 'arrow-rotate-left', 'arrow-up', 'atm', 'attach', 'AUD', 'avatar', 'AZN', 'bag', 'bank', 'bell', 'bell-alt', 'BGN', 'BHD', 'binoculars', 'birthday-cake', 'book', 'briefcase', 'browser', 'CAD', 'calculator', 'calendar', 'calendar-alt', 'camera', 'camera-alt', 'card', 'caret-left', 'caret-right', 'chain', 'chart', 'chat', 'check', 'check-alt', 'check-circle', 'CHF', 'clipboard', 'clock', 'clock-alt', 'clock-rotate-left', 'clone', 'close', 'close-alt', 'close-circle', 'CNH', 'CNY', 'code', 'code-alt', 'comment-sms', 'compass', 'compress', 'csv', 'cup', 'customer', 'CZK', 'dashboard', 'dashboard-alt', 'desktop', 'dev-avatar', 'divide', 'DKK', 'document-plus', 'documents', 'documents-alt', 'download', 'DZD', 'edit', 'edit-alt', 'ellipsis', 'ellipsis-h', 'ellipsis-v-alt', 'envelope-open', 'error', 'EUR', 'excel', 'exclamation', 'exit', 'expand', 'expand-left', 'expand-right', 'external-link', 'eye', 'eye-alt', 'eye-slash', 'factory', 'file-lines', 'filter', 'filter-close', 'flag', 'flag-solid', 'flexible-alt', 'folder', 'frown', 'GBP', 'gift', 'globe', 'graduation-cap', 'grip-vertical', 'headphones', 'heart', 'heart-f', 'help', 'HKD', 'home', 'home-alt', 'home-f', 'HUF', 'IEP', 'IQD', 'identity', 'inbox', 'info', 'info-circle', 'JOD', 'JPY', 'kiosk', 'KWD', 'KZT', 'lightbulb', 'list', 'lock', 'lock-alt', 'lock-open', 'lock-open-alt', 'lock-open-check', 'loveseat', 'LYD', 'MAD', 'mail', 'mail-alt', 'map-marker-alt', 'mars', 'megaphone-alt', 'meh', 'menu', 'menu-arrow', 'menu-favorites', 'menu-related-actions', 'menu-sik-kullanilanlar', 'menu-tum-islemler', 'menu-yardimci-uygulamalar', 'microphone', 'microphone-slash', 'minus', 'minus-alt', 'mobil', 'money', 'money-bill', 'monitor-share', 'mouse-pointer', 'MYR', 'newspaper-alt', 'NGN', 'NLG', 'no-data', 'NOK', 'office', 'paper', 'paperclip', 'pause', 'pdf', 'phone', 'phone-alt', 'phone-arrow-down-left', 'phone-arrow-up-right', 'phone-emergency-alt', 'phone-hangup', 'phone-pause', 'phone-xmark', 'picture', 'pill-alt', 'pin', 'play', 'play-circle', 'PLN', 'plus', 'plus-alt', 'power-off', 'print', 'profile', 'ptt', 'QAR', 'qrcode', 'question', 'question-comment-alt', 'random-alt', 'rank-alt', 'rates', 'refresh', 'rings-wedding-alt', 'RON', 'roof-alt', 'round', 'round-plus', 'RUB', 'SAR', 'screen', 'search', 'search-alt', 'SEK', 'settings', 'SGD', 'share', 'share-nodes', 'shield', 'shop', 'signature', 'slider-h', 'sliders-h', 'smiley', 'sort', 'sort-alt', 'sort-down', 'sort-up', 'spin', 'star', 'success', 'sun', 'swap-right', 'tachometer-average', 'tachometer-fast', 'tachometer-fastest', 'tachometer-slow', 'thumb-tack', 'thumb-tack-f', 'thumbs-down', 'thumbs-up', 'ticket', 'TR', 'trash', 'trash-alt', 'turn-left', 'upload', 'USD', 'usd-circle', 'user', 'user-alt', 'user-arrow-down', 'user-arrow-up', 'user-f', 'user-friends', 'user-friends-f', 'user-plus', 'users-f', 'venus', 'video', 'video-slash', 'wallet', 'warning', 'warning-circle', 'wheelchair', 'XAU', 'XPT', 'YER', 'ykb-alt', 'ZAR']).isRequired,
  onClick: _propTypes.default.func,
  size: _propTypes.default.number,
  style: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.object])
});
(0, _defineProperty2.default)(Icon, "defaultProps", {
  size: null
});